"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryLinkingCollectionsCategoryCollectionOrder = exports.CategoryLinkingCollectionsBlogPostCollectionOrder = exports.CaseStudyTopicsListCollectionOrder = exports.CaseStudyRelatedCaseStudiesCollectionOrder = exports.CaseStudyPropertyOrder = exports.CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder = exports.CaseStudyOrder = exports.CaseStudyLinkingCollectionsResourceCollectionOrder = exports.CaseStudyLinkingCollectionsCaseStudyCollectionOrder = exports.CaseStudyIndustriesListCollectionOrder = exports.CaseStudyCompetitorsListCollectionOrder = exports.CaseStudyCaseStudyStatsCollectionOrder = exports.BlogPostTagsCollectionOrder = exports.BlogPostOrder = exports.BlogPostLinkingCollectionsResourceCollectionOrder = exports.BlogPostCategoriesCollectionOrder = exports.BasicContentCardOrder = exports.BasicContentCardLinkingCollectionsResourceCollectionOrder = exports.BasicContentCardLinkingCollectionsArticleCollectionOrder = exports.BasicContentCardCtaButtonCollectionOrder = exports.BackgroundOrder = exports.BackgroundLinkingCollectionsHeroCollectionOrder = exports.AssetOrder = exports.AssetInternalOrder = exports.AssetInternalLinkingCollectionsShowcaseCollectionOrder = exports.AssetInternalLinkingCollectionsPressCollectionOrder = exports.AssetInternalLinkingCollectionsHeroCollectionOrder = exports.AssetExternalOrder = exports.AssetExternalLinkingCollectionsShowcaseCollectionOrder = exports.AssetExternalLinkingCollectionsPressCollectionOrder = exports.AssetExternalLinkingCollectionsHeroCollectionOrder = exports.AssetExternalLinkingCollectionsCaseStudyCollectionOrder = exports.ArticleSecondaryCtasCollectionOrder = exports.ArticleOrder = exports.ArticleLinkingCollectionsResourceCollectionOrder = exports.ArticleLinkingCollectionsArticleCollectionOrder = exports.ArticleFaqsCollectionOrder = exports.ArticleAdditionalResourcesOverridesCollectionOrder = exports.AppTierOrder = exports.AppTierLinkingCollectionsMarketplaceAppCollectionOrder = exports.AppFeatureOrder = exports.AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder = exports.AppCollectionOrder = exports.AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder = exports.AppCaseStudyOrder = exports.AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder = exports.AmplitudeExperimentsOrder = exports.AdditionalPersonOptionsRelatedNewsCollectionOrder = exports.AdditionalPersonOptionsOrder = exports.AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder = void 0;
exports.PressOrder = exports.PersonOrder = exports.PersonLinkingCollectionsBlogPostCollectionOrder = exports.PersonLinkingCollectionsArticleCollectionOrder = exports.MarketplaceThemeThemeIndustriesCollectionOrder = exports.MarketplaceThemeOrder = exports.MarketplaceAppOrder = exports.MarketplaceAppCollectionsCollectionOrder = exports.MarketplaceAppCategoriesCollectionOrder = exports.MarketplaceAppCaseStudiesCollectionOrder = exports.MarketplaceAppAppFeaturesCollectionOrder = exports.MarketoFormOrder = exports.KeyValueSetOrder = exports.KeyValueSetKeyValueCollectionOrder = exports.KeyValueOrder = exports.KeyValueLinkingCollectionsResourceCollectionOrder = exports.KeyValueLinkingCollectionsKeyValueSetCollectionOrder = exports.KeyValueLinkingCollectionsCaseStudyCollectionOrder = exports.ImageResizeStrategy = exports.ImageResizeFocus = exports.ImageFormat = exports.HeroOrder = exports.HeroLinkingCollectionsResourceCollectionOrder = exports.HeroLinkingCollectionsCaseStudyCollectionOrder = exports.HeroLinkingCollectionsArticleCollectionOrder = exports.GlossaryOrder = exports.GlossaryCategoryCollectionOrder = exports.GatedContentOrder = exports.GatedContentLinkingCollectionsBlogPostCollectionOrder = exports.FaqItemOrder = exports.FaqItemLinkingCollectionsArticleCollectionOrder = exports.ExternalLinkOrder = exports.ExternalLinkLinkingCollectionsShowcaseCollectionOrder = exports.ExternalLinkLinkingCollectionsPressCollectionOrder = exports.ExternalLinkLinkingCollectionsEventCollectionOrder = exports.ExternalLinkLinkingCollectionsCtaButtonCollectionOrder = exports.ExternalLinkLinkingCollectionsAdditionalPersonOptionsCollectionOrder = exports.EventOrder = exports.EntryOrder = exports.CtaMatPatternOrder = exports.CtaMatPatternLinkingCollectionsBlogPostCollectionOrder = exports.CtaButtonOrder = exports.CtaButtonLinkingCollectionsResourceCollectionOrder = exports.CtaButtonLinkingCollectionsHeroCollectionOrder = exports.CtaButtonLinkingCollectionsBasicContentCardCollectionOrder = exports.CtaButtonLinkingCollectionsArticleCollectionOrder = exports.CategoryOrder = exports.CategoryLinkingCollectionsShowcaseCollectionOrder = exports.CategoryLinkingCollectionsMarketplaceAppCollectionOrder = exports.CategoryLinkingCollectionsGlossaryCollectionOrder = void 0;
exports.ArticleFragmentDoc = exports.ArticleSecondaryCtAsFragmentDoc = exports.ArticleMetaFragmentDoc = exports.SeoMetadataFragmentFragmentDoc = exports.LocalizedArticleSlugFragmentDoc = exports.ArticleStatusFragmentDoc = exports.ArticleInterstitialFragmentDoc = exports.ArticleFaqAccordionsFragmentDoc = exports.ArticleFeedCarouselFragmentDoc = exports.ArticleImageFragmentDoc = exports.ImageAssetFragmentDoc = exports.ArticleRichTextFragmentDoc = exports.ArticleBodyLinksFragmentDoc = exports.BasicContentCardFragmentDoc = exports.ArticleExternalLinkFragmentDoc = exports.ArticleAssetExternalFragmentDoc = exports.RichTextCalloutFragmentDoc = exports.ArticleAssetFragmentDoc = exports.ArticleBreadcrumbsFragmentDoc = exports.TypeFragmentDoc = exports.__TypeKind = exports.ThemePropertyOrder = exports.ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder = exports.TagOrder = exports.TagLinkingCollectionsBlogPostCollectionOrder = exports.SpeakerCardOrder = exports.SpeakerCardLinkingCollectionsResourceCollectionOrder = exports.ShowcaseOrder = exports.ShowcaseCategoryCollectionOrder = exports.SeoMetadataOrder = exports.SeoMetadataLinkingCollectionsThemePropertyCollectionOrder = exports.SeoMetadataLinkingCollectionsResourceCollectionOrder = exports.SeoMetadataLinkingCollectionsPressCollectionOrder = exports.SeoMetadataLinkingCollectionsPersonCollectionOrder = exports.SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder = exports.SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder = exports.SeoMetadataLinkingCollectionsGlossaryCollectionOrder = exports.SeoMetadataLinkingCollectionsCategoryCollectionOrder = exports.SeoMetadataLinkingCollectionsCaseStudyCollectionOrder = exports.SeoMetadataLinkingCollectionsBlogPostCollectionOrder = exports.SeoMetadataLinkingCollectionsArticleCollectionOrder = exports.SeoMetadataLinkingCollectionsAppTierCollectionOrder = exports.SeoMetadataLinkingCollectionsAppCollectionCollectionOrder = exports.RobotsOrder = exports.RichTextWrapperOrder = exports.ResourceStatsCollectionOrder = exports.ResourceSpeakersCollectionOrder = exports.ResourceOrder = exports.ResourceLinkingCollectionsResourceCollectionOrder = exports.RedirectOrder = void 0;
exports.ThemeRichTextFragmentDoc = exports.ThemeImageFragmentDoc = exports.AppTierFragmentDoc = exports.AppTierImageFragmentDoc = exports.AppTierTextFragmentDoc = exports.AppMetaFragmentFragmentDoc = exports.AppCollectionFragmentDoc = exports.AppCollectionTextFragmentDoc = exports.AppCollectionImageFragmentDoc = exports.AppInformationFragmentDoc = exports.AppFragmentDoc = exports.AppRichTextFragmentDoc = exports.GlossaryCategoryFragmentDoc = exports.GlossaryCategorySlugsFragmentDoc = exports.GlossaryFragmentDoc = exports.GlossaryMetaFragmentDoc = exports.GlossaryImageFragmentDoc = exports.GlossaryRichTextFragmentDoc = exports.GlossaryAssetFragmentDoc = exports.GlossaryTextFragmentDoc = exports.CategoryFragmentDoc = exports.CategoryRichTextFragmentDoc = exports.CategoryMetaFragmentDoc = exports.CaseStudyFragmentDoc = exports.CaseStudyRelatedCaseStudiesFragmentDoc = exports.CaseStudyCategoriesFragmentDoc = exports.CaseStudyHeroFragmentDoc = exports.CaseStudyMetaFragmentDoc = exports.CaseStudyVideoFragmentDoc = exports.CaseStudyImageFragmentDoc = exports.CaseStudyStatsFragmentDoc = exports.CaseStudyRichTextFragmentDoc = exports.AssetFragmentDoc = exports.CaseStudyTextFragmentDoc = exports.CaseStudyButtonFragmentDoc = exports.BlogPostFragmentDoc = exports.BlogPostTextFragmentDoc = exports.BlogPostButtonFragmentDoc = exports.BlogPostImageFragmentDoc = exports.BlogPostRichTextFragmentDoc = exports.BlogPostBodyLinksFragmentDoc = exports.BlogPostAssetExternalFragmentDoc = exports.BlogPostAssetFragmentDoc = exports.BlogPostPdfDownloadFragmentDoc = exports.BlogPostMetaFragmentDoc = exports.BlogPostCategoriesFragmentDoc = exports.BlogPostBreadcrumbsFragmentDoc = exports.CategoryBreadcrumbsFragmentDoc = exports.ArticleTextFragmentDoc = exports.ArticleChildrenCarouselFragmentDoc = void 0;
exports.BlogPostsDocument = exports.LocalizedParentArticlesDocument = exports.ArticleFeedCarouselDocument = exports.ArticleChildrenCarouselDocument = exports.ArticleChildFeedGridDocument = exports.ArticlesDocument = exports.TypesDocument = exports.ArticleSlugFragmentDoc = exports.ThemeSitemapFragmentDoc = exports.ThemeIndustryFragmentDoc = exports.ResourcesSitemapFragmentDoc = exports.PressSitemapFragmentDoc = exports.GlossarySitemapFragmentDoc = exports.CategoriesSitemapFragmentDoc = exports.CaseStudySitemapFragmentDoc = exports.BlogPostSitemapFragmentDoc = exports.BlogPostCategoriesSitemapFragmentDoc = exports.BlogPostAuthorsFragmentDoc = exports.ArticleSitemapFragmentDoc = exports.AppSitemapFragmentDoc = exports.AppCollectionSitemapFragmentDoc = exports.AlgoliaMarketplaceThemeFragmentDoc = exports.AlgoliaMarketplaceAppFragmentDoc = exports.AlgoliaBlogPostFragmentDoc = exports.ShowcaseCategoryFragmentDoc = exports.ShowcaseCategorySlugsFragmentDoc = exports.ShowcaseItemFragmentDoc = exports.ResourceFragmentDoc = exports.ResourceSpeakersFragmentDoc = exports.ResourceRecommendedFeedFragmentDoc = exports.ResourceHeroFragmentDoc = exports.HeroSubheadingLinkFragmentDoc = exports.AssetExternalFragmentDoc = exports.ResourceSlugFragmentDoc = exports.PressFragmentDoc = exports.PressPostMetaFragmentDoc = exports.PressEnabledFragmentDoc = exports.PressSlugFragmentDoc = exports.PressDateFragmentDoc = exports.PressTextFragmentDoc = exports.PressRichTextFragmentDoc = exports.PressAssetFragmentDoc = exports.PersonFragmentDoc = exports.PersonImageFragmentDoc = exports.PersonRelatedNewsFragmentDoc = exports.PersonMetaFragmentDoc = exports.PersonRichTextFragmentDoc = exports.PersonTextFragmentDoc = exports.ThemesPropertyFragmentDoc = exports.ThemeInformationFragmentDoc = void 0;
exports.AppCollectionSitemapDocument = exports.RobotsDocument = exports.BlogContentForPdfDocument = exports.BlogPostPathsDocument = exports.AlgoliaMarketplaceThemeByIdDocument = exports.AlgoliaMarketplaceThemesDocument = exports.AlgoliaMarketplaceAppByIdDocument = exports.AlgoliaMarketplaceAppsDocument = exports.AlgoliaBlogPostByIdDocument = exports.AlgoliaBlogPostsDocument = exports.ShowcaseCategoriesDocument = exports.ShowcaseFeedDocument = exports.ResourceFeedDocument = exports.ResourceDocument = exports.PressFeedDocument = exports.PressDocument = exports.PersonFeedPriorityDocument = exports.PersonFeedDocument = exports.PersonsDocument = exports.ThemesListDocument = exports.ThemesCollectionsDocument = exports.ThemeRelatedStyleDocument = exports.ThemesInformationDocument = exports.AppsRecommendedDocument = exports.AppTierAppGridDocument = exports.AppTierDocument = exports.AppRowCardsDocument = exports.AppRowDocument = exports.AppMetaDocument = exports.AppCollectionListDocument = exports.AppCollectionCarouselPriorityDocument = exports.AppCollectionCarouselDocument = exports.AppCollectionDocument = exports.AppCategoriesDocument = exports.AppCarouselDocument = exports.AppInformationDocument = exports.GlossaryCategoriesDocument = exports.GlossaryFeedDocument = exports.GlossaryDocument = exports.FeaturedLogoCarouselDocument = exports.FeaturedContentBlockDocument = exports.EventFeedDocument = exports.CategoriesDocument = exports.CaseStudySlugsDocument = exports.CaseStudyPropertyDocument = exports.CaseStudyFeedDocument = exports.CaseStudiesDocument = exports.BlogPostFeedCategoriesDocument = exports.BlogPostFeedPersonsDocument = exports.BlogPostFeedDocument = void 0;
exports.RedirectsDocument = exports.ArticlePreviewDocument = exports.BlogPostPreviewDocument = exports.ThemesSitemapDocument = exports.ThemeIndustriesSitemapDocument = exports.RootSitemapDocument = exports.ResourcesSitemapDocument = exports.PressSitemapDocument = exports.LeadersSitemapDocument = exports.GlossarySitemapDocument = exports.CategoriesSitemapDocument = exports.CaseStudySitemapDocument = exports.BlogPostsSitemapDocument = exports.BlogPostCategoriesSitemapDocument = exports.BlogPostAuthorsSitemapDocument = exports.ArticlesSitemapDocument = exports.AppsSitemapDocument = void 0;
var AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder;
(function (AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder) {
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["EmailAsc"] = "email_ASC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["EmailDesc"] = "email_DESC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["EnabledAsc"] = "enabled_ASC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["EnabledDesc"] = "enabled_DESC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["FullNameAsc"] = "fullName_ASC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["FullNameDesc"] = "fullName_DESC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["JobTitleAsc"] = "jobTitle_ASC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["JobTitleDesc"] = "jobTitle_DESC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["LinkedUrlAsc"] = "linkedUrl_ASC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["LinkedUrlDesc"] = "linkedUrl_DESC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["SlugAsc"] = "slug_ASC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["SlugDesc"] = "slug_DESC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["TypeAsc"] = "type_ASC";
    AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder["TypeDesc"] = "type_DESC";
})(AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder || (exports.AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder = AdditionalPersonOptionsLinkingCollectionsPersonCollectionOrder = {}));
var AdditionalPersonOptionsOrder;
(function (AdditionalPersonOptionsOrder) {
    AdditionalPersonOptionsOrder["InternalNameAsc"] = "internalName_ASC";
    AdditionalPersonOptionsOrder["InternalNameDesc"] = "internalName_DESC";
    AdditionalPersonOptionsOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AdditionalPersonOptionsOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AdditionalPersonOptionsOrder["SysIdAsc"] = "sys_id_ASC";
    AdditionalPersonOptionsOrder["SysIdDesc"] = "sys_id_DESC";
    AdditionalPersonOptionsOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AdditionalPersonOptionsOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AdditionalPersonOptionsOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AdditionalPersonOptionsOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(AdditionalPersonOptionsOrder || (exports.AdditionalPersonOptionsOrder = AdditionalPersonOptionsOrder = {}));
var AdditionalPersonOptionsRelatedNewsCollectionOrder;
(function (AdditionalPersonOptionsRelatedNewsCollectionOrder) {
    AdditionalPersonOptionsRelatedNewsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    AdditionalPersonOptionsRelatedNewsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    AdditionalPersonOptionsRelatedNewsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AdditionalPersonOptionsRelatedNewsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AdditionalPersonOptionsRelatedNewsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AdditionalPersonOptionsRelatedNewsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AdditionalPersonOptionsRelatedNewsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AdditionalPersonOptionsRelatedNewsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AdditionalPersonOptionsRelatedNewsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AdditionalPersonOptionsRelatedNewsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AdditionalPersonOptionsRelatedNewsCollectionOrder["UrlAsc"] = "url_ASC";
    AdditionalPersonOptionsRelatedNewsCollectionOrder["UrlDesc"] = "url_DESC";
})(AdditionalPersonOptionsRelatedNewsCollectionOrder || (exports.AdditionalPersonOptionsRelatedNewsCollectionOrder = AdditionalPersonOptionsRelatedNewsCollectionOrder = {}));
var AmplitudeExperimentsOrder;
(function (AmplitudeExperimentsOrder) {
    AmplitudeExperimentsOrder["ExperimentFlagAsc"] = "experimentFlag_ASC";
    AmplitudeExperimentsOrder["ExperimentFlagDesc"] = "experimentFlag_DESC";
    AmplitudeExperimentsOrder["LocaleAsc"] = "locale_ASC";
    AmplitudeExperimentsOrder["LocaleDesc"] = "locale_DESC";
    AmplitudeExperimentsOrder["PathnameAsc"] = "pathname_ASC";
    AmplitudeExperimentsOrder["PathnameDesc"] = "pathname_DESC";
    AmplitudeExperimentsOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AmplitudeExperimentsOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AmplitudeExperimentsOrder["SysIdAsc"] = "sys_id_ASC";
    AmplitudeExperimentsOrder["SysIdDesc"] = "sys_id_DESC";
    AmplitudeExperimentsOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AmplitudeExperimentsOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AmplitudeExperimentsOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AmplitudeExperimentsOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(AmplitudeExperimentsOrder || (exports.AmplitudeExperimentsOrder = AmplitudeExperimentsOrder = {}));
var AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder;
(function (AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder) {
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["AlternativeLogoAsc"] = "alternativeLogo_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["AlternativeLogoDesc"] = "alternativeLogo_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryIdAsc"] = "appRegistryId_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryIdDesc"] = "appRegistryId_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryUpdatedAtAsc"] = "appRegistryUpdatedAt_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryUpdatedAtDesc"] = "appRegistryUpdatedAt_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["ApprovedAtAsc"] = "approvedAt_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["ApprovedAtDesc"] = "approvedAt_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["AutomatedBillingAsc"] = "automatedBilling_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["AutomatedBillingDesc"] = "automatedBilling_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["CreatedOnAsc"] = "createdOn_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["CreatedOnDesc"] = "createdOn_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedAsc"] = "featured_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedDesc"] = "featured_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDaysAsc"] = "freeTrialDays_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDaysDesc"] = "freeTrialDays_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialAsc"] = "freeTrial_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDesc"] = "freeTrial_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["InstallationGuideUrlAsc"] = "installationGuideUrl_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["InstallationGuideUrlDesc"] = "installationGuideUrl_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["LastHashAsc"] = "lastHash_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["LastHashDesc"] = "lastHash_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["LogoIconAsc"] = "logoIcon_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["LogoIconDesc"] = "logoIcon_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["LogoAsc"] = "logo_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["LogoDesc"] = "logo_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["MonthlyPriceAsc"] = "monthlyPrice_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["MonthlyPriceDesc"] = "monthlyPrice_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["MultiLocationAsc"] = "multiLocation_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["MultiLocationDesc"] = "multiLocation_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["MultiStorefrontAsc"] = "multiStorefront_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["MultiStorefrontDesc"] = "multiStorefront_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["NameAsc"] = "name_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["NameDesc"] = "name_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["PricingTypeAsc"] = "pricingType_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["PricingTypeDesc"] = "pricingType_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["PricingAsc"] = "pricing_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["PricingDesc"] = "pricing_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["RankAsc"] = "rank_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["RankDesc"] = "rank_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["RatingAsc"] = "rating_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["RatingDesc"] = "rating_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedOrderAsc"] = "recommendedOrder_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedOrderDesc"] = "recommendedOrder_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedAsc"] = "recommended_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedDesc"] = "recommended_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["ReviewCountAsc"] = "reviewCount_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["ReviewCountDesc"] = "reviewCount_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["SingleClickAsc"] = "singleClick_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["SingleClickDesc"] = "singleClick_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["SlugAsc"] = "slug_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["SlugDesc"] = "slug_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["SupportEmailAsc"] = "supportEmail_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["SupportEmailDesc"] = "supportEmail_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["SupportUrlAsc"] = "supportUrl_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["SupportUrlDesc"] = "supportUrl_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["TypeAsc"] = "type_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["TypeDesc"] = "type_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["UnifiedBillingAsc"] = "unifiedBilling_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["UnifiedBillingDesc"] = "unifiedBilling_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["UpfrontPriceAsc"] = "upfrontPrice_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["UpfrontPriceDesc"] = "upfrontPrice_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["UserGuideUrlAsc"] = "userGuideUrl_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["UserGuideUrlDesc"] = "userGuideUrl_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["VersionAsc"] = "version_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["VersionDesc"] = "version_DESC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["WebsiteAsc"] = "website_ASC";
    AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder["WebsiteDesc"] = "website_DESC";
})(AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder || (exports.AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder = AppCaseStudyLinkingCollectionsMarketplaceAppCollectionOrder = {}));
var AppCaseStudyOrder;
(function (AppCaseStudyOrder) {
    AppCaseStudyOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AppCaseStudyOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AppCaseStudyOrder["SysIdAsc"] = "sys_id_ASC";
    AppCaseStudyOrder["SysIdDesc"] = "sys_id_DESC";
    AppCaseStudyOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AppCaseStudyOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AppCaseStudyOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AppCaseStudyOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AppCaseStudyOrder["TitleAsc"] = "title_ASC";
    AppCaseStudyOrder["TitleDesc"] = "title_DESC";
    AppCaseStudyOrder["UrlAsc"] = "url_ASC";
    AppCaseStudyOrder["UrlDesc"] = "url_DESC";
})(AppCaseStudyOrder || (exports.AppCaseStudyOrder = AppCaseStudyOrder = {}));
var AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder;
(function (AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder) {
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["AlternativeLogoAsc"] = "alternativeLogo_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["AlternativeLogoDesc"] = "alternativeLogo_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryIdAsc"] = "appRegistryId_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryIdDesc"] = "appRegistryId_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryUpdatedAtAsc"] = "appRegistryUpdatedAt_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryUpdatedAtDesc"] = "appRegistryUpdatedAt_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["ApprovedAtAsc"] = "approvedAt_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["ApprovedAtDesc"] = "approvedAt_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["AutomatedBillingAsc"] = "automatedBilling_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["AutomatedBillingDesc"] = "automatedBilling_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["CreatedOnAsc"] = "createdOn_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["CreatedOnDesc"] = "createdOn_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedAsc"] = "featured_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedDesc"] = "featured_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDaysAsc"] = "freeTrialDays_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDaysDesc"] = "freeTrialDays_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialAsc"] = "freeTrial_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDesc"] = "freeTrial_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["InstallationGuideUrlAsc"] = "installationGuideUrl_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["InstallationGuideUrlDesc"] = "installationGuideUrl_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["LastHashAsc"] = "lastHash_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["LastHashDesc"] = "lastHash_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["LogoIconAsc"] = "logoIcon_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["LogoIconDesc"] = "logoIcon_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["LogoAsc"] = "logo_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["LogoDesc"] = "logo_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["MonthlyPriceAsc"] = "monthlyPrice_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["MonthlyPriceDesc"] = "monthlyPrice_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["MultiLocationAsc"] = "multiLocation_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["MultiLocationDesc"] = "multiLocation_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["MultiStorefrontAsc"] = "multiStorefront_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["MultiStorefrontDesc"] = "multiStorefront_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["NameAsc"] = "name_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["NameDesc"] = "name_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["PricingTypeAsc"] = "pricingType_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["PricingTypeDesc"] = "pricingType_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["PricingAsc"] = "pricing_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["PricingDesc"] = "pricing_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["RankAsc"] = "rank_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["RankDesc"] = "rank_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["RatingAsc"] = "rating_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["RatingDesc"] = "rating_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedOrderAsc"] = "recommendedOrder_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedOrderDesc"] = "recommendedOrder_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedAsc"] = "recommended_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedDesc"] = "recommended_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["ReviewCountAsc"] = "reviewCount_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["ReviewCountDesc"] = "reviewCount_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["SingleClickAsc"] = "singleClick_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["SingleClickDesc"] = "singleClick_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["SlugAsc"] = "slug_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["SlugDesc"] = "slug_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["SupportEmailAsc"] = "supportEmail_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["SupportEmailDesc"] = "supportEmail_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["SupportUrlAsc"] = "supportUrl_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["SupportUrlDesc"] = "supportUrl_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["TypeAsc"] = "type_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["TypeDesc"] = "type_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["UnifiedBillingAsc"] = "unifiedBilling_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["UnifiedBillingDesc"] = "unifiedBilling_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["UpfrontPriceAsc"] = "upfrontPrice_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["UpfrontPriceDesc"] = "upfrontPrice_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["UserGuideUrlAsc"] = "userGuideUrl_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["UserGuideUrlDesc"] = "userGuideUrl_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["VersionAsc"] = "version_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["VersionDesc"] = "version_DESC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["WebsiteAsc"] = "website_ASC";
    AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder["WebsiteDesc"] = "website_DESC";
})(AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder || (exports.AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder = AppCollectionLinkingCollectionsMarketplaceAppCollectionOrder = {}));
var AppCollectionOrder;
(function (AppCollectionOrder) {
    AppCollectionOrder["NameAsc"] = "name_ASC";
    AppCollectionOrder["NameDesc"] = "name_DESC";
    AppCollectionOrder["PrivateAsc"] = "private_ASC";
    AppCollectionOrder["PrivateDesc"] = "private_DESC";
    AppCollectionOrder["SlugAsc"] = "slug_ASC";
    AppCollectionOrder["SlugDesc"] = "slug_DESC";
    AppCollectionOrder["SortAsc"] = "sort_ASC";
    AppCollectionOrder["SortDesc"] = "sort_DESC";
    AppCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AppCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AppCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AppCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AppCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AppCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AppCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AppCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AppCollectionOrder["ThumbnailAsc"] = "thumbnail_ASC";
    AppCollectionOrder["ThumbnailDesc"] = "thumbnail_DESC";
})(AppCollectionOrder || (exports.AppCollectionOrder = AppCollectionOrder = {}));
var AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder;
(function (AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder) {
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["AlternativeLogoAsc"] = "alternativeLogo_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["AlternativeLogoDesc"] = "alternativeLogo_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryIdAsc"] = "appRegistryId_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryIdDesc"] = "appRegistryId_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryUpdatedAtAsc"] = "appRegistryUpdatedAt_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryUpdatedAtDesc"] = "appRegistryUpdatedAt_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["ApprovedAtAsc"] = "approvedAt_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["ApprovedAtDesc"] = "approvedAt_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["AutomatedBillingAsc"] = "automatedBilling_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["AutomatedBillingDesc"] = "automatedBilling_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["CreatedOnAsc"] = "createdOn_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["CreatedOnDesc"] = "createdOn_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedAsc"] = "featured_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedDesc"] = "featured_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDaysAsc"] = "freeTrialDays_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDaysDesc"] = "freeTrialDays_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialAsc"] = "freeTrial_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDesc"] = "freeTrial_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["InstallationGuideUrlAsc"] = "installationGuideUrl_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["InstallationGuideUrlDesc"] = "installationGuideUrl_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["LastHashAsc"] = "lastHash_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["LastHashDesc"] = "lastHash_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["LogoIconAsc"] = "logoIcon_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["LogoIconDesc"] = "logoIcon_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["LogoAsc"] = "logo_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["LogoDesc"] = "logo_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["MonthlyPriceAsc"] = "monthlyPrice_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["MonthlyPriceDesc"] = "monthlyPrice_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["MultiLocationAsc"] = "multiLocation_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["MultiLocationDesc"] = "multiLocation_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["MultiStorefrontAsc"] = "multiStorefront_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["MultiStorefrontDesc"] = "multiStorefront_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["NameAsc"] = "name_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["NameDesc"] = "name_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["PricingTypeAsc"] = "pricingType_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["PricingTypeDesc"] = "pricingType_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["PricingAsc"] = "pricing_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["PricingDesc"] = "pricing_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["RankAsc"] = "rank_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["RankDesc"] = "rank_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["RatingAsc"] = "rating_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["RatingDesc"] = "rating_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedOrderAsc"] = "recommendedOrder_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedOrderDesc"] = "recommendedOrder_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedAsc"] = "recommended_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedDesc"] = "recommended_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["ReviewCountAsc"] = "reviewCount_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["ReviewCountDesc"] = "reviewCount_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["SingleClickAsc"] = "singleClick_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["SingleClickDesc"] = "singleClick_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["SlugAsc"] = "slug_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["SlugDesc"] = "slug_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["SupportEmailAsc"] = "supportEmail_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["SupportEmailDesc"] = "supportEmail_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["SupportUrlAsc"] = "supportUrl_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["SupportUrlDesc"] = "supportUrl_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["TypeAsc"] = "type_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["TypeDesc"] = "type_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["UnifiedBillingAsc"] = "unifiedBilling_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["UnifiedBillingDesc"] = "unifiedBilling_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["UpfrontPriceAsc"] = "upfrontPrice_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["UpfrontPriceDesc"] = "upfrontPrice_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["UserGuideUrlAsc"] = "userGuideUrl_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["UserGuideUrlDesc"] = "userGuideUrl_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["VersionAsc"] = "version_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["VersionDesc"] = "version_DESC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["WebsiteAsc"] = "website_ASC";
    AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder["WebsiteDesc"] = "website_DESC";
})(AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder || (exports.AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder = AppFeatureLinkingCollectionsMarketplaceAppCollectionOrder = {}));
var AppFeatureOrder;
(function (AppFeatureOrder) {
    AppFeatureOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AppFeatureOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AppFeatureOrder["SysIdAsc"] = "sys_id_ASC";
    AppFeatureOrder["SysIdDesc"] = "sys_id_DESC";
    AppFeatureOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AppFeatureOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AppFeatureOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AppFeatureOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AppFeatureOrder["TitleAsc"] = "title_ASC";
    AppFeatureOrder["TitleDesc"] = "title_DESC";
})(AppFeatureOrder || (exports.AppFeatureOrder = AppFeatureOrder = {}));
var AppTierLinkingCollectionsMarketplaceAppCollectionOrder;
(function (AppTierLinkingCollectionsMarketplaceAppCollectionOrder) {
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["AlternativeLogoAsc"] = "alternativeLogo_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["AlternativeLogoDesc"] = "alternativeLogo_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryIdAsc"] = "appRegistryId_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryIdDesc"] = "appRegistryId_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryUpdatedAtAsc"] = "appRegistryUpdatedAt_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryUpdatedAtDesc"] = "appRegistryUpdatedAt_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["ApprovedAtAsc"] = "approvedAt_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["ApprovedAtDesc"] = "approvedAt_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["AutomatedBillingAsc"] = "automatedBilling_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["AutomatedBillingDesc"] = "automatedBilling_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["CreatedOnAsc"] = "createdOn_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["CreatedOnDesc"] = "createdOn_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedAsc"] = "featured_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedDesc"] = "featured_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDaysAsc"] = "freeTrialDays_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDaysDesc"] = "freeTrialDays_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialAsc"] = "freeTrial_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDesc"] = "freeTrial_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["InstallationGuideUrlAsc"] = "installationGuideUrl_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["InstallationGuideUrlDesc"] = "installationGuideUrl_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["LastHashAsc"] = "lastHash_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["LastHashDesc"] = "lastHash_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["LogoIconAsc"] = "logoIcon_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["LogoIconDesc"] = "logoIcon_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["LogoAsc"] = "logo_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["LogoDesc"] = "logo_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["MonthlyPriceAsc"] = "monthlyPrice_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["MonthlyPriceDesc"] = "monthlyPrice_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["MultiLocationAsc"] = "multiLocation_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["MultiLocationDesc"] = "multiLocation_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["MultiStorefrontAsc"] = "multiStorefront_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["MultiStorefrontDesc"] = "multiStorefront_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["NameAsc"] = "name_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["NameDesc"] = "name_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["PricingTypeAsc"] = "pricingType_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["PricingTypeDesc"] = "pricingType_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["PricingAsc"] = "pricing_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["PricingDesc"] = "pricing_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["RankAsc"] = "rank_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["RankDesc"] = "rank_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["RatingAsc"] = "rating_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["RatingDesc"] = "rating_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedOrderAsc"] = "recommendedOrder_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedOrderDesc"] = "recommendedOrder_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedAsc"] = "recommended_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedDesc"] = "recommended_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["ReviewCountAsc"] = "reviewCount_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["ReviewCountDesc"] = "reviewCount_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["SingleClickAsc"] = "singleClick_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["SingleClickDesc"] = "singleClick_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["SlugAsc"] = "slug_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["SlugDesc"] = "slug_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["SupportEmailAsc"] = "supportEmail_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["SupportEmailDesc"] = "supportEmail_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["SupportUrlAsc"] = "supportUrl_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["SupportUrlDesc"] = "supportUrl_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["TypeAsc"] = "type_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["TypeDesc"] = "type_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["UnifiedBillingAsc"] = "unifiedBilling_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["UnifiedBillingDesc"] = "unifiedBilling_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["UpfrontPriceAsc"] = "upfrontPrice_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["UpfrontPriceDesc"] = "upfrontPrice_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["UserGuideUrlAsc"] = "userGuideUrl_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["UserGuideUrlDesc"] = "userGuideUrl_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["VersionAsc"] = "version_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["VersionDesc"] = "version_DESC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["WebsiteAsc"] = "website_ASC";
    AppTierLinkingCollectionsMarketplaceAppCollectionOrder["WebsiteDesc"] = "website_DESC";
})(AppTierLinkingCollectionsMarketplaceAppCollectionOrder || (exports.AppTierLinkingCollectionsMarketplaceAppCollectionOrder = AppTierLinkingCollectionsMarketplaceAppCollectionOrder = {}));
var AppTierOrder;
(function (AppTierOrder) {
    AppTierOrder["NameAsc"] = "name_ASC";
    AppTierOrder["NameDesc"] = "name_DESC";
    AppTierOrder["SlugAsc"] = "slug_ASC";
    AppTierOrder["SlugDesc"] = "slug_DESC";
    AppTierOrder["SortAsc"] = "sort_ASC";
    AppTierOrder["SortDesc"] = "sort_DESC";
    AppTierOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AppTierOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AppTierOrder["SysIdAsc"] = "sys_id_ASC";
    AppTierOrder["SysIdDesc"] = "sys_id_DESC";
    AppTierOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AppTierOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AppTierOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AppTierOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(AppTierOrder || (exports.AppTierOrder = AppTierOrder = {}));
var ArticleAdditionalResourcesOverridesCollectionOrder;
(function (ArticleAdditionalResourcesOverridesCollectionOrder) {
    ArticleAdditionalResourcesOverridesCollectionOrder["EditStatusAsc"] = "editStatus_ASC";
    ArticleAdditionalResourcesOverridesCollectionOrder["EditStatusDesc"] = "editStatus_DESC";
    ArticleAdditionalResourcesOverridesCollectionOrder["FaqsHeadingAsc"] = "faqsHeading_ASC";
    ArticleAdditionalResourcesOverridesCollectionOrder["FaqsHeadingDesc"] = "faqsHeading_DESC";
    ArticleAdditionalResourcesOverridesCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ArticleAdditionalResourcesOverridesCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ArticleAdditionalResourcesOverridesCollectionOrder["InterstitialHeadlineAsc"] = "interstitialHeadline_ASC";
    ArticleAdditionalResourcesOverridesCollectionOrder["InterstitialHeadlineDesc"] = "interstitialHeadline_DESC";
    ArticleAdditionalResourcesOverridesCollectionOrder["PopularAsc"] = "popular_ASC";
    ArticleAdditionalResourcesOverridesCollectionOrder["PopularDesc"] = "popular_DESC";
    ArticleAdditionalResourcesOverridesCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    ArticleAdditionalResourcesOverridesCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    ArticleAdditionalResourcesOverridesCollectionOrder["SlugAsc"] = "slug_ASC";
    ArticleAdditionalResourcesOverridesCollectionOrder["SlugDesc"] = "slug_DESC";
    ArticleAdditionalResourcesOverridesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticleAdditionalResourcesOverridesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticleAdditionalResourcesOverridesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ArticleAdditionalResourcesOverridesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ArticleAdditionalResourcesOverridesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticleAdditionalResourcesOverridesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticleAdditionalResourcesOverridesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticleAdditionalResourcesOverridesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ArticleAdditionalResourcesOverridesCollectionOrder["TitleAsc"] = "title_ASC";
    ArticleAdditionalResourcesOverridesCollectionOrder["TitleDesc"] = "title_DESC";
})(ArticleAdditionalResourcesOverridesCollectionOrder || (exports.ArticleAdditionalResourcesOverridesCollectionOrder = ArticleAdditionalResourcesOverridesCollectionOrder = {}));
var ArticleFaqsCollectionOrder;
(function (ArticleFaqsCollectionOrder) {
    ArticleFaqsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticleFaqsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticleFaqsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ArticleFaqsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ArticleFaqsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticleFaqsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticleFaqsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticleFaqsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ArticleFaqsCollectionOrder || (exports.ArticleFaqsCollectionOrder = ArticleFaqsCollectionOrder = {}));
var ArticleLinkingCollectionsArticleCollectionOrder;
(function (ArticleLinkingCollectionsArticleCollectionOrder) {
    ArticleLinkingCollectionsArticleCollectionOrder["EditStatusAsc"] = "editStatus_ASC";
    ArticleLinkingCollectionsArticleCollectionOrder["EditStatusDesc"] = "editStatus_DESC";
    ArticleLinkingCollectionsArticleCollectionOrder["FaqsHeadingAsc"] = "faqsHeading_ASC";
    ArticleLinkingCollectionsArticleCollectionOrder["FaqsHeadingDesc"] = "faqsHeading_DESC";
    ArticleLinkingCollectionsArticleCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ArticleLinkingCollectionsArticleCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ArticleLinkingCollectionsArticleCollectionOrder["InterstitialHeadlineAsc"] = "interstitialHeadline_ASC";
    ArticleLinkingCollectionsArticleCollectionOrder["InterstitialHeadlineDesc"] = "interstitialHeadline_DESC";
    ArticleLinkingCollectionsArticleCollectionOrder["PopularAsc"] = "popular_ASC";
    ArticleLinkingCollectionsArticleCollectionOrder["PopularDesc"] = "popular_DESC";
    ArticleLinkingCollectionsArticleCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    ArticleLinkingCollectionsArticleCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    ArticleLinkingCollectionsArticleCollectionOrder["SlugAsc"] = "slug_ASC";
    ArticleLinkingCollectionsArticleCollectionOrder["SlugDesc"] = "slug_DESC";
    ArticleLinkingCollectionsArticleCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticleLinkingCollectionsArticleCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticleLinkingCollectionsArticleCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ArticleLinkingCollectionsArticleCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ArticleLinkingCollectionsArticleCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticleLinkingCollectionsArticleCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticleLinkingCollectionsArticleCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticleLinkingCollectionsArticleCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ArticleLinkingCollectionsArticleCollectionOrder["TitleAsc"] = "title_ASC";
    ArticleLinkingCollectionsArticleCollectionOrder["TitleDesc"] = "title_DESC";
})(ArticleLinkingCollectionsArticleCollectionOrder || (exports.ArticleLinkingCollectionsArticleCollectionOrder = ArticleLinkingCollectionsArticleCollectionOrder = {}));
var ArticleLinkingCollectionsResourceCollectionOrder;
(function (ArticleLinkingCollectionsResourceCollectionOrder) {
    ArticleLinkingCollectionsResourceCollectionOrder["FormButtonTextAsc"] = "formButtonText_ASC";
    ArticleLinkingCollectionsResourceCollectionOrder["FormButtonTextDesc"] = "formButtonText_DESC";
    ArticleLinkingCollectionsResourceCollectionOrder["FormIdAsc"] = "formId_ASC";
    ArticleLinkingCollectionsResourceCollectionOrder["FormIdDesc"] = "formId_DESC";
    ArticleLinkingCollectionsResourceCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ArticleLinkingCollectionsResourceCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ArticleLinkingCollectionsResourceCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    ArticleLinkingCollectionsResourceCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    ArticleLinkingCollectionsResourceCollectionOrder["SlugAsc"] = "slug_ASC";
    ArticleLinkingCollectionsResourceCollectionOrder["SlugDesc"] = "slug_DESC";
    ArticleLinkingCollectionsResourceCollectionOrder["StatusAsc"] = "status_ASC";
    ArticleLinkingCollectionsResourceCollectionOrder["StatusDesc"] = "status_DESC";
    ArticleLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticleLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticleLinkingCollectionsResourceCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ArticleLinkingCollectionsResourceCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ArticleLinkingCollectionsResourceCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticleLinkingCollectionsResourceCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticleLinkingCollectionsResourceCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticleLinkingCollectionsResourceCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ArticleLinkingCollectionsResourceCollectionOrder["TitleAsc"] = "title_ASC";
    ArticleLinkingCollectionsResourceCollectionOrder["TitleDesc"] = "title_DESC";
    ArticleLinkingCollectionsResourceCollectionOrder["TypeAsc"] = "type_ASC";
    ArticleLinkingCollectionsResourceCollectionOrder["TypeDesc"] = "type_DESC";
})(ArticleLinkingCollectionsResourceCollectionOrder || (exports.ArticleLinkingCollectionsResourceCollectionOrder = ArticleLinkingCollectionsResourceCollectionOrder = {}));
var ArticleOrder;
(function (ArticleOrder) {
    ArticleOrder["EditStatusAsc"] = "editStatus_ASC";
    ArticleOrder["EditStatusDesc"] = "editStatus_DESC";
    ArticleOrder["FaqsHeadingAsc"] = "faqsHeading_ASC";
    ArticleOrder["FaqsHeadingDesc"] = "faqsHeading_DESC";
    ArticleOrder["InternalNameAsc"] = "internalName_ASC";
    ArticleOrder["InternalNameDesc"] = "internalName_DESC";
    ArticleOrder["InterstitialHeadlineAsc"] = "interstitialHeadline_ASC";
    ArticleOrder["InterstitialHeadlineDesc"] = "interstitialHeadline_DESC";
    ArticleOrder["PopularAsc"] = "popular_ASC";
    ArticleOrder["PopularDesc"] = "popular_DESC";
    ArticleOrder["PublishedDateAsc"] = "publishedDate_ASC";
    ArticleOrder["PublishedDateDesc"] = "publishedDate_DESC";
    ArticleOrder["SlugAsc"] = "slug_ASC";
    ArticleOrder["SlugDesc"] = "slug_DESC";
    ArticleOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticleOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticleOrder["SysIdAsc"] = "sys_id_ASC";
    ArticleOrder["SysIdDesc"] = "sys_id_DESC";
    ArticleOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticleOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticleOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticleOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ArticleOrder["TitleAsc"] = "title_ASC";
    ArticleOrder["TitleDesc"] = "title_DESC";
})(ArticleOrder || (exports.ArticleOrder = ArticleOrder = {}));
var ArticleSecondaryCtasCollectionOrder;
(function (ArticleSecondaryCtasCollectionOrder) {
    ArticleSecondaryCtasCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ArticleSecondaryCtasCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ArticleSecondaryCtasCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ArticleSecondaryCtasCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ArticleSecondaryCtasCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ArticleSecondaryCtasCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ArticleSecondaryCtasCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ArticleSecondaryCtasCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ArticleSecondaryCtasCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ArticleSecondaryCtasCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ArticleSecondaryCtasCollectionOrder["ThemeAsc"] = "theme_ASC";
    ArticleSecondaryCtasCollectionOrder["ThemeDesc"] = "theme_DESC";
    ArticleSecondaryCtasCollectionOrder["TitleAsc"] = "title_ASC";
    ArticleSecondaryCtasCollectionOrder["TitleDesc"] = "title_DESC";
})(ArticleSecondaryCtasCollectionOrder || (exports.ArticleSecondaryCtasCollectionOrder = ArticleSecondaryCtasCollectionOrder = {}));
var AssetExternalLinkingCollectionsCaseStudyCollectionOrder;
(function (AssetExternalLinkingCollectionsCaseStudyCollectionOrder) {
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorNameAsc"] = "featuredAuthorName_ASC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorNameDesc"] = "featuredAuthorName_DESC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorTitleAsc"] = "featuredAuthorTitle_ASC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorTitleDesc"] = "featuredAuthorTitle_DESC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["FeaturedLinkTextAsc"] = "featuredLinkText_ASC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["FeaturedLinkTextDesc"] = "featuredLinkText_DESC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["SlugAsc"] = "slug_ASC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["SlugDesc"] = "slug_DESC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["StatusAsc"] = "status_ASC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["StatusDesc"] = "status_DESC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["TitleAsc"] = "title_ASC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["TitleDesc"] = "title_DESC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["WhitepaperStandinAsc"] = "whitepaperStandin_ASC";
    AssetExternalLinkingCollectionsCaseStudyCollectionOrder["WhitepaperStandinDesc"] = "whitepaperStandin_DESC";
})(AssetExternalLinkingCollectionsCaseStudyCollectionOrder || (exports.AssetExternalLinkingCollectionsCaseStudyCollectionOrder = AssetExternalLinkingCollectionsCaseStudyCollectionOrder = {}));
var AssetExternalLinkingCollectionsHeroCollectionOrder;
(function (AssetExternalLinkingCollectionsHeroCollectionOrder) {
    AssetExternalLinkingCollectionsHeroCollectionOrder["BcLogoAsc"] = "bcLogo_ASC";
    AssetExternalLinkingCollectionsHeroCollectionOrder["BcLogoDesc"] = "bcLogo_DESC";
    AssetExternalLinkingCollectionsHeroCollectionOrder["HeadlineAsc"] = "headline_ASC";
    AssetExternalLinkingCollectionsHeroCollectionOrder["HeadlineDesc"] = "headline_DESC";
    AssetExternalLinkingCollectionsHeroCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    AssetExternalLinkingCollectionsHeroCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    AssetExternalLinkingCollectionsHeroCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AssetExternalLinkingCollectionsHeroCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AssetExternalLinkingCollectionsHeroCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AssetExternalLinkingCollectionsHeroCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AssetExternalLinkingCollectionsHeroCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AssetExternalLinkingCollectionsHeroCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AssetExternalLinkingCollectionsHeroCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AssetExternalLinkingCollectionsHeroCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(AssetExternalLinkingCollectionsHeroCollectionOrder || (exports.AssetExternalLinkingCollectionsHeroCollectionOrder = AssetExternalLinkingCollectionsHeroCollectionOrder = {}));
var AssetExternalLinkingCollectionsPressCollectionOrder;
(function (AssetExternalLinkingCollectionsPressCollectionOrder) {
    AssetExternalLinkingCollectionsPressCollectionOrder["EnabledAsc"] = "enabled_ASC";
    AssetExternalLinkingCollectionsPressCollectionOrder["EnabledDesc"] = "enabled_DESC";
    AssetExternalLinkingCollectionsPressCollectionOrder["FeaturedAsc"] = "featured_ASC";
    AssetExternalLinkingCollectionsPressCollectionOrder["FeaturedDesc"] = "featured_DESC";
    AssetExternalLinkingCollectionsPressCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    AssetExternalLinkingCollectionsPressCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    AssetExternalLinkingCollectionsPressCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    AssetExternalLinkingCollectionsPressCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    AssetExternalLinkingCollectionsPressCollectionOrder["SlugAsc"] = "slug_ASC";
    AssetExternalLinkingCollectionsPressCollectionOrder["SlugDesc"] = "slug_DESC";
    AssetExternalLinkingCollectionsPressCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AssetExternalLinkingCollectionsPressCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AssetExternalLinkingCollectionsPressCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AssetExternalLinkingCollectionsPressCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AssetExternalLinkingCollectionsPressCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AssetExternalLinkingCollectionsPressCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AssetExternalLinkingCollectionsPressCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AssetExternalLinkingCollectionsPressCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AssetExternalLinkingCollectionsPressCollectionOrder["TitleAsc"] = "title_ASC";
    AssetExternalLinkingCollectionsPressCollectionOrder["TitleDesc"] = "title_DESC";
    AssetExternalLinkingCollectionsPressCollectionOrder["TypeAsc"] = "type_ASC";
    AssetExternalLinkingCollectionsPressCollectionOrder["TypeDesc"] = "type_DESC";
})(AssetExternalLinkingCollectionsPressCollectionOrder || (exports.AssetExternalLinkingCollectionsPressCollectionOrder = AssetExternalLinkingCollectionsPressCollectionOrder = {}));
var AssetExternalLinkingCollectionsShowcaseCollectionOrder;
(function (AssetExternalLinkingCollectionsShowcaseCollectionOrder) {
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["FeaturedAsc"] = "featured_ASC";
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["FeaturedDesc"] = "featured_DESC";
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["SlugAsc"] = "slug_ASC";
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["SlugDesc"] = "slug_DESC";
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["StatusAsc"] = "status_ASC";
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["StatusDesc"] = "status_DESC";
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["TitleAsc"] = "title_ASC";
    AssetExternalLinkingCollectionsShowcaseCollectionOrder["TitleDesc"] = "title_DESC";
})(AssetExternalLinkingCollectionsShowcaseCollectionOrder || (exports.AssetExternalLinkingCollectionsShowcaseCollectionOrder = AssetExternalLinkingCollectionsShowcaseCollectionOrder = {}));
var AssetExternalOrder;
(function (AssetExternalOrder) {
    AssetExternalOrder["AltTextAsc"] = "altText_ASC";
    AssetExternalOrder["AltTextDesc"] = "altText_DESC";
    AssetExternalOrder["AssetTypeAsc"] = "assetType_ASC";
    AssetExternalOrder["AssetTypeDesc"] = "assetType_DESC";
    AssetExternalOrder["InternalNameAsc"] = "internalName_ASC";
    AssetExternalOrder["InternalNameDesc"] = "internalName_DESC";
    AssetExternalOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AssetExternalOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AssetExternalOrder["SysIdAsc"] = "sys_id_ASC";
    AssetExternalOrder["SysIdDesc"] = "sys_id_DESC";
    AssetExternalOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AssetExternalOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AssetExternalOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AssetExternalOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AssetExternalOrder["UrlAsc"] = "url_ASC";
    AssetExternalOrder["UrlDesc"] = "url_DESC";
})(AssetExternalOrder || (exports.AssetExternalOrder = AssetExternalOrder = {}));
var AssetInternalLinkingCollectionsHeroCollectionOrder;
(function (AssetInternalLinkingCollectionsHeroCollectionOrder) {
    AssetInternalLinkingCollectionsHeroCollectionOrder["BcLogoAsc"] = "bcLogo_ASC";
    AssetInternalLinkingCollectionsHeroCollectionOrder["BcLogoDesc"] = "bcLogo_DESC";
    AssetInternalLinkingCollectionsHeroCollectionOrder["HeadlineAsc"] = "headline_ASC";
    AssetInternalLinkingCollectionsHeroCollectionOrder["HeadlineDesc"] = "headline_DESC";
    AssetInternalLinkingCollectionsHeroCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    AssetInternalLinkingCollectionsHeroCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    AssetInternalLinkingCollectionsHeroCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AssetInternalLinkingCollectionsHeroCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AssetInternalLinkingCollectionsHeroCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AssetInternalLinkingCollectionsHeroCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AssetInternalLinkingCollectionsHeroCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AssetInternalLinkingCollectionsHeroCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AssetInternalLinkingCollectionsHeroCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AssetInternalLinkingCollectionsHeroCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(AssetInternalLinkingCollectionsHeroCollectionOrder || (exports.AssetInternalLinkingCollectionsHeroCollectionOrder = AssetInternalLinkingCollectionsHeroCollectionOrder = {}));
var AssetInternalLinkingCollectionsPressCollectionOrder;
(function (AssetInternalLinkingCollectionsPressCollectionOrder) {
    AssetInternalLinkingCollectionsPressCollectionOrder["EnabledAsc"] = "enabled_ASC";
    AssetInternalLinkingCollectionsPressCollectionOrder["EnabledDesc"] = "enabled_DESC";
    AssetInternalLinkingCollectionsPressCollectionOrder["FeaturedAsc"] = "featured_ASC";
    AssetInternalLinkingCollectionsPressCollectionOrder["FeaturedDesc"] = "featured_DESC";
    AssetInternalLinkingCollectionsPressCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    AssetInternalLinkingCollectionsPressCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    AssetInternalLinkingCollectionsPressCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    AssetInternalLinkingCollectionsPressCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    AssetInternalLinkingCollectionsPressCollectionOrder["SlugAsc"] = "slug_ASC";
    AssetInternalLinkingCollectionsPressCollectionOrder["SlugDesc"] = "slug_DESC";
    AssetInternalLinkingCollectionsPressCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AssetInternalLinkingCollectionsPressCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AssetInternalLinkingCollectionsPressCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AssetInternalLinkingCollectionsPressCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AssetInternalLinkingCollectionsPressCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AssetInternalLinkingCollectionsPressCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AssetInternalLinkingCollectionsPressCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AssetInternalLinkingCollectionsPressCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AssetInternalLinkingCollectionsPressCollectionOrder["TitleAsc"] = "title_ASC";
    AssetInternalLinkingCollectionsPressCollectionOrder["TitleDesc"] = "title_DESC";
    AssetInternalLinkingCollectionsPressCollectionOrder["TypeAsc"] = "type_ASC";
    AssetInternalLinkingCollectionsPressCollectionOrder["TypeDesc"] = "type_DESC";
})(AssetInternalLinkingCollectionsPressCollectionOrder || (exports.AssetInternalLinkingCollectionsPressCollectionOrder = AssetInternalLinkingCollectionsPressCollectionOrder = {}));
var AssetInternalLinkingCollectionsShowcaseCollectionOrder;
(function (AssetInternalLinkingCollectionsShowcaseCollectionOrder) {
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["FeaturedAsc"] = "featured_ASC";
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["FeaturedDesc"] = "featured_DESC";
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["SlugAsc"] = "slug_ASC";
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["SlugDesc"] = "slug_DESC";
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["StatusAsc"] = "status_ASC";
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["StatusDesc"] = "status_DESC";
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["TitleAsc"] = "title_ASC";
    AssetInternalLinkingCollectionsShowcaseCollectionOrder["TitleDesc"] = "title_DESC";
})(AssetInternalLinkingCollectionsShowcaseCollectionOrder || (exports.AssetInternalLinkingCollectionsShowcaseCollectionOrder = AssetInternalLinkingCollectionsShowcaseCollectionOrder = {}));
var AssetInternalOrder;
(function (AssetInternalOrder) {
    AssetInternalOrder["AltTextAsc"] = "altText_ASC";
    AssetInternalOrder["AltTextDesc"] = "altText_DESC";
    AssetInternalOrder["InternalNameAsc"] = "internalName_ASC";
    AssetInternalOrder["InternalNameDesc"] = "internalName_DESC";
    AssetInternalOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AssetInternalOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AssetInternalOrder["SysIdAsc"] = "sys_id_ASC";
    AssetInternalOrder["SysIdDesc"] = "sys_id_DESC";
    AssetInternalOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AssetInternalOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AssetInternalOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AssetInternalOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(AssetInternalOrder || (exports.AssetInternalOrder = AssetInternalOrder = {}));
var AssetOrder;
(function (AssetOrder) {
    AssetOrder["ContentTypeAsc"] = "contentType_ASC";
    AssetOrder["ContentTypeDesc"] = "contentType_DESC";
    AssetOrder["FileNameAsc"] = "fileName_ASC";
    AssetOrder["FileNameDesc"] = "fileName_DESC";
    AssetOrder["HeightAsc"] = "height_ASC";
    AssetOrder["HeightDesc"] = "height_DESC";
    AssetOrder["SizeAsc"] = "size_ASC";
    AssetOrder["SizeDesc"] = "size_DESC";
    AssetOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    AssetOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    AssetOrder["SysIdAsc"] = "sys_id_ASC";
    AssetOrder["SysIdDesc"] = "sys_id_DESC";
    AssetOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    AssetOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    AssetOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    AssetOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    AssetOrder["UrlAsc"] = "url_ASC";
    AssetOrder["UrlDesc"] = "url_DESC";
    AssetOrder["WidthAsc"] = "width_ASC";
    AssetOrder["WidthDesc"] = "width_DESC";
})(AssetOrder || (exports.AssetOrder = AssetOrder = {}));
var BackgroundLinkingCollectionsHeroCollectionOrder;
(function (BackgroundLinkingCollectionsHeroCollectionOrder) {
    BackgroundLinkingCollectionsHeroCollectionOrder["BcLogoAsc"] = "bcLogo_ASC";
    BackgroundLinkingCollectionsHeroCollectionOrder["BcLogoDesc"] = "bcLogo_DESC";
    BackgroundLinkingCollectionsHeroCollectionOrder["HeadlineAsc"] = "headline_ASC";
    BackgroundLinkingCollectionsHeroCollectionOrder["HeadlineDesc"] = "headline_DESC";
    BackgroundLinkingCollectionsHeroCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    BackgroundLinkingCollectionsHeroCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    BackgroundLinkingCollectionsHeroCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    BackgroundLinkingCollectionsHeroCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    BackgroundLinkingCollectionsHeroCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    BackgroundLinkingCollectionsHeroCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    BackgroundLinkingCollectionsHeroCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    BackgroundLinkingCollectionsHeroCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    BackgroundLinkingCollectionsHeroCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    BackgroundLinkingCollectionsHeroCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(BackgroundLinkingCollectionsHeroCollectionOrder || (exports.BackgroundLinkingCollectionsHeroCollectionOrder = BackgroundLinkingCollectionsHeroCollectionOrder = {}));
var BackgroundOrder;
(function (BackgroundOrder) {
    BackgroundOrder["GradientAsc"] = "gradient_ASC";
    BackgroundOrder["GradientDesc"] = "gradient_DESC";
    BackgroundOrder["InternalNameAsc"] = "internalName_ASC";
    BackgroundOrder["InternalNameDesc"] = "internalName_DESC";
    BackgroundOrder["SolidColorAsc"] = "solidColor_ASC";
    BackgroundOrder["SolidColorDesc"] = "solidColor_DESC";
    BackgroundOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    BackgroundOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    BackgroundOrder["SysIdAsc"] = "sys_id_ASC";
    BackgroundOrder["SysIdDesc"] = "sys_id_DESC";
    BackgroundOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    BackgroundOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    BackgroundOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    BackgroundOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    BackgroundOrder["TextColorAsc"] = "textColor_ASC";
    BackgroundOrder["TextColorDesc"] = "textColor_DESC";
})(BackgroundOrder || (exports.BackgroundOrder = BackgroundOrder = {}));
var BasicContentCardCtaButtonCollectionOrder;
(function (BasicContentCardCtaButtonCollectionOrder) {
    BasicContentCardCtaButtonCollectionOrder["ColorAsc"] = "color_ASC";
    BasicContentCardCtaButtonCollectionOrder["ColorDesc"] = "color_DESC";
    BasicContentCardCtaButtonCollectionOrder["DisplayTextAsc"] = "displayText_ASC";
    BasicContentCardCtaButtonCollectionOrder["DisplayTextDesc"] = "displayText_DESC";
    BasicContentCardCtaButtonCollectionOrder["FormIdAsc"] = "formId_ASC";
    BasicContentCardCtaButtonCollectionOrder["FormIdDesc"] = "formId_DESC";
    BasicContentCardCtaButtonCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    BasicContentCardCtaButtonCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    BasicContentCardCtaButtonCollectionOrder["OpenInNewTabAsc"] = "openInNewTab_ASC";
    BasicContentCardCtaButtonCollectionOrder["OpenInNewTabDesc"] = "openInNewTab_DESC";
    BasicContentCardCtaButtonCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    BasicContentCardCtaButtonCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    BasicContentCardCtaButtonCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    BasicContentCardCtaButtonCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    BasicContentCardCtaButtonCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    BasicContentCardCtaButtonCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    BasicContentCardCtaButtonCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    BasicContentCardCtaButtonCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    BasicContentCardCtaButtonCollectionOrder["VariantAsc"] = "variant_ASC";
    BasicContentCardCtaButtonCollectionOrder["VariantDesc"] = "variant_DESC";
})(BasicContentCardCtaButtonCollectionOrder || (exports.BasicContentCardCtaButtonCollectionOrder = BasicContentCardCtaButtonCollectionOrder = {}));
var BasicContentCardLinkingCollectionsArticleCollectionOrder;
(function (BasicContentCardLinkingCollectionsArticleCollectionOrder) {
    BasicContentCardLinkingCollectionsArticleCollectionOrder["EditStatusAsc"] = "editStatus_ASC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["EditStatusDesc"] = "editStatus_DESC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["FaqsHeadingAsc"] = "faqsHeading_ASC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["FaqsHeadingDesc"] = "faqsHeading_DESC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["InterstitialHeadlineAsc"] = "interstitialHeadline_ASC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["InterstitialHeadlineDesc"] = "interstitialHeadline_DESC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["PopularAsc"] = "popular_ASC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["PopularDesc"] = "popular_DESC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["SlugAsc"] = "slug_ASC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["SlugDesc"] = "slug_DESC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["TitleAsc"] = "title_ASC";
    BasicContentCardLinkingCollectionsArticleCollectionOrder["TitleDesc"] = "title_DESC";
})(BasicContentCardLinkingCollectionsArticleCollectionOrder || (exports.BasicContentCardLinkingCollectionsArticleCollectionOrder = BasicContentCardLinkingCollectionsArticleCollectionOrder = {}));
var BasicContentCardLinkingCollectionsResourceCollectionOrder;
(function (BasicContentCardLinkingCollectionsResourceCollectionOrder) {
    BasicContentCardLinkingCollectionsResourceCollectionOrder["FormButtonTextAsc"] = "formButtonText_ASC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["FormButtonTextDesc"] = "formButtonText_DESC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["FormIdAsc"] = "formId_ASC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["FormIdDesc"] = "formId_DESC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["SlugAsc"] = "slug_ASC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["SlugDesc"] = "slug_DESC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["StatusAsc"] = "status_ASC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["StatusDesc"] = "status_DESC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["TitleAsc"] = "title_ASC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["TitleDesc"] = "title_DESC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["TypeAsc"] = "type_ASC";
    BasicContentCardLinkingCollectionsResourceCollectionOrder["TypeDesc"] = "type_DESC";
})(BasicContentCardLinkingCollectionsResourceCollectionOrder || (exports.BasicContentCardLinkingCollectionsResourceCollectionOrder = BasicContentCardLinkingCollectionsResourceCollectionOrder = {}));
var BasicContentCardOrder;
(function (BasicContentCardOrder) {
    BasicContentCardOrder["InternalNameAsc"] = "internalName_ASC";
    BasicContentCardOrder["InternalNameDesc"] = "internalName_DESC";
    BasicContentCardOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    BasicContentCardOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    BasicContentCardOrder["SysIdAsc"] = "sys_id_ASC";
    BasicContentCardOrder["SysIdDesc"] = "sys_id_DESC";
    BasicContentCardOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    BasicContentCardOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    BasicContentCardOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    BasicContentCardOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    BasicContentCardOrder["ThemeAsc"] = "theme_ASC";
    BasicContentCardOrder["ThemeDesc"] = "theme_DESC";
    BasicContentCardOrder["TitleAsc"] = "title_ASC";
    BasicContentCardOrder["TitleDesc"] = "title_DESC";
})(BasicContentCardOrder || (exports.BasicContentCardOrder = BasicContentCardOrder = {}));
var BlogPostCategoriesCollectionOrder;
(function (BlogPostCategoriesCollectionOrder) {
    BlogPostCategoriesCollectionOrder["NameAsc"] = "name_ASC";
    BlogPostCategoriesCollectionOrder["NameDesc"] = "name_DESC";
    BlogPostCategoriesCollectionOrder["SlugAsc"] = "slug_ASC";
    BlogPostCategoriesCollectionOrder["SlugDesc"] = "slug_DESC";
    BlogPostCategoriesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    BlogPostCategoriesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    BlogPostCategoriesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    BlogPostCategoriesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    BlogPostCategoriesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    BlogPostCategoriesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    BlogPostCategoriesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    BlogPostCategoriesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(BlogPostCategoriesCollectionOrder || (exports.BlogPostCategoriesCollectionOrder = BlogPostCategoriesCollectionOrder = {}));
var BlogPostLinkingCollectionsResourceCollectionOrder;
(function (BlogPostLinkingCollectionsResourceCollectionOrder) {
    BlogPostLinkingCollectionsResourceCollectionOrder["FormButtonTextAsc"] = "formButtonText_ASC";
    BlogPostLinkingCollectionsResourceCollectionOrder["FormButtonTextDesc"] = "formButtonText_DESC";
    BlogPostLinkingCollectionsResourceCollectionOrder["FormIdAsc"] = "formId_ASC";
    BlogPostLinkingCollectionsResourceCollectionOrder["FormIdDesc"] = "formId_DESC";
    BlogPostLinkingCollectionsResourceCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    BlogPostLinkingCollectionsResourceCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    BlogPostLinkingCollectionsResourceCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    BlogPostLinkingCollectionsResourceCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    BlogPostLinkingCollectionsResourceCollectionOrder["SlugAsc"] = "slug_ASC";
    BlogPostLinkingCollectionsResourceCollectionOrder["SlugDesc"] = "slug_DESC";
    BlogPostLinkingCollectionsResourceCollectionOrder["StatusAsc"] = "status_ASC";
    BlogPostLinkingCollectionsResourceCollectionOrder["StatusDesc"] = "status_DESC";
    BlogPostLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    BlogPostLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    BlogPostLinkingCollectionsResourceCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    BlogPostLinkingCollectionsResourceCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    BlogPostLinkingCollectionsResourceCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    BlogPostLinkingCollectionsResourceCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    BlogPostLinkingCollectionsResourceCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    BlogPostLinkingCollectionsResourceCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    BlogPostLinkingCollectionsResourceCollectionOrder["TitleAsc"] = "title_ASC";
    BlogPostLinkingCollectionsResourceCollectionOrder["TitleDesc"] = "title_DESC";
    BlogPostLinkingCollectionsResourceCollectionOrder["TypeAsc"] = "type_ASC";
    BlogPostLinkingCollectionsResourceCollectionOrder["TypeDesc"] = "type_DESC";
})(BlogPostLinkingCollectionsResourceCollectionOrder || (exports.BlogPostLinkingCollectionsResourceCollectionOrder = BlogPostLinkingCollectionsResourceCollectionOrder = {}));
var BlogPostOrder;
(function (BlogPostOrder) {
    BlogPostOrder["HideOnHomepageAsc"] = "hideOnHomepage_ASC";
    BlogPostOrder["HideOnHomepageDesc"] = "hideOnHomepage_DESC";
    BlogPostOrder["InternalNameAsc"] = "internalName_ASC";
    BlogPostOrder["InternalNameDesc"] = "internalName_DESC";
    BlogPostOrder["PublishedDateAsc"] = "publishedDate_ASC";
    BlogPostOrder["PublishedDateDesc"] = "publishedDate_DESC";
    BlogPostOrder["ShowPostHeroAsc"] = "showPostHero_ASC";
    BlogPostOrder["ShowPostHeroDesc"] = "showPostHero_DESC";
    BlogPostOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    BlogPostOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    BlogPostOrder["SlugAsc"] = "slug_ASC";
    BlogPostOrder["SlugDesc"] = "slug_DESC";
    BlogPostOrder["StatusAsc"] = "status_ASC";
    BlogPostOrder["StatusDesc"] = "status_DESC";
    BlogPostOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    BlogPostOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    BlogPostOrder["SysIdAsc"] = "sys_id_ASC";
    BlogPostOrder["SysIdDesc"] = "sys_id_DESC";
    BlogPostOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    BlogPostOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    BlogPostOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    BlogPostOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    BlogPostOrder["TitleAsc"] = "title_ASC";
    BlogPostOrder["TitleDesc"] = "title_DESC";
})(BlogPostOrder || (exports.BlogPostOrder = BlogPostOrder = {}));
var BlogPostTagsCollectionOrder;
(function (BlogPostTagsCollectionOrder) {
    BlogPostTagsCollectionOrder["NameAsc"] = "name_ASC";
    BlogPostTagsCollectionOrder["NameDesc"] = "name_DESC";
    BlogPostTagsCollectionOrder["SlugAsc"] = "slug_ASC";
    BlogPostTagsCollectionOrder["SlugDesc"] = "slug_DESC";
    BlogPostTagsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    BlogPostTagsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    BlogPostTagsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    BlogPostTagsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    BlogPostTagsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    BlogPostTagsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    BlogPostTagsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    BlogPostTagsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(BlogPostTagsCollectionOrder || (exports.BlogPostTagsCollectionOrder = BlogPostTagsCollectionOrder = {}));
var CaseStudyCaseStudyStatsCollectionOrder;
(function (CaseStudyCaseStudyStatsCollectionOrder) {
    CaseStudyCaseStudyStatsCollectionOrder["KeyAsc"] = "key_ASC";
    CaseStudyCaseStudyStatsCollectionOrder["KeyDesc"] = "key_DESC";
    CaseStudyCaseStudyStatsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaseStudyCaseStudyStatsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaseStudyCaseStudyStatsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CaseStudyCaseStudyStatsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CaseStudyCaseStudyStatsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaseStudyCaseStudyStatsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaseStudyCaseStudyStatsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaseStudyCaseStudyStatsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CaseStudyCaseStudyStatsCollectionOrder["ValueAsc"] = "value_ASC";
    CaseStudyCaseStudyStatsCollectionOrder["ValueDesc"] = "value_DESC";
})(CaseStudyCaseStudyStatsCollectionOrder || (exports.CaseStudyCaseStudyStatsCollectionOrder = CaseStudyCaseStudyStatsCollectionOrder = {}));
var CaseStudyCompetitorsListCollectionOrder;
(function (CaseStudyCompetitorsListCollectionOrder) {
    CaseStudyCompetitorsListCollectionOrder["NameAsc"] = "name_ASC";
    CaseStudyCompetitorsListCollectionOrder["NameDesc"] = "name_DESC";
    CaseStudyCompetitorsListCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaseStudyCompetitorsListCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaseStudyCompetitorsListCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CaseStudyCompetitorsListCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CaseStudyCompetitorsListCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaseStudyCompetitorsListCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaseStudyCompetitorsListCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaseStudyCompetitorsListCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CaseStudyCompetitorsListCollectionOrder["TypeAsc"] = "type_ASC";
    CaseStudyCompetitorsListCollectionOrder["TypeDesc"] = "type_DESC";
})(CaseStudyCompetitorsListCollectionOrder || (exports.CaseStudyCompetitorsListCollectionOrder = CaseStudyCompetitorsListCollectionOrder = {}));
var CaseStudyIndustriesListCollectionOrder;
(function (CaseStudyIndustriesListCollectionOrder) {
    CaseStudyIndustriesListCollectionOrder["NameAsc"] = "name_ASC";
    CaseStudyIndustriesListCollectionOrder["NameDesc"] = "name_DESC";
    CaseStudyIndustriesListCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaseStudyIndustriesListCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaseStudyIndustriesListCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CaseStudyIndustriesListCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CaseStudyIndustriesListCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaseStudyIndustriesListCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaseStudyIndustriesListCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaseStudyIndustriesListCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CaseStudyIndustriesListCollectionOrder["TypeAsc"] = "type_ASC";
    CaseStudyIndustriesListCollectionOrder["TypeDesc"] = "type_DESC";
})(CaseStudyIndustriesListCollectionOrder || (exports.CaseStudyIndustriesListCollectionOrder = CaseStudyIndustriesListCollectionOrder = {}));
var CaseStudyLinkingCollectionsCaseStudyCollectionOrder;
(function (CaseStudyLinkingCollectionsCaseStudyCollectionOrder) {
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorNameAsc"] = "featuredAuthorName_ASC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorNameDesc"] = "featuredAuthorName_DESC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorTitleAsc"] = "featuredAuthorTitle_ASC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorTitleDesc"] = "featuredAuthorTitle_DESC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["FeaturedLinkTextAsc"] = "featuredLinkText_ASC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["FeaturedLinkTextDesc"] = "featuredLinkText_DESC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["SlugAsc"] = "slug_ASC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["SlugDesc"] = "slug_DESC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["StatusAsc"] = "status_ASC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["StatusDesc"] = "status_DESC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["TitleAsc"] = "title_ASC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["TitleDesc"] = "title_DESC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["WhitepaperStandinAsc"] = "whitepaperStandin_ASC";
    CaseStudyLinkingCollectionsCaseStudyCollectionOrder["WhitepaperStandinDesc"] = "whitepaperStandin_DESC";
})(CaseStudyLinkingCollectionsCaseStudyCollectionOrder || (exports.CaseStudyLinkingCollectionsCaseStudyCollectionOrder = CaseStudyLinkingCollectionsCaseStudyCollectionOrder = {}));
var CaseStudyLinkingCollectionsResourceCollectionOrder;
(function (CaseStudyLinkingCollectionsResourceCollectionOrder) {
    CaseStudyLinkingCollectionsResourceCollectionOrder["FormButtonTextAsc"] = "formButtonText_ASC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["FormButtonTextDesc"] = "formButtonText_DESC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["FormIdAsc"] = "formId_ASC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["FormIdDesc"] = "formId_DESC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["SlugAsc"] = "slug_ASC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["SlugDesc"] = "slug_DESC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["StatusAsc"] = "status_ASC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["StatusDesc"] = "status_DESC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["TitleAsc"] = "title_ASC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["TitleDesc"] = "title_DESC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["TypeAsc"] = "type_ASC";
    CaseStudyLinkingCollectionsResourceCollectionOrder["TypeDesc"] = "type_DESC";
})(CaseStudyLinkingCollectionsResourceCollectionOrder || (exports.CaseStudyLinkingCollectionsResourceCollectionOrder = CaseStudyLinkingCollectionsResourceCollectionOrder = {}));
var CaseStudyOrder;
(function (CaseStudyOrder) {
    CaseStudyOrder["FeaturedAuthorNameAsc"] = "featuredAuthorName_ASC";
    CaseStudyOrder["FeaturedAuthorNameDesc"] = "featuredAuthorName_DESC";
    CaseStudyOrder["FeaturedAuthorTitleAsc"] = "featuredAuthorTitle_ASC";
    CaseStudyOrder["FeaturedAuthorTitleDesc"] = "featuredAuthorTitle_DESC";
    CaseStudyOrder["FeaturedLinkTextAsc"] = "featuredLinkText_ASC";
    CaseStudyOrder["FeaturedLinkTextDesc"] = "featuredLinkText_DESC";
    CaseStudyOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    CaseStudyOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    CaseStudyOrder["InternalNameAsc"] = "internalName_ASC";
    CaseStudyOrder["InternalNameDesc"] = "internalName_DESC";
    CaseStudyOrder["PublishedDateAsc"] = "publishedDate_ASC";
    CaseStudyOrder["PublishedDateDesc"] = "publishedDate_DESC";
    CaseStudyOrder["SlugAsc"] = "slug_ASC";
    CaseStudyOrder["SlugDesc"] = "slug_DESC";
    CaseStudyOrder["StatusAsc"] = "status_ASC";
    CaseStudyOrder["StatusDesc"] = "status_DESC";
    CaseStudyOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaseStudyOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaseStudyOrder["SysIdAsc"] = "sys_id_ASC";
    CaseStudyOrder["SysIdDesc"] = "sys_id_DESC";
    CaseStudyOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaseStudyOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaseStudyOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaseStudyOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CaseStudyOrder["TitleAsc"] = "title_ASC";
    CaseStudyOrder["TitleDesc"] = "title_DESC";
    CaseStudyOrder["WhitepaperStandinAsc"] = "whitepaperStandin_ASC";
    CaseStudyOrder["WhitepaperStandinDesc"] = "whitepaperStandin_DESC";
})(CaseStudyOrder || (exports.CaseStudyOrder = CaseStudyOrder = {}));
var CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder;
(function (CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder) {
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorNameAsc"] = "featuredAuthorName_ASC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorNameDesc"] = "featuredAuthorName_DESC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorTitleAsc"] = "featuredAuthorTitle_ASC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorTitleDesc"] = "featuredAuthorTitle_DESC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["FeaturedLinkTextAsc"] = "featuredLinkText_ASC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["FeaturedLinkTextDesc"] = "featuredLinkText_DESC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["SlugAsc"] = "slug_ASC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["SlugDesc"] = "slug_DESC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["StatusAsc"] = "status_ASC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["StatusDesc"] = "status_DESC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["TitleAsc"] = "title_ASC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["TitleDesc"] = "title_DESC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["WhitepaperStandinAsc"] = "whitepaperStandin_ASC";
    CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder["WhitepaperStandinDesc"] = "whitepaperStandin_DESC";
})(CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder || (exports.CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder = CaseStudyPropertyLinkingCollectionsCaseStudyCollectionOrder = {}));
var CaseStudyPropertyOrder;
(function (CaseStudyPropertyOrder) {
    CaseStudyPropertyOrder["NameAsc"] = "name_ASC";
    CaseStudyPropertyOrder["NameDesc"] = "name_DESC";
    CaseStudyPropertyOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaseStudyPropertyOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaseStudyPropertyOrder["SysIdAsc"] = "sys_id_ASC";
    CaseStudyPropertyOrder["SysIdDesc"] = "sys_id_DESC";
    CaseStudyPropertyOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaseStudyPropertyOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaseStudyPropertyOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaseStudyPropertyOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CaseStudyPropertyOrder["TypeAsc"] = "type_ASC";
    CaseStudyPropertyOrder["TypeDesc"] = "type_DESC";
})(CaseStudyPropertyOrder || (exports.CaseStudyPropertyOrder = CaseStudyPropertyOrder = {}));
var CaseStudyRelatedCaseStudiesCollectionOrder;
(function (CaseStudyRelatedCaseStudiesCollectionOrder) {
    CaseStudyRelatedCaseStudiesCollectionOrder["FeaturedAuthorNameAsc"] = "featuredAuthorName_ASC";
    CaseStudyRelatedCaseStudiesCollectionOrder["FeaturedAuthorNameDesc"] = "featuredAuthorName_DESC";
    CaseStudyRelatedCaseStudiesCollectionOrder["FeaturedAuthorTitleAsc"] = "featuredAuthorTitle_ASC";
    CaseStudyRelatedCaseStudiesCollectionOrder["FeaturedAuthorTitleDesc"] = "featuredAuthorTitle_DESC";
    CaseStudyRelatedCaseStudiesCollectionOrder["FeaturedLinkTextAsc"] = "featuredLinkText_ASC";
    CaseStudyRelatedCaseStudiesCollectionOrder["FeaturedLinkTextDesc"] = "featuredLinkText_DESC";
    CaseStudyRelatedCaseStudiesCollectionOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    CaseStudyRelatedCaseStudiesCollectionOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    CaseStudyRelatedCaseStudiesCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    CaseStudyRelatedCaseStudiesCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    CaseStudyRelatedCaseStudiesCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    CaseStudyRelatedCaseStudiesCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    CaseStudyRelatedCaseStudiesCollectionOrder["SlugAsc"] = "slug_ASC";
    CaseStudyRelatedCaseStudiesCollectionOrder["SlugDesc"] = "slug_DESC";
    CaseStudyRelatedCaseStudiesCollectionOrder["StatusAsc"] = "status_ASC";
    CaseStudyRelatedCaseStudiesCollectionOrder["StatusDesc"] = "status_DESC";
    CaseStudyRelatedCaseStudiesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaseStudyRelatedCaseStudiesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaseStudyRelatedCaseStudiesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CaseStudyRelatedCaseStudiesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CaseStudyRelatedCaseStudiesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaseStudyRelatedCaseStudiesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaseStudyRelatedCaseStudiesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaseStudyRelatedCaseStudiesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CaseStudyRelatedCaseStudiesCollectionOrder["TitleAsc"] = "title_ASC";
    CaseStudyRelatedCaseStudiesCollectionOrder["TitleDesc"] = "title_DESC";
    CaseStudyRelatedCaseStudiesCollectionOrder["WhitepaperStandinAsc"] = "whitepaperStandin_ASC";
    CaseStudyRelatedCaseStudiesCollectionOrder["WhitepaperStandinDesc"] = "whitepaperStandin_DESC";
})(CaseStudyRelatedCaseStudiesCollectionOrder || (exports.CaseStudyRelatedCaseStudiesCollectionOrder = CaseStudyRelatedCaseStudiesCollectionOrder = {}));
var CaseStudyTopicsListCollectionOrder;
(function (CaseStudyTopicsListCollectionOrder) {
    CaseStudyTopicsListCollectionOrder["NameAsc"] = "name_ASC";
    CaseStudyTopicsListCollectionOrder["NameDesc"] = "name_DESC";
    CaseStudyTopicsListCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CaseStudyTopicsListCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CaseStudyTopicsListCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CaseStudyTopicsListCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CaseStudyTopicsListCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CaseStudyTopicsListCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CaseStudyTopicsListCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CaseStudyTopicsListCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CaseStudyTopicsListCollectionOrder["TypeAsc"] = "type_ASC";
    CaseStudyTopicsListCollectionOrder["TypeDesc"] = "type_DESC";
})(CaseStudyTopicsListCollectionOrder || (exports.CaseStudyTopicsListCollectionOrder = CaseStudyTopicsListCollectionOrder = {}));
var CategoryLinkingCollectionsBlogPostCollectionOrder;
(function (CategoryLinkingCollectionsBlogPostCollectionOrder) {
    CategoryLinkingCollectionsBlogPostCollectionOrder["HideOnHomepageAsc"] = "hideOnHomepage_ASC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["HideOnHomepageDesc"] = "hideOnHomepage_DESC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["ShowPostHeroAsc"] = "showPostHero_ASC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["ShowPostHeroDesc"] = "showPostHero_DESC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["SlugAsc"] = "slug_ASC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["SlugDesc"] = "slug_DESC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["StatusAsc"] = "status_ASC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["StatusDesc"] = "status_DESC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["TitleAsc"] = "title_ASC";
    CategoryLinkingCollectionsBlogPostCollectionOrder["TitleDesc"] = "title_DESC";
})(CategoryLinkingCollectionsBlogPostCollectionOrder || (exports.CategoryLinkingCollectionsBlogPostCollectionOrder = CategoryLinkingCollectionsBlogPostCollectionOrder = {}));
var CategoryLinkingCollectionsCategoryCollectionOrder;
(function (CategoryLinkingCollectionsCategoryCollectionOrder) {
    CategoryLinkingCollectionsCategoryCollectionOrder["NameAsc"] = "name_ASC";
    CategoryLinkingCollectionsCategoryCollectionOrder["NameDesc"] = "name_DESC";
    CategoryLinkingCollectionsCategoryCollectionOrder["SlugAsc"] = "slug_ASC";
    CategoryLinkingCollectionsCategoryCollectionOrder["SlugDesc"] = "slug_DESC";
    CategoryLinkingCollectionsCategoryCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CategoryLinkingCollectionsCategoryCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CategoryLinkingCollectionsCategoryCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CategoryLinkingCollectionsCategoryCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CategoryLinkingCollectionsCategoryCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CategoryLinkingCollectionsCategoryCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CategoryLinkingCollectionsCategoryCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CategoryLinkingCollectionsCategoryCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(CategoryLinkingCollectionsCategoryCollectionOrder || (exports.CategoryLinkingCollectionsCategoryCollectionOrder = CategoryLinkingCollectionsCategoryCollectionOrder = {}));
var CategoryLinkingCollectionsGlossaryCollectionOrder;
(function (CategoryLinkingCollectionsGlossaryCollectionOrder) {
    CategoryLinkingCollectionsGlossaryCollectionOrder["EnabledAsc"] = "enabled_ASC";
    CategoryLinkingCollectionsGlossaryCollectionOrder["EnabledDesc"] = "enabled_DESC";
    CategoryLinkingCollectionsGlossaryCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    CategoryLinkingCollectionsGlossaryCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    CategoryLinkingCollectionsGlossaryCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    CategoryLinkingCollectionsGlossaryCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    CategoryLinkingCollectionsGlossaryCollectionOrder["SlugAsc"] = "slug_ASC";
    CategoryLinkingCollectionsGlossaryCollectionOrder["SlugDesc"] = "slug_DESC";
    CategoryLinkingCollectionsGlossaryCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CategoryLinkingCollectionsGlossaryCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CategoryLinkingCollectionsGlossaryCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CategoryLinkingCollectionsGlossaryCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CategoryLinkingCollectionsGlossaryCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CategoryLinkingCollectionsGlossaryCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CategoryLinkingCollectionsGlossaryCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CategoryLinkingCollectionsGlossaryCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CategoryLinkingCollectionsGlossaryCollectionOrder["TitleAsc"] = "title_ASC";
    CategoryLinkingCollectionsGlossaryCollectionOrder["TitleDesc"] = "title_DESC";
})(CategoryLinkingCollectionsGlossaryCollectionOrder || (exports.CategoryLinkingCollectionsGlossaryCollectionOrder = CategoryLinkingCollectionsGlossaryCollectionOrder = {}));
var CategoryLinkingCollectionsMarketplaceAppCollectionOrder;
(function (CategoryLinkingCollectionsMarketplaceAppCollectionOrder) {
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["AlternativeLogoAsc"] = "alternativeLogo_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["AlternativeLogoDesc"] = "alternativeLogo_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryIdAsc"] = "appRegistryId_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryIdDesc"] = "appRegistryId_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryUpdatedAtAsc"] = "appRegistryUpdatedAt_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryUpdatedAtDesc"] = "appRegistryUpdatedAt_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["ApprovedAtAsc"] = "approvedAt_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["ApprovedAtDesc"] = "approvedAt_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["AutomatedBillingAsc"] = "automatedBilling_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["AutomatedBillingDesc"] = "automatedBilling_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["CreatedOnAsc"] = "createdOn_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["CreatedOnDesc"] = "createdOn_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedAsc"] = "featured_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedDesc"] = "featured_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDaysAsc"] = "freeTrialDays_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDaysDesc"] = "freeTrialDays_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialAsc"] = "freeTrial_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDesc"] = "freeTrial_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["InstallationGuideUrlAsc"] = "installationGuideUrl_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["InstallationGuideUrlDesc"] = "installationGuideUrl_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["LastHashAsc"] = "lastHash_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["LastHashDesc"] = "lastHash_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["LogoIconAsc"] = "logoIcon_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["LogoIconDesc"] = "logoIcon_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["LogoAsc"] = "logo_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["LogoDesc"] = "logo_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["MonthlyPriceAsc"] = "monthlyPrice_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["MonthlyPriceDesc"] = "monthlyPrice_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["MultiLocationAsc"] = "multiLocation_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["MultiLocationDesc"] = "multiLocation_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["MultiStorefrontAsc"] = "multiStorefront_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["MultiStorefrontDesc"] = "multiStorefront_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["NameAsc"] = "name_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["NameDesc"] = "name_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["PricingTypeAsc"] = "pricingType_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["PricingTypeDesc"] = "pricingType_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["PricingAsc"] = "pricing_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["PricingDesc"] = "pricing_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["RankAsc"] = "rank_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["RankDesc"] = "rank_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["RatingAsc"] = "rating_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["RatingDesc"] = "rating_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedOrderAsc"] = "recommendedOrder_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedOrderDesc"] = "recommendedOrder_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedAsc"] = "recommended_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedDesc"] = "recommended_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["ReviewCountAsc"] = "reviewCount_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["ReviewCountDesc"] = "reviewCount_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["SingleClickAsc"] = "singleClick_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["SingleClickDesc"] = "singleClick_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["SlugAsc"] = "slug_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["SlugDesc"] = "slug_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["SupportEmailAsc"] = "supportEmail_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["SupportEmailDesc"] = "supportEmail_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["SupportUrlAsc"] = "supportUrl_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["SupportUrlDesc"] = "supportUrl_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["TypeAsc"] = "type_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["TypeDesc"] = "type_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["UnifiedBillingAsc"] = "unifiedBilling_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["UnifiedBillingDesc"] = "unifiedBilling_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["UpfrontPriceAsc"] = "upfrontPrice_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["UpfrontPriceDesc"] = "upfrontPrice_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["UserGuideUrlAsc"] = "userGuideUrl_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["UserGuideUrlDesc"] = "userGuideUrl_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["VersionAsc"] = "version_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["VersionDesc"] = "version_DESC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["WebsiteAsc"] = "website_ASC";
    CategoryLinkingCollectionsMarketplaceAppCollectionOrder["WebsiteDesc"] = "website_DESC";
})(CategoryLinkingCollectionsMarketplaceAppCollectionOrder || (exports.CategoryLinkingCollectionsMarketplaceAppCollectionOrder = CategoryLinkingCollectionsMarketplaceAppCollectionOrder = {}));
var CategoryLinkingCollectionsShowcaseCollectionOrder;
(function (CategoryLinkingCollectionsShowcaseCollectionOrder) {
    CategoryLinkingCollectionsShowcaseCollectionOrder["FeaturedAsc"] = "featured_ASC";
    CategoryLinkingCollectionsShowcaseCollectionOrder["FeaturedDesc"] = "featured_DESC";
    CategoryLinkingCollectionsShowcaseCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    CategoryLinkingCollectionsShowcaseCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    CategoryLinkingCollectionsShowcaseCollectionOrder["SlugAsc"] = "slug_ASC";
    CategoryLinkingCollectionsShowcaseCollectionOrder["SlugDesc"] = "slug_DESC";
    CategoryLinkingCollectionsShowcaseCollectionOrder["StatusAsc"] = "status_ASC";
    CategoryLinkingCollectionsShowcaseCollectionOrder["StatusDesc"] = "status_DESC";
    CategoryLinkingCollectionsShowcaseCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CategoryLinkingCollectionsShowcaseCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CategoryLinkingCollectionsShowcaseCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CategoryLinkingCollectionsShowcaseCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CategoryLinkingCollectionsShowcaseCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CategoryLinkingCollectionsShowcaseCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CategoryLinkingCollectionsShowcaseCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CategoryLinkingCollectionsShowcaseCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CategoryLinkingCollectionsShowcaseCollectionOrder["TitleAsc"] = "title_ASC";
    CategoryLinkingCollectionsShowcaseCollectionOrder["TitleDesc"] = "title_DESC";
})(CategoryLinkingCollectionsShowcaseCollectionOrder || (exports.CategoryLinkingCollectionsShowcaseCollectionOrder = CategoryLinkingCollectionsShowcaseCollectionOrder = {}));
var CategoryOrder;
(function (CategoryOrder) {
    CategoryOrder["NameAsc"] = "name_ASC";
    CategoryOrder["NameDesc"] = "name_DESC";
    CategoryOrder["SlugAsc"] = "slug_ASC";
    CategoryOrder["SlugDesc"] = "slug_DESC";
    CategoryOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CategoryOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CategoryOrder["SysIdAsc"] = "sys_id_ASC";
    CategoryOrder["SysIdDesc"] = "sys_id_DESC";
    CategoryOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CategoryOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CategoryOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CategoryOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(CategoryOrder || (exports.CategoryOrder = CategoryOrder = {}));
var CtaButtonLinkingCollectionsArticleCollectionOrder;
(function (CtaButtonLinkingCollectionsArticleCollectionOrder) {
    CtaButtonLinkingCollectionsArticleCollectionOrder["EditStatusAsc"] = "editStatus_ASC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["EditStatusDesc"] = "editStatus_DESC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["FaqsHeadingAsc"] = "faqsHeading_ASC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["FaqsHeadingDesc"] = "faqsHeading_DESC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["InterstitialHeadlineAsc"] = "interstitialHeadline_ASC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["InterstitialHeadlineDesc"] = "interstitialHeadline_DESC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["PopularAsc"] = "popular_ASC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["PopularDesc"] = "popular_DESC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["SlugAsc"] = "slug_ASC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["SlugDesc"] = "slug_DESC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["TitleAsc"] = "title_ASC";
    CtaButtonLinkingCollectionsArticleCollectionOrder["TitleDesc"] = "title_DESC";
})(CtaButtonLinkingCollectionsArticleCollectionOrder || (exports.CtaButtonLinkingCollectionsArticleCollectionOrder = CtaButtonLinkingCollectionsArticleCollectionOrder = {}));
var CtaButtonLinkingCollectionsBasicContentCardCollectionOrder;
(function (CtaButtonLinkingCollectionsBasicContentCardCollectionOrder) {
    CtaButtonLinkingCollectionsBasicContentCardCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    CtaButtonLinkingCollectionsBasicContentCardCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    CtaButtonLinkingCollectionsBasicContentCardCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CtaButtonLinkingCollectionsBasicContentCardCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CtaButtonLinkingCollectionsBasicContentCardCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CtaButtonLinkingCollectionsBasicContentCardCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CtaButtonLinkingCollectionsBasicContentCardCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CtaButtonLinkingCollectionsBasicContentCardCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CtaButtonLinkingCollectionsBasicContentCardCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CtaButtonLinkingCollectionsBasicContentCardCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CtaButtonLinkingCollectionsBasicContentCardCollectionOrder["ThemeAsc"] = "theme_ASC";
    CtaButtonLinkingCollectionsBasicContentCardCollectionOrder["ThemeDesc"] = "theme_DESC";
    CtaButtonLinkingCollectionsBasicContentCardCollectionOrder["TitleAsc"] = "title_ASC";
    CtaButtonLinkingCollectionsBasicContentCardCollectionOrder["TitleDesc"] = "title_DESC";
})(CtaButtonLinkingCollectionsBasicContentCardCollectionOrder || (exports.CtaButtonLinkingCollectionsBasicContentCardCollectionOrder = CtaButtonLinkingCollectionsBasicContentCardCollectionOrder = {}));
var CtaButtonLinkingCollectionsHeroCollectionOrder;
(function (CtaButtonLinkingCollectionsHeroCollectionOrder) {
    CtaButtonLinkingCollectionsHeroCollectionOrder["BcLogoAsc"] = "bcLogo_ASC";
    CtaButtonLinkingCollectionsHeroCollectionOrder["BcLogoDesc"] = "bcLogo_DESC";
    CtaButtonLinkingCollectionsHeroCollectionOrder["HeadlineAsc"] = "headline_ASC";
    CtaButtonLinkingCollectionsHeroCollectionOrder["HeadlineDesc"] = "headline_DESC";
    CtaButtonLinkingCollectionsHeroCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    CtaButtonLinkingCollectionsHeroCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    CtaButtonLinkingCollectionsHeroCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CtaButtonLinkingCollectionsHeroCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CtaButtonLinkingCollectionsHeroCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CtaButtonLinkingCollectionsHeroCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CtaButtonLinkingCollectionsHeroCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CtaButtonLinkingCollectionsHeroCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CtaButtonLinkingCollectionsHeroCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CtaButtonLinkingCollectionsHeroCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(CtaButtonLinkingCollectionsHeroCollectionOrder || (exports.CtaButtonLinkingCollectionsHeroCollectionOrder = CtaButtonLinkingCollectionsHeroCollectionOrder = {}));
var CtaButtonLinkingCollectionsResourceCollectionOrder;
(function (CtaButtonLinkingCollectionsResourceCollectionOrder) {
    CtaButtonLinkingCollectionsResourceCollectionOrder["FormButtonTextAsc"] = "formButtonText_ASC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["FormButtonTextDesc"] = "formButtonText_DESC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["FormIdAsc"] = "formId_ASC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["FormIdDesc"] = "formId_DESC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["SlugAsc"] = "slug_ASC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["SlugDesc"] = "slug_DESC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["StatusAsc"] = "status_ASC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["StatusDesc"] = "status_DESC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["TitleAsc"] = "title_ASC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["TitleDesc"] = "title_DESC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["TypeAsc"] = "type_ASC";
    CtaButtonLinkingCollectionsResourceCollectionOrder["TypeDesc"] = "type_DESC";
})(CtaButtonLinkingCollectionsResourceCollectionOrder || (exports.CtaButtonLinkingCollectionsResourceCollectionOrder = CtaButtonLinkingCollectionsResourceCollectionOrder = {}));
var CtaButtonOrder;
(function (CtaButtonOrder) {
    CtaButtonOrder["ColorAsc"] = "color_ASC";
    CtaButtonOrder["ColorDesc"] = "color_DESC";
    CtaButtonOrder["DisplayTextAsc"] = "displayText_ASC";
    CtaButtonOrder["DisplayTextDesc"] = "displayText_DESC";
    CtaButtonOrder["FormIdAsc"] = "formId_ASC";
    CtaButtonOrder["FormIdDesc"] = "formId_DESC";
    CtaButtonOrder["InternalNameAsc"] = "internalName_ASC";
    CtaButtonOrder["InternalNameDesc"] = "internalName_DESC";
    CtaButtonOrder["OpenInNewTabAsc"] = "openInNewTab_ASC";
    CtaButtonOrder["OpenInNewTabDesc"] = "openInNewTab_DESC";
    CtaButtonOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CtaButtonOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CtaButtonOrder["SysIdAsc"] = "sys_id_ASC";
    CtaButtonOrder["SysIdDesc"] = "sys_id_DESC";
    CtaButtonOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CtaButtonOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CtaButtonOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CtaButtonOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CtaButtonOrder["VariantAsc"] = "variant_ASC";
    CtaButtonOrder["VariantDesc"] = "variant_DESC";
})(CtaButtonOrder || (exports.CtaButtonOrder = CtaButtonOrder = {}));
var CtaMatPatternLinkingCollectionsBlogPostCollectionOrder;
(function (CtaMatPatternLinkingCollectionsBlogPostCollectionOrder) {
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["HideOnHomepageAsc"] = "hideOnHomepage_ASC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["HideOnHomepageDesc"] = "hideOnHomepage_DESC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["ShowPostHeroAsc"] = "showPostHero_ASC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["ShowPostHeroDesc"] = "showPostHero_DESC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["SlugAsc"] = "slug_ASC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["SlugDesc"] = "slug_DESC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["StatusAsc"] = "status_ASC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["StatusDesc"] = "status_DESC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["TitleAsc"] = "title_ASC";
    CtaMatPatternLinkingCollectionsBlogPostCollectionOrder["TitleDesc"] = "title_DESC";
})(CtaMatPatternLinkingCollectionsBlogPostCollectionOrder || (exports.CtaMatPatternLinkingCollectionsBlogPostCollectionOrder = CtaMatPatternLinkingCollectionsBlogPostCollectionOrder = {}));
var CtaMatPatternOrder;
(function (CtaMatPatternOrder) {
    CtaMatPatternOrder["CtaTextAsc"] = "ctaText_ASC";
    CtaMatPatternOrder["CtaTextDesc"] = "ctaText_DESC";
    CtaMatPatternOrder["CtaUrlAsc"] = "ctaUrl_ASC";
    CtaMatPatternOrder["CtaUrlDesc"] = "ctaUrl_DESC";
    CtaMatPatternOrder["EnabledAsc"] = "enabled_ASC";
    CtaMatPatternOrder["EnabledDesc"] = "enabled_DESC";
    CtaMatPatternOrder["HeadingAsc"] = "heading_ASC";
    CtaMatPatternOrder["HeadingDesc"] = "heading_DESC";
    CtaMatPatternOrder["SubheadingAsc"] = "subheading_ASC";
    CtaMatPatternOrder["SubheadingDesc"] = "subheading_DESC";
    CtaMatPatternOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    CtaMatPatternOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    CtaMatPatternOrder["SysIdAsc"] = "sys_id_ASC";
    CtaMatPatternOrder["SysIdDesc"] = "sys_id_DESC";
    CtaMatPatternOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    CtaMatPatternOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    CtaMatPatternOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    CtaMatPatternOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(CtaMatPatternOrder || (exports.CtaMatPatternOrder = CtaMatPatternOrder = {}));
var EntryOrder;
(function (EntryOrder) {
    EntryOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    EntryOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    EntryOrder["SysIdAsc"] = "sys_id_ASC";
    EntryOrder["SysIdDesc"] = "sys_id_DESC";
    EntryOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    EntryOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    EntryOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    EntryOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(EntryOrder || (exports.EntryOrder = EntryOrder = {}));
var EventOrder;
(function (EventOrder) {
    EventOrder["EndDateAsc"] = "endDate_ASC";
    EventOrder["EndDateDesc"] = "endDate_DESC";
    EventOrder["FeaturedAsc"] = "featured_ASC";
    EventOrder["FeaturedDesc"] = "featured_DESC";
    EventOrder["InternalNameAsc"] = "internalName_ASC";
    EventOrder["InternalNameDesc"] = "internalName_DESC";
    EventOrder["RecurringEventAsc"] = "recurringEvent_ASC";
    EventOrder["RecurringEventDesc"] = "recurringEvent_DESC";
    EventOrder["StartDateAsc"] = "startDate_ASC";
    EventOrder["StartDateDesc"] = "startDate_DESC";
    EventOrder["StatusAsc"] = "status_ASC";
    EventOrder["StatusDesc"] = "status_DESC";
    EventOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    EventOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    EventOrder["SysIdAsc"] = "sys_id_ASC";
    EventOrder["SysIdDesc"] = "sys_id_DESC";
    EventOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    EventOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    EventOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    EventOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    EventOrder["TitleAsc"] = "title_ASC";
    EventOrder["TitleDesc"] = "title_DESC";
})(EventOrder || (exports.EventOrder = EventOrder = {}));
var ExternalLinkLinkingCollectionsAdditionalPersonOptionsCollectionOrder;
(function (ExternalLinkLinkingCollectionsAdditionalPersonOptionsCollectionOrder) {
    ExternalLinkLinkingCollectionsAdditionalPersonOptionsCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ExternalLinkLinkingCollectionsAdditionalPersonOptionsCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ExternalLinkLinkingCollectionsAdditionalPersonOptionsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ExternalLinkLinkingCollectionsAdditionalPersonOptionsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ExternalLinkLinkingCollectionsAdditionalPersonOptionsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ExternalLinkLinkingCollectionsAdditionalPersonOptionsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ExternalLinkLinkingCollectionsAdditionalPersonOptionsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ExternalLinkLinkingCollectionsAdditionalPersonOptionsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ExternalLinkLinkingCollectionsAdditionalPersonOptionsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ExternalLinkLinkingCollectionsAdditionalPersonOptionsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ExternalLinkLinkingCollectionsAdditionalPersonOptionsCollectionOrder || (exports.ExternalLinkLinkingCollectionsAdditionalPersonOptionsCollectionOrder = ExternalLinkLinkingCollectionsAdditionalPersonOptionsCollectionOrder = {}));
var ExternalLinkLinkingCollectionsCtaButtonCollectionOrder;
(function (ExternalLinkLinkingCollectionsCtaButtonCollectionOrder) {
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["ColorAsc"] = "color_ASC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["ColorDesc"] = "color_DESC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["DisplayTextAsc"] = "displayText_ASC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["DisplayTextDesc"] = "displayText_DESC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["FormIdAsc"] = "formId_ASC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["FormIdDesc"] = "formId_DESC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["OpenInNewTabAsc"] = "openInNewTab_ASC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["OpenInNewTabDesc"] = "openInNewTab_DESC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["VariantAsc"] = "variant_ASC";
    ExternalLinkLinkingCollectionsCtaButtonCollectionOrder["VariantDesc"] = "variant_DESC";
})(ExternalLinkLinkingCollectionsCtaButtonCollectionOrder || (exports.ExternalLinkLinkingCollectionsCtaButtonCollectionOrder = ExternalLinkLinkingCollectionsCtaButtonCollectionOrder = {}));
var ExternalLinkLinkingCollectionsEventCollectionOrder;
(function (ExternalLinkLinkingCollectionsEventCollectionOrder) {
    ExternalLinkLinkingCollectionsEventCollectionOrder["EndDateAsc"] = "endDate_ASC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["EndDateDesc"] = "endDate_DESC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["FeaturedAsc"] = "featured_ASC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["FeaturedDesc"] = "featured_DESC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["RecurringEventAsc"] = "recurringEvent_ASC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["RecurringEventDesc"] = "recurringEvent_DESC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["StartDateAsc"] = "startDate_ASC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["StartDateDesc"] = "startDate_DESC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["StatusAsc"] = "status_ASC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["StatusDesc"] = "status_DESC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["TitleAsc"] = "title_ASC";
    ExternalLinkLinkingCollectionsEventCollectionOrder["TitleDesc"] = "title_DESC";
})(ExternalLinkLinkingCollectionsEventCollectionOrder || (exports.ExternalLinkLinkingCollectionsEventCollectionOrder = ExternalLinkLinkingCollectionsEventCollectionOrder = {}));
var ExternalLinkLinkingCollectionsPressCollectionOrder;
(function (ExternalLinkLinkingCollectionsPressCollectionOrder) {
    ExternalLinkLinkingCollectionsPressCollectionOrder["EnabledAsc"] = "enabled_ASC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["EnabledDesc"] = "enabled_DESC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["FeaturedAsc"] = "featured_ASC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["FeaturedDesc"] = "featured_DESC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["SlugAsc"] = "slug_ASC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["SlugDesc"] = "slug_DESC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["TitleAsc"] = "title_ASC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["TitleDesc"] = "title_DESC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["TypeAsc"] = "type_ASC";
    ExternalLinkLinkingCollectionsPressCollectionOrder["TypeDesc"] = "type_DESC";
})(ExternalLinkLinkingCollectionsPressCollectionOrder || (exports.ExternalLinkLinkingCollectionsPressCollectionOrder = ExternalLinkLinkingCollectionsPressCollectionOrder = {}));
var ExternalLinkLinkingCollectionsShowcaseCollectionOrder;
(function (ExternalLinkLinkingCollectionsShowcaseCollectionOrder) {
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["FeaturedAsc"] = "featured_ASC";
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["FeaturedDesc"] = "featured_DESC";
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["SlugAsc"] = "slug_ASC";
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["SlugDesc"] = "slug_DESC";
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["StatusAsc"] = "status_ASC";
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["StatusDesc"] = "status_DESC";
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["TitleAsc"] = "title_ASC";
    ExternalLinkLinkingCollectionsShowcaseCollectionOrder["TitleDesc"] = "title_DESC";
})(ExternalLinkLinkingCollectionsShowcaseCollectionOrder || (exports.ExternalLinkLinkingCollectionsShowcaseCollectionOrder = ExternalLinkLinkingCollectionsShowcaseCollectionOrder = {}));
var ExternalLinkOrder;
(function (ExternalLinkOrder) {
    ExternalLinkOrder["InternalNameAsc"] = "internalName_ASC";
    ExternalLinkOrder["InternalNameDesc"] = "internalName_DESC";
    ExternalLinkOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ExternalLinkOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ExternalLinkOrder["SysIdAsc"] = "sys_id_ASC";
    ExternalLinkOrder["SysIdDesc"] = "sys_id_DESC";
    ExternalLinkOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ExternalLinkOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ExternalLinkOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ExternalLinkOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ExternalLinkOrder["UrlAsc"] = "url_ASC";
    ExternalLinkOrder["UrlDesc"] = "url_DESC";
})(ExternalLinkOrder || (exports.ExternalLinkOrder = ExternalLinkOrder = {}));
var FaqItemLinkingCollectionsArticleCollectionOrder;
(function (FaqItemLinkingCollectionsArticleCollectionOrder) {
    FaqItemLinkingCollectionsArticleCollectionOrder["EditStatusAsc"] = "editStatus_ASC";
    FaqItemLinkingCollectionsArticleCollectionOrder["EditStatusDesc"] = "editStatus_DESC";
    FaqItemLinkingCollectionsArticleCollectionOrder["FaqsHeadingAsc"] = "faqsHeading_ASC";
    FaqItemLinkingCollectionsArticleCollectionOrder["FaqsHeadingDesc"] = "faqsHeading_DESC";
    FaqItemLinkingCollectionsArticleCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    FaqItemLinkingCollectionsArticleCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    FaqItemLinkingCollectionsArticleCollectionOrder["InterstitialHeadlineAsc"] = "interstitialHeadline_ASC";
    FaqItemLinkingCollectionsArticleCollectionOrder["InterstitialHeadlineDesc"] = "interstitialHeadline_DESC";
    FaqItemLinkingCollectionsArticleCollectionOrder["PopularAsc"] = "popular_ASC";
    FaqItemLinkingCollectionsArticleCollectionOrder["PopularDesc"] = "popular_DESC";
    FaqItemLinkingCollectionsArticleCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    FaqItemLinkingCollectionsArticleCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    FaqItemLinkingCollectionsArticleCollectionOrder["SlugAsc"] = "slug_ASC";
    FaqItemLinkingCollectionsArticleCollectionOrder["SlugDesc"] = "slug_DESC";
    FaqItemLinkingCollectionsArticleCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FaqItemLinkingCollectionsArticleCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FaqItemLinkingCollectionsArticleCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    FaqItemLinkingCollectionsArticleCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    FaqItemLinkingCollectionsArticleCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FaqItemLinkingCollectionsArticleCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FaqItemLinkingCollectionsArticleCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FaqItemLinkingCollectionsArticleCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    FaqItemLinkingCollectionsArticleCollectionOrder["TitleAsc"] = "title_ASC";
    FaqItemLinkingCollectionsArticleCollectionOrder["TitleDesc"] = "title_DESC";
})(FaqItemLinkingCollectionsArticleCollectionOrder || (exports.FaqItemLinkingCollectionsArticleCollectionOrder = FaqItemLinkingCollectionsArticleCollectionOrder = {}));
var FaqItemOrder;
(function (FaqItemOrder) {
    FaqItemOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    FaqItemOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    FaqItemOrder["SysIdAsc"] = "sys_id_ASC";
    FaqItemOrder["SysIdDesc"] = "sys_id_DESC";
    FaqItemOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    FaqItemOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    FaqItemOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    FaqItemOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(FaqItemOrder || (exports.FaqItemOrder = FaqItemOrder = {}));
var GatedContentLinkingCollectionsBlogPostCollectionOrder;
(function (GatedContentLinkingCollectionsBlogPostCollectionOrder) {
    GatedContentLinkingCollectionsBlogPostCollectionOrder["HideOnHomepageAsc"] = "hideOnHomepage_ASC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["HideOnHomepageDesc"] = "hideOnHomepage_DESC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["ShowPostHeroAsc"] = "showPostHero_ASC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["ShowPostHeroDesc"] = "showPostHero_DESC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["SlugAsc"] = "slug_ASC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["SlugDesc"] = "slug_DESC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["StatusAsc"] = "status_ASC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["StatusDesc"] = "status_DESC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["TitleAsc"] = "title_ASC";
    GatedContentLinkingCollectionsBlogPostCollectionOrder["TitleDesc"] = "title_DESC";
})(GatedContentLinkingCollectionsBlogPostCollectionOrder || (exports.GatedContentLinkingCollectionsBlogPostCollectionOrder = GatedContentLinkingCollectionsBlogPostCollectionOrder = {}));
var GatedContentOrder;
(function (GatedContentOrder) {
    GatedContentOrder["CalloutTitleAsc"] = "calloutTitle_ASC";
    GatedContentOrder["CalloutTitleDesc"] = "calloutTitle_DESC";
    GatedContentOrder["InternalNameAsc"] = "internalName_ASC";
    GatedContentOrder["InternalNameDesc"] = "internalName_DESC";
    GatedContentOrder["ProvidePrintVersionAsc"] = "providePrintVersion_ASC";
    GatedContentOrder["ProvidePrintVersionDesc"] = "providePrintVersion_DESC";
    GatedContentOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    GatedContentOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    GatedContentOrder["SysIdAsc"] = "sys_id_ASC";
    GatedContentOrder["SysIdDesc"] = "sys_id_DESC";
    GatedContentOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    GatedContentOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    GatedContentOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    GatedContentOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(GatedContentOrder || (exports.GatedContentOrder = GatedContentOrder = {}));
var GlossaryCategoryCollectionOrder;
(function (GlossaryCategoryCollectionOrder) {
    GlossaryCategoryCollectionOrder["NameAsc"] = "name_ASC";
    GlossaryCategoryCollectionOrder["NameDesc"] = "name_DESC";
    GlossaryCategoryCollectionOrder["SlugAsc"] = "slug_ASC";
    GlossaryCategoryCollectionOrder["SlugDesc"] = "slug_DESC";
    GlossaryCategoryCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    GlossaryCategoryCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    GlossaryCategoryCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    GlossaryCategoryCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    GlossaryCategoryCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    GlossaryCategoryCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    GlossaryCategoryCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    GlossaryCategoryCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(GlossaryCategoryCollectionOrder || (exports.GlossaryCategoryCollectionOrder = GlossaryCategoryCollectionOrder = {}));
var GlossaryOrder;
(function (GlossaryOrder) {
    GlossaryOrder["EnabledAsc"] = "enabled_ASC";
    GlossaryOrder["EnabledDesc"] = "enabled_DESC";
    GlossaryOrder["InternalNameAsc"] = "internalName_ASC";
    GlossaryOrder["InternalNameDesc"] = "internalName_DESC";
    GlossaryOrder["PublishedDateAsc"] = "publishedDate_ASC";
    GlossaryOrder["PublishedDateDesc"] = "publishedDate_DESC";
    GlossaryOrder["SlugAsc"] = "slug_ASC";
    GlossaryOrder["SlugDesc"] = "slug_DESC";
    GlossaryOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    GlossaryOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    GlossaryOrder["SysIdAsc"] = "sys_id_ASC";
    GlossaryOrder["SysIdDesc"] = "sys_id_DESC";
    GlossaryOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    GlossaryOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    GlossaryOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    GlossaryOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    GlossaryOrder["TitleAsc"] = "title_ASC";
    GlossaryOrder["TitleDesc"] = "title_DESC";
})(GlossaryOrder || (exports.GlossaryOrder = GlossaryOrder = {}));
var HeroLinkingCollectionsArticleCollectionOrder;
(function (HeroLinkingCollectionsArticleCollectionOrder) {
    HeroLinkingCollectionsArticleCollectionOrder["EditStatusAsc"] = "editStatus_ASC";
    HeroLinkingCollectionsArticleCollectionOrder["EditStatusDesc"] = "editStatus_DESC";
    HeroLinkingCollectionsArticleCollectionOrder["FaqsHeadingAsc"] = "faqsHeading_ASC";
    HeroLinkingCollectionsArticleCollectionOrder["FaqsHeadingDesc"] = "faqsHeading_DESC";
    HeroLinkingCollectionsArticleCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    HeroLinkingCollectionsArticleCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    HeroLinkingCollectionsArticleCollectionOrder["InterstitialHeadlineAsc"] = "interstitialHeadline_ASC";
    HeroLinkingCollectionsArticleCollectionOrder["InterstitialHeadlineDesc"] = "interstitialHeadline_DESC";
    HeroLinkingCollectionsArticleCollectionOrder["PopularAsc"] = "popular_ASC";
    HeroLinkingCollectionsArticleCollectionOrder["PopularDesc"] = "popular_DESC";
    HeroLinkingCollectionsArticleCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    HeroLinkingCollectionsArticleCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    HeroLinkingCollectionsArticleCollectionOrder["SlugAsc"] = "slug_ASC";
    HeroLinkingCollectionsArticleCollectionOrder["SlugDesc"] = "slug_DESC";
    HeroLinkingCollectionsArticleCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HeroLinkingCollectionsArticleCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HeroLinkingCollectionsArticleCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    HeroLinkingCollectionsArticleCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    HeroLinkingCollectionsArticleCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HeroLinkingCollectionsArticleCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HeroLinkingCollectionsArticleCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HeroLinkingCollectionsArticleCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HeroLinkingCollectionsArticleCollectionOrder["TitleAsc"] = "title_ASC";
    HeroLinkingCollectionsArticleCollectionOrder["TitleDesc"] = "title_DESC";
})(HeroLinkingCollectionsArticleCollectionOrder || (exports.HeroLinkingCollectionsArticleCollectionOrder = HeroLinkingCollectionsArticleCollectionOrder = {}));
var HeroLinkingCollectionsCaseStudyCollectionOrder;
(function (HeroLinkingCollectionsCaseStudyCollectionOrder) {
    HeroLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorNameAsc"] = "featuredAuthorName_ASC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorNameDesc"] = "featuredAuthorName_DESC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorTitleAsc"] = "featuredAuthorTitle_ASC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorTitleDesc"] = "featuredAuthorTitle_DESC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["FeaturedLinkTextAsc"] = "featuredLinkText_ASC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["FeaturedLinkTextDesc"] = "featuredLinkText_DESC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["SlugAsc"] = "slug_ASC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["SlugDesc"] = "slug_DESC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["StatusAsc"] = "status_ASC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["StatusDesc"] = "status_DESC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["TitleAsc"] = "title_ASC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["TitleDesc"] = "title_DESC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["WhitepaperStandinAsc"] = "whitepaperStandin_ASC";
    HeroLinkingCollectionsCaseStudyCollectionOrder["WhitepaperStandinDesc"] = "whitepaperStandin_DESC";
})(HeroLinkingCollectionsCaseStudyCollectionOrder || (exports.HeroLinkingCollectionsCaseStudyCollectionOrder = HeroLinkingCollectionsCaseStudyCollectionOrder = {}));
var HeroLinkingCollectionsResourceCollectionOrder;
(function (HeroLinkingCollectionsResourceCollectionOrder) {
    HeroLinkingCollectionsResourceCollectionOrder["FormButtonTextAsc"] = "formButtonText_ASC";
    HeroLinkingCollectionsResourceCollectionOrder["FormButtonTextDesc"] = "formButtonText_DESC";
    HeroLinkingCollectionsResourceCollectionOrder["FormIdAsc"] = "formId_ASC";
    HeroLinkingCollectionsResourceCollectionOrder["FormIdDesc"] = "formId_DESC";
    HeroLinkingCollectionsResourceCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    HeroLinkingCollectionsResourceCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    HeroLinkingCollectionsResourceCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    HeroLinkingCollectionsResourceCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    HeroLinkingCollectionsResourceCollectionOrder["SlugAsc"] = "slug_ASC";
    HeroLinkingCollectionsResourceCollectionOrder["SlugDesc"] = "slug_DESC";
    HeroLinkingCollectionsResourceCollectionOrder["StatusAsc"] = "status_ASC";
    HeroLinkingCollectionsResourceCollectionOrder["StatusDesc"] = "status_DESC";
    HeroLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HeroLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HeroLinkingCollectionsResourceCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    HeroLinkingCollectionsResourceCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    HeroLinkingCollectionsResourceCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HeroLinkingCollectionsResourceCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HeroLinkingCollectionsResourceCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HeroLinkingCollectionsResourceCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    HeroLinkingCollectionsResourceCollectionOrder["TitleAsc"] = "title_ASC";
    HeroLinkingCollectionsResourceCollectionOrder["TitleDesc"] = "title_DESC";
    HeroLinkingCollectionsResourceCollectionOrder["TypeAsc"] = "type_ASC";
    HeroLinkingCollectionsResourceCollectionOrder["TypeDesc"] = "type_DESC";
})(HeroLinkingCollectionsResourceCollectionOrder || (exports.HeroLinkingCollectionsResourceCollectionOrder = HeroLinkingCollectionsResourceCollectionOrder = {}));
var HeroOrder;
(function (HeroOrder) {
    HeroOrder["BcLogoAsc"] = "bcLogo_ASC";
    HeroOrder["BcLogoDesc"] = "bcLogo_DESC";
    HeroOrder["HeadlineAsc"] = "headline_ASC";
    HeroOrder["HeadlineDesc"] = "headline_DESC";
    HeroOrder["InternalNameAsc"] = "internalName_ASC";
    HeroOrder["InternalNameDesc"] = "internalName_DESC";
    HeroOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    HeroOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    HeroOrder["SysIdAsc"] = "sys_id_ASC";
    HeroOrder["SysIdDesc"] = "sys_id_DESC";
    HeroOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    HeroOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    HeroOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    HeroOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(HeroOrder || (exports.HeroOrder = HeroOrder = {}));
var ImageFormat;
(function (ImageFormat) {
    ImageFormat["Avif"] = "AVIF";
    /** JPG image format. */
    ImageFormat["Jpg"] = "JPG";
    /**
     * Progressive JPG format stores multiple passes of an image in progressively higher detail.
     *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
     *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
     *         early as possible to make the layout look as designed.
     */
    ImageFormat["JpgProgressive"] = "JPG_PROGRESSIVE";
    /** PNG image format */
    ImageFormat["Png"] = "PNG";
    /**
     * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
     *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
     */
    ImageFormat["Png8"] = "PNG8";
    /** WebP image format. */
    ImageFormat["Webp"] = "WEBP";
})(ImageFormat || (exports.ImageFormat = ImageFormat = {}));
var ImageResizeFocus;
(function (ImageResizeFocus) {
    /** Focus the resizing on the bottom. */
    ImageResizeFocus["Bottom"] = "BOTTOM";
    /** Focus the resizing on the bottom left. */
    ImageResizeFocus["BottomLeft"] = "BOTTOM_LEFT";
    /** Focus the resizing on the bottom right. */
    ImageResizeFocus["BottomRight"] = "BOTTOM_RIGHT";
    /** Focus the resizing on the center. */
    ImageResizeFocus["Center"] = "CENTER";
    /** Focus the resizing on the largest face. */
    ImageResizeFocus["Face"] = "FACE";
    /** Focus the resizing on the area containing all the faces. */
    ImageResizeFocus["Faces"] = "FACES";
    /** Focus the resizing on the left. */
    ImageResizeFocus["Left"] = "LEFT";
    /** Focus the resizing on the right. */
    ImageResizeFocus["Right"] = "RIGHT";
    /** Focus the resizing on the top. */
    ImageResizeFocus["Top"] = "TOP";
    /** Focus the resizing on the top left. */
    ImageResizeFocus["TopLeft"] = "TOP_LEFT";
    /** Focus the resizing on the top right. */
    ImageResizeFocus["TopRight"] = "TOP_RIGHT";
})(ImageResizeFocus || (exports.ImageResizeFocus = ImageResizeFocus = {}));
var ImageResizeStrategy;
(function (ImageResizeStrategy) {
    /** Crops a part of the original image to fit into the specified dimensions. */
    ImageResizeStrategy["Crop"] = "CROP";
    /** Resizes the image to the specified dimensions, cropping the image if needed. */
    ImageResizeStrategy["Fill"] = "FILL";
    /** Resizes the image to fit into the specified dimensions. */
    ImageResizeStrategy["Fit"] = "FIT";
    /**
     * Resizes the image to the specified dimensions, padding the image if needed.
     *         Uses desired background color as padding color.
     */
    ImageResizeStrategy["Pad"] = "PAD";
    /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
    ImageResizeStrategy["Scale"] = "SCALE";
    /** Creates a thumbnail from the image. */
    ImageResizeStrategy["Thumb"] = "THUMB";
})(ImageResizeStrategy || (exports.ImageResizeStrategy = ImageResizeStrategy = {}));
var KeyValueLinkingCollectionsCaseStudyCollectionOrder;
(function (KeyValueLinkingCollectionsCaseStudyCollectionOrder) {
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorNameAsc"] = "featuredAuthorName_ASC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorNameDesc"] = "featuredAuthorName_DESC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorTitleAsc"] = "featuredAuthorTitle_ASC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorTitleDesc"] = "featuredAuthorTitle_DESC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["FeaturedLinkTextAsc"] = "featuredLinkText_ASC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["FeaturedLinkTextDesc"] = "featuredLinkText_DESC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["SlugAsc"] = "slug_ASC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["SlugDesc"] = "slug_DESC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["StatusAsc"] = "status_ASC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["StatusDesc"] = "status_DESC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["TitleAsc"] = "title_ASC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["TitleDesc"] = "title_DESC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["WhitepaperStandinAsc"] = "whitepaperStandin_ASC";
    KeyValueLinkingCollectionsCaseStudyCollectionOrder["WhitepaperStandinDesc"] = "whitepaperStandin_DESC";
})(KeyValueLinkingCollectionsCaseStudyCollectionOrder || (exports.KeyValueLinkingCollectionsCaseStudyCollectionOrder = KeyValueLinkingCollectionsCaseStudyCollectionOrder = {}));
var KeyValueLinkingCollectionsKeyValueSetCollectionOrder;
(function (KeyValueLinkingCollectionsKeyValueSetCollectionOrder) {
    KeyValueLinkingCollectionsKeyValueSetCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    KeyValueLinkingCollectionsKeyValueSetCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    KeyValueLinkingCollectionsKeyValueSetCollectionOrder["MakeswiftPageIdAsc"] = "makeswiftPageId_ASC";
    KeyValueLinkingCollectionsKeyValueSetCollectionOrder["MakeswiftPageIdDesc"] = "makeswiftPageId_DESC";
    KeyValueLinkingCollectionsKeyValueSetCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    KeyValueLinkingCollectionsKeyValueSetCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    KeyValueLinkingCollectionsKeyValueSetCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    KeyValueLinkingCollectionsKeyValueSetCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    KeyValueLinkingCollectionsKeyValueSetCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    KeyValueLinkingCollectionsKeyValueSetCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    KeyValueLinkingCollectionsKeyValueSetCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    KeyValueLinkingCollectionsKeyValueSetCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(KeyValueLinkingCollectionsKeyValueSetCollectionOrder || (exports.KeyValueLinkingCollectionsKeyValueSetCollectionOrder = KeyValueLinkingCollectionsKeyValueSetCollectionOrder = {}));
var KeyValueLinkingCollectionsResourceCollectionOrder;
(function (KeyValueLinkingCollectionsResourceCollectionOrder) {
    KeyValueLinkingCollectionsResourceCollectionOrder["FormButtonTextAsc"] = "formButtonText_ASC";
    KeyValueLinkingCollectionsResourceCollectionOrder["FormButtonTextDesc"] = "formButtonText_DESC";
    KeyValueLinkingCollectionsResourceCollectionOrder["FormIdAsc"] = "formId_ASC";
    KeyValueLinkingCollectionsResourceCollectionOrder["FormIdDesc"] = "formId_DESC";
    KeyValueLinkingCollectionsResourceCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    KeyValueLinkingCollectionsResourceCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    KeyValueLinkingCollectionsResourceCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    KeyValueLinkingCollectionsResourceCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    KeyValueLinkingCollectionsResourceCollectionOrder["SlugAsc"] = "slug_ASC";
    KeyValueLinkingCollectionsResourceCollectionOrder["SlugDesc"] = "slug_DESC";
    KeyValueLinkingCollectionsResourceCollectionOrder["StatusAsc"] = "status_ASC";
    KeyValueLinkingCollectionsResourceCollectionOrder["StatusDesc"] = "status_DESC";
    KeyValueLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    KeyValueLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    KeyValueLinkingCollectionsResourceCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    KeyValueLinkingCollectionsResourceCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    KeyValueLinkingCollectionsResourceCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    KeyValueLinkingCollectionsResourceCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    KeyValueLinkingCollectionsResourceCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    KeyValueLinkingCollectionsResourceCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    KeyValueLinkingCollectionsResourceCollectionOrder["TitleAsc"] = "title_ASC";
    KeyValueLinkingCollectionsResourceCollectionOrder["TitleDesc"] = "title_DESC";
    KeyValueLinkingCollectionsResourceCollectionOrder["TypeAsc"] = "type_ASC";
    KeyValueLinkingCollectionsResourceCollectionOrder["TypeDesc"] = "type_DESC";
})(KeyValueLinkingCollectionsResourceCollectionOrder || (exports.KeyValueLinkingCollectionsResourceCollectionOrder = KeyValueLinkingCollectionsResourceCollectionOrder = {}));
var KeyValueOrder;
(function (KeyValueOrder) {
    KeyValueOrder["KeyAsc"] = "key_ASC";
    KeyValueOrder["KeyDesc"] = "key_DESC";
    KeyValueOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    KeyValueOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    KeyValueOrder["SysIdAsc"] = "sys_id_ASC";
    KeyValueOrder["SysIdDesc"] = "sys_id_DESC";
    KeyValueOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    KeyValueOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    KeyValueOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    KeyValueOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    KeyValueOrder["ValueAsc"] = "value_ASC";
    KeyValueOrder["ValueDesc"] = "value_DESC";
})(KeyValueOrder || (exports.KeyValueOrder = KeyValueOrder = {}));
var KeyValueSetKeyValueCollectionOrder;
(function (KeyValueSetKeyValueCollectionOrder) {
    KeyValueSetKeyValueCollectionOrder["KeyAsc"] = "key_ASC";
    KeyValueSetKeyValueCollectionOrder["KeyDesc"] = "key_DESC";
    KeyValueSetKeyValueCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    KeyValueSetKeyValueCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    KeyValueSetKeyValueCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    KeyValueSetKeyValueCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    KeyValueSetKeyValueCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    KeyValueSetKeyValueCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    KeyValueSetKeyValueCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    KeyValueSetKeyValueCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    KeyValueSetKeyValueCollectionOrder["ValueAsc"] = "value_ASC";
    KeyValueSetKeyValueCollectionOrder["ValueDesc"] = "value_DESC";
})(KeyValueSetKeyValueCollectionOrder || (exports.KeyValueSetKeyValueCollectionOrder = KeyValueSetKeyValueCollectionOrder = {}));
var KeyValueSetOrder;
(function (KeyValueSetOrder) {
    KeyValueSetOrder["InternalNameAsc"] = "internalName_ASC";
    KeyValueSetOrder["InternalNameDesc"] = "internalName_DESC";
    KeyValueSetOrder["MakeswiftPageIdAsc"] = "makeswiftPageId_ASC";
    KeyValueSetOrder["MakeswiftPageIdDesc"] = "makeswiftPageId_DESC";
    KeyValueSetOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    KeyValueSetOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    KeyValueSetOrder["SysIdAsc"] = "sys_id_ASC";
    KeyValueSetOrder["SysIdDesc"] = "sys_id_DESC";
    KeyValueSetOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    KeyValueSetOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    KeyValueSetOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    KeyValueSetOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(KeyValueSetOrder || (exports.KeyValueSetOrder = KeyValueSetOrder = {}));
var MarketoFormOrder;
(function (MarketoFormOrder) {
    MarketoFormOrder["InternalNameAsc"] = "internalName_ASC";
    MarketoFormOrder["InternalNameDesc"] = "internalName_DESC";
    MarketoFormOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    MarketoFormOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    MarketoFormOrder["SysIdAsc"] = "sys_id_ASC";
    MarketoFormOrder["SysIdDesc"] = "sys_id_DESC";
    MarketoFormOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    MarketoFormOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    MarketoFormOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    MarketoFormOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(MarketoFormOrder || (exports.MarketoFormOrder = MarketoFormOrder = {}));
var MarketplaceAppAppFeaturesCollectionOrder;
(function (MarketplaceAppAppFeaturesCollectionOrder) {
    MarketplaceAppAppFeaturesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    MarketplaceAppAppFeaturesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    MarketplaceAppAppFeaturesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    MarketplaceAppAppFeaturesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    MarketplaceAppAppFeaturesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    MarketplaceAppAppFeaturesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    MarketplaceAppAppFeaturesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    MarketplaceAppAppFeaturesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    MarketplaceAppAppFeaturesCollectionOrder["TitleAsc"] = "title_ASC";
    MarketplaceAppAppFeaturesCollectionOrder["TitleDesc"] = "title_DESC";
})(MarketplaceAppAppFeaturesCollectionOrder || (exports.MarketplaceAppAppFeaturesCollectionOrder = MarketplaceAppAppFeaturesCollectionOrder = {}));
var MarketplaceAppCaseStudiesCollectionOrder;
(function (MarketplaceAppCaseStudiesCollectionOrder) {
    MarketplaceAppCaseStudiesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    MarketplaceAppCaseStudiesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    MarketplaceAppCaseStudiesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    MarketplaceAppCaseStudiesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    MarketplaceAppCaseStudiesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    MarketplaceAppCaseStudiesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    MarketplaceAppCaseStudiesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    MarketplaceAppCaseStudiesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    MarketplaceAppCaseStudiesCollectionOrder["TitleAsc"] = "title_ASC";
    MarketplaceAppCaseStudiesCollectionOrder["TitleDesc"] = "title_DESC";
    MarketplaceAppCaseStudiesCollectionOrder["UrlAsc"] = "url_ASC";
    MarketplaceAppCaseStudiesCollectionOrder["UrlDesc"] = "url_DESC";
})(MarketplaceAppCaseStudiesCollectionOrder || (exports.MarketplaceAppCaseStudiesCollectionOrder = MarketplaceAppCaseStudiesCollectionOrder = {}));
var MarketplaceAppCategoriesCollectionOrder;
(function (MarketplaceAppCategoriesCollectionOrder) {
    MarketplaceAppCategoriesCollectionOrder["NameAsc"] = "name_ASC";
    MarketplaceAppCategoriesCollectionOrder["NameDesc"] = "name_DESC";
    MarketplaceAppCategoriesCollectionOrder["SlugAsc"] = "slug_ASC";
    MarketplaceAppCategoriesCollectionOrder["SlugDesc"] = "slug_DESC";
    MarketplaceAppCategoriesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    MarketplaceAppCategoriesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    MarketplaceAppCategoriesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    MarketplaceAppCategoriesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    MarketplaceAppCategoriesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    MarketplaceAppCategoriesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    MarketplaceAppCategoriesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    MarketplaceAppCategoriesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(MarketplaceAppCategoriesCollectionOrder || (exports.MarketplaceAppCategoriesCollectionOrder = MarketplaceAppCategoriesCollectionOrder = {}));
var MarketplaceAppCollectionsCollectionOrder;
(function (MarketplaceAppCollectionsCollectionOrder) {
    MarketplaceAppCollectionsCollectionOrder["NameAsc"] = "name_ASC";
    MarketplaceAppCollectionsCollectionOrder["NameDesc"] = "name_DESC";
    MarketplaceAppCollectionsCollectionOrder["PrivateAsc"] = "private_ASC";
    MarketplaceAppCollectionsCollectionOrder["PrivateDesc"] = "private_DESC";
    MarketplaceAppCollectionsCollectionOrder["SlugAsc"] = "slug_ASC";
    MarketplaceAppCollectionsCollectionOrder["SlugDesc"] = "slug_DESC";
    MarketplaceAppCollectionsCollectionOrder["SortAsc"] = "sort_ASC";
    MarketplaceAppCollectionsCollectionOrder["SortDesc"] = "sort_DESC";
    MarketplaceAppCollectionsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    MarketplaceAppCollectionsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    MarketplaceAppCollectionsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    MarketplaceAppCollectionsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    MarketplaceAppCollectionsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    MarketplaceAppCollectionsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    MarketplaceAppCollectionsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    MarketplaceAppCollectionsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    MarketplaceAppCollectionsCollectionOrder["ThumbnailAsc"] = "thumbnail_ASC";
    MarketplaceAppCollectionsCollectionOrder["ThumbnailDesc"] = "thumbnail_DESC";
})(MarketplaceAppCollectionsCollectionOrder || (exports.MarketplaceAppCollectionsCollectionOrder = MarketplaceAppCollectionsCollectionOrder = {}));
var MarketplaceAppOrder;
(function (MarketplaceAppOrder) {
    MarketplaceAppOrder["AlternativeLogoAsc"] = "alternativeLogo_ASC";
    MarketplaceAppOrder["AlternativeLogoDesc"] = "alternativeLogo_DESC";
    MarketplaceAppOrder["AppRegistryIdAsc"] = "appRegistryId_ASC";
    MarketplaceAppOrder["AppRegistryIdDesc"] = "appRegistryId_DESC";
    MarketplaceAppOrder["AppRegistryUpdatedAtAsc"] = "appRegistryUpdatedAt_ASC";
    MarketplaceAppOrder["AppRegistryUpdatedAtDesc"] = "appRegistryUpdatedAt_DESC";
    MarketplaceAppOrder["ApprovedAtAsc"] = "approvedAt_ASC";
    MarketplaceAppOrder["ApprovedAtDesc"] = "approvedAt_DESC";
    MarketplaceAppOrder["AutomatedBillingAsc"] = "automatedBilling_ASC";
    MarketplaceAppOrder["AutomatedBillingDesc"] = "automatedBilling_DESC";
    MarketplaceAppOrder["CreatedOnAsc"] = "createdOn_ASC";
    MarketplaceAppOrder["CreatedOnDesc"] = "createdOn_DESC";
    MarketplaceAppOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    MarketplaceAppOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    MarketplaceAppOrder["FeaturedAsc"] = "featured_ASC";
    MarketplaceAppOrder["FeaturedDesc"] = "featured_DESC";
    MarketplaceAppOrder["FreeTrialDaysAsc"] = "freeTrialDays_ASC";
    MarketplaceAppOrder["FreeTrialDaysDesc"] = "freeTrialDays_DESC";
    MarketplaceAppOrder["FreeTrialAsc"] = "freeTrial_ASC";
    MarketplaceAppOrder["FreeTrialDesc"] = "freeTrial_DESC";
    MarketplaceAppOrder["InstallationGuideUrlAsc"] = "installationGuideUrl_ASC";
    MarketplaceAppOrder["InstallationGuideUrlDesc"] = "installationGuideUrl_DESC";
    MarketplaceAppOrder["InternalNameAsc"] = "internalName_ASC";
    MarketplaceAppOrder["InternalNameDesc"] = "internalName_DESC";
    MarketplaceAppOrder["LastHashAsc"] = "lastHash_ASC";
    MarketplaceAppOrder["LastHashDesc"] = "lastHash_DESC";
    MarketplaceAppOrder["LogoIconAsc"] = "logoIcon_ASC";
    MarketplaceAppOrder["LogoIconDesc"] = "logoIcon_DESC";
    MarketplaceAppOrder["LogoAsc"] = "logo_ASC";
    MarketplaceAppOrder["LogoDesc"] = "logo_DESC";
    MarketplaceAppOrder["MonthlyPriceAsc"] = "monthlyPrice_ASC";
    MarketplaceAppOrder["MonthlyPriceDesc"] = "monthlyPrice_DESC";
    MarketplaceAppOrder["MultiLocationAsc"] = "multiLocation_ASC";
    MarketplaceAppOrder["MultiLocationDesc"] = "multiLocation_DESC";
    MarketplaceAppOrder["MultiStorefrontAsc"] = "multiStorefront_ASC";
    MarketplaceAppOrder["MultiStorefrontDesc"] = "multiStorefront_DESC";
    MarketplaceAppOrder["NameAsc"] = "name_ASC";
    MarketplaceAppOrder["NameDesc"] = "name_DESC";
    MarketplaceAppOrder["PricingTypeAsc"] = "pricingType_ASC";
    MarketplaceAppOrder["PricingTypeDesc"] = "pricingType_DESC";
    MarketplaceAppOrder["PricingAsc"] = "pricing_ASC";
    MarketplaceAppOrder["PricingDesc"] = "pricing_DESC";
    MarketplaceAppOrder["RankAsc"] = "rank_ASC";
    MarketplaceAppOrder["RankDesc"] = "rank_DESC";
    MarketplaceAppOrder["RatingAsc"] = "rating_ASC";
    MarketplaceAppOrder["RatingDesc"] = "rating_DESC";
    MarketplaceAppOrder["RecommendedOrderAsc"] = "recommendedOrder_ASC";
    MarketplaceAppOrder["RecommendedOrderDesc"] = "recommendedOrder_DESC";
    MarketplaceAppOrder["RecommendedAsc"] = "recommended_ASC";
    MarketplaceAppOrder["RecommendedDesc"] = "recommended_DESC";
    MarketplaceAppOrder["ReviewCountAsc"] = "reviewCount_ASC";
    MarketplaceAppOrder["ReviewCountDesc"] = "reviewCount_DESC";
    MarketplaceAppOrder["SingleClickAsc"] = "singleClick_ASC";
    MarketplaceAppOrder["SingleClickDesc"] = "singleClick_DESC";
    MarketplaceAppOrder["SlugAsc"] = "slug_ASC";
    MarketplaceAppOrder["SlugDesc"] = "slug_DESC";
    MarketplaceAppOrder["SupportEmailAsc"] = "supportEmail_ASC";
    MarketplaceAppOrder["SupportEmailDesc"] = "supportEmail_DESC";
    MarketplaceAppOrder["SupportUrlAsc"] = "supportUrl_ASC";
    MarketplaceAppOrder["SupportUrlDesc"] = "supportUrl_DESC";
    MarketplaceAppOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    MarketplaceAppOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    MarketplaceAppOrder["SysIdAsc"] = "sys_id_ASC";
    MarketplaceAppOrder["SysIdDesc"] = "sys_id_DESC";
    MarketplaceAppOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    MarketplaceAppOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    MarketplaceAppOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    MarketplaceAppOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    MarketplaceAppOrder["TypeAsc"] = "type_ASC";
    MarketplaceAppOrder["TypeDesc"] = "type_DESC";
    MarketplaceAppOrder["UnifiedBillingAsc"] = "unifiedBilling_ASC";
    MarketplaceAppOrder["UnifiedBillingDesc"] = "unifiedBilling_DESC";
    MarketplaceAppOrder["UpfrontPriceAsc"] = "upfrontPrice_ASC";
    MarketplaceAppOrder["UpfrontPriceDesc"] = "upfrontPrice_DESC";
    MarketplaceAppOrder["UserGuideUrlAsc"] = "userGuideUrl_ASC";
    MarketplaceAppOrder["UserGuideUrlDesc"] = "userGuideUrl_DESC";
    MarketplaceAppOrder["VersionAsc"] = "version_ASC";
    MarketplaceAppOrder["VersionDesc"] = "version_DESC";
    MarketplaceAppOrder["WebsiteAsc"] = "website_ASC";
    MarketplaceAppOrder["WebsiteDesc"] = "website_DESC";
})(MarketplaceAppOrder || (exports.MarketplaceAppOrder = MarketplaceAppOrder = {}));
var MarketplaceThemeOrder;
(function (MarketplaceThemeOrder) {
    MarketplaceThemeOrder["ContactUrlAsc"] = "contactUrl_ASC";
    MarketplaceThemeOrder["ContactUrlDesc"] = "contactUrl_DESC";
    MarketplaceThemeOrder["DemoUrlAsc"] = "demoUrl_ASC";
    MarketplaceThemeOrder["DemoUrlDesc"] = "demoUrl_DESC";
    MarketplaceThemeOrder["DocumentationUrlAsc"] = "documentationUrl_ASC";
    MarketplaceThemeOrder["DocumentationUrlDesc"] = "documentationUrl_DESC";
    MarketplaceThemeOrder["ExternalIdAsc"] = "externalId_ASC";
    MarketplaceThemeOrder["ExternalIdDesc"] = "externalId_DESC";
    MarketplaceThemeOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    MarketplaceThemeOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    MarketplaceThemeOrder["InternalNameAsc"] = "internalName_ASC";
    MarketplaceThemeOrder["InternalNameDesc"] = "internalName_DESC";
    MarketplaceThemeOrder["LargePreviewAsc"] = "largePreview_ASC";
    MarketplaceThemeOrder["LargePreviewDesc"] = "largePreview_DESC";
    MarketplaceThemeOrder["LargeThumbnailAsc"] = "largeThumbnail_ASC";
    MarketplaceThemeOrder["LargeThumbnailDesc"] = "largeThumbnail_DESC";
    MarketplaceThemeOrder["LastHashAsc"] = "lastHash_ASC";
    MarketplaceThemeOrder["LastHashDesc"] = "lastHash_DESC";
    MarketplaceThemeOrder["MobilePreviewAsc"] = "mobilePreview_ASC";
    MarketplaceThemeOrder["MobilePreviewDesc"] = "mobilePreview_DESC";
    MarketplaceThemeOrder["PartnerEmailAsc"] = "partnerEmail_ASC";
    MarketplaceThemeOrder["PartnerEmailDesc"] = "partnerEmail_DESC";
    MarketplaceThemeOrder["PartnerIdAsc"] = "partnerId_ASC";
    MarketplaceThemeOrder["PartnerIdDesc"] = "partnerId_DESC";
    MarketplaceThemeOrder["PartnerNameAsc"] = "partnerName_ASC";
    MarketplaceThemeOrder["PartnerNameDesc"] = "partnerName_DESC";
    MarketplaceThemeOrder["PriceAsc"] = "price_ASC";
    MarketplaceThemeOrder["PriceDesc"] = "price_DESC";
    MarketplaceThemeOrder["PublishedDateAsc"] = "publishedDate_ASC";
    MarketplaceThemeOrder["PublishedDateDesc"] = "publishedDate_DESC";
    MarketplaceThemeOrder["RegistryIdAsc"] = "registryId_ASC";
    MarketplaceThemeOrder["RegistryIdDesc"] = "registryId_DESC";
    MarketplaceThemeOrder["SlugAsc"] = "slug_ASC";
    MarketplaceThemeOrder["SlugDesc"] = "slug_DESC";
    MarketplaceThemeOrder["SmallThumbnailAsc"] = "smallThumbnail_ASC";
    MarketplaceThemeOrder["SmallThumbnailDesc"] = "smallThumbnail_DESC";
    MarketplaceThemeOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    MarketplaceThemeOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    MarketplaceThemeOrder["SysIdAsc"] = "sys_id_ASC";
    MarketplaceThemeOrder["SysIdDesc"] = "sys_id_DESC";
    MarketplaceThemeOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    MarketplaceThemeOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    MarketplaceThemeOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    MarketplaceThemeOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    MarketplaceThemeOrder["ThemeDefaultConfigurationIdAsc"] = "themeDefaultConfigurationId_ASC";
    MarketplaceThemeOrder["ThemeDefaultConfigurationIdDesc"] = "themeDefaultConfigurationId_DESC";
    MarketplaceThemeOrder["ThemeIdAsc"] = "themeId_ASC";
    MarketplaceThemeOrder["ThemeIdDesc"] = "themeId_DESC";
    MarketplaceThemeOrder["TitleAsc"] = "title_ASC";
    MarketplaceThemeOrder["TitleDesc"] = "title_DESC";
    MarketplaceThemeOrder["VariationNameAsc"] = "variationName_ASC";
    MarketplaceThemeOrder["VariationNameDesc"] = "variationName_DESC";
    MarketplaceThemeOrder["VersionIdAsc"] = "versionId_ASC";
    MarketplaceThemeOrder["VersionIdDesc"] = "versionId_DESC";
})(MarketplaceThemeOrder || (exports.MarketplaceThemeOrder = MarketplaceThemeOrder = {}));
var MarketplaceThemeThemeIndustriesCollectionOrder;
(function (MarketplaceThemeThemeIndustriesCollectionOrder) {
    MarketplaceThemeThemeIndustriesCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    MarketplaceThemeThemeIndustriesCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    MarketplaceThemeThemeIndustriesCollectionOrder["NameAsc"] = "name_ASC";
    MarketplaceThemeThemeIndustriesCollectionOrder["NameDesc"] = "name_DESC";
    MarketplaceThemeThemeIndustriesCollectionOrder["SlugAsc"] = "slug_ASC";
    MarketplaceThemeThemeIndustriesCollectionOrder["SlugDesc"] = "slug_DESC";
    MarketplaceThemeThemeIndustriesCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    MarketplaceThemeThemeIndustriesCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    MarketplaceThemeThemeIndustriesCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    MarketplaceThemeThemeIndustriesCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    MarketplaceThemeThemeIndustriesCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    MarketplaceThemeThemeIndustriesCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    MarketplaceThemeThemeIndustriesCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    MarketplaceThemeThemeIndustriesCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    MarketplaceThemeThemeIndustriesCollectionOrder["TypeAsc"] = "type_ASC";
    MarketplaceThemeThemeIndustriesCollectionOrder["TypeDesc"] = "type_DESC";
})(MarketplaceThemeThemeIndustriesCollectionOrder || (exports.MarketplaceThemeThemeIndustriesCollectionOrder = MarketplaceThemeThemeIndustriesCollectionOrder = {}));
var PersonLinkingCollectionsArticleCollectionOrder;
(function (PersonLinkingCollectionsArticleCollectionOrder) {
    PersonLinkingCollectionsArticleCollectionOrder["EditStatusAsc"] = "editStatus_ASC";
    PersonLinkingCollectionsArticleCollectionOrder["EditStatusDesc"] = "editStatus_DESC";
    PersonLinkingCollectionsArticleCollectionOrder["FaqsHeadingAsc"] = "faqsHeading_ASC";
    PersonLinkingCollectionsArticleCollectionOrder["FaqsHeadingDesc"] = "faqsHeading_DESC";
    PersonLinkingCollectionsArticleCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    PersonLinkingCollectionsArticleCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    PersonLinkingCollectionsArticleCollectionOrder["InterstitialHeadlineAsc"] = "interstitialHeadline_ASC";
    PersonLinkingCollectionsArticleCollectionOrder["InterstitialHeadlineDesc"] = "interstitialHeadline_DESC";
    PersonLinkingCollectionsArticleCollectionOrder["PopularAsc"] = "popular_ASC";
    PersonLinkingCollectionsArticleCollectionOrder["PopularDesc"] = "popular_DESC";
    PersonLinkingCollectionsArticleCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    PersonLinkingCollectionsArticleCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    PersonLinkingCollectionsArticleCollectionOrder["SlugAsc"] = "slug_ASC";
    PersonLinkingCollectionsArticleCollectionOrder["SlugDesc"] = "slug_DESC";
    PersonLinkingCollectionsArticleCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PersonLinkingCollectionsArticleCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PersonLinkingCollectionsArticleCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PersonLinkingCollectionsArticleCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PersonLinkingCollectionsArticleCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PersonLinkingCollectionsArticleCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PersonLinkingCollectionsArticleCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PersonLinkingCollectionsArticleCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PersonLinkingCollectionsArticleCollectionOrder["TitleAsc"] = "title_ASC";
    PersonLinkingCollectionsArticleCollectionOrder["TitleDesc"] = "title_DESC";
})(PersonLinkingCollectionsArticleCollectionOrder || (exports.PersonLinkingCollectionsArticleCollectionOrder = PersonLinkingCollectionsArticleCollectionOrder = {}));
var PersonLinkingCollectionsBlogPostCollectionOrder;
(function (PersonLinkingCollectionsBlogPostCollectionOrder) {
    PersonLinkingCollectionsBlogPostCollectionOrder["HideOnHomepageAsc"] = "hideOnHomepage_ASC";
    PersonLinkingCollectionsBlogPostCollectionOrder["HideOnHomepageDesc"] = "hideOnHomepage_DESC";
    PersonLinkingCollectionsBlogPostCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    PersonLinkingCollectionsBlogPostCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    PersonLinkingCollectionsBlogPostCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    PersonLinkingCollectionsBlogPostCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    PersonLinkingCollectionsBlogPostCollectionOrder["ShowPostHeroAsc"] = "showPostHero_ASC";
    PersonLinkingCollectionsBlogPostCollectionOrder["ShowPostHeroDesc"] = "showPostHero_DESC";
    PersonLinkingCollectionsBlogPostCollectionOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    PersonLinkingCollectionsBlogPostCollectionOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    PersonLinkingCollectionsBlogPostCollectionOrder["SlugAsc"] = "slug_ASC";
    PersonLinkingCollectionsBlogPostCollectionOrder["SlugDesc"] = "slug_DESC";
    PersonLinkingCollectionsBlogPostCollectionOrder["StatusAsc"] = "status_ASC";
    PersonLinkingCollectionsBlogPostCollectionOrder["StatusDesc"] = "status_DESC";
    PersonLinkingCollectionsBlogPostCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PersonLinkingCollectionsBlogPostCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PersonLinkingCollectionsBlogPostCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    PersonLinkingCollectionsBlogPostCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    PersonLinkingCollectionsBlogPostCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PersonLinkingCollectionsBlogPostCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PersonLinkingCollectionsBlogPostCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PersonLinkingCollectionsBlogPostCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PersonLinkingCollectionsBlogPostCollectionOrder["TitleAsc"] = "title_ASC";
    PersonLinkingCollectionsBlogPostCollectionOrder["TitleDesc"] = "title_DESC";
})(PersonLinkingCollectionsBlogPostCollectionOrder || (exports.PersonLinkingCollectionsBlogPostCollectionOrder = PersonLinkingCollectionsBlogPostCollectionOrder = {}));
var PersonOrder;
(function (PersonOrder) {
    PersonOrder["EmailAsc"] = "email_ASC";
    PersonOrder["EmailDesc"] = "email_DESC";
    PersonOrder["EnabledAsc"] = "enabled_ASC";
    PersonOrder["EnabledDesc"] = "enabled_DESC";
    PersonOrder["FullNameAsc"] = "fullName_ASC";
    PersonOrder["FullNameDesc"] = "fullName_DESC";
    PersonOrder["JobTitleAsc"] = "jobTitle_ASC";
    PersonOrder["JobTitleDesc"] = "jobTitle_DESC";
    PersonOrder["LinkedUrlAsc"] = "linkedUrl_ASC";
    PersonOrder["LinkedUrlDesc"] = "linkedUrl_DESC";
    PersonOrder["SlugAsc"] = "slug_ASC";
    PersonOrder["SlugDesc"] = "slug_DESC";
    PersonOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PersonOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PersonOrder["SysIdAsc"] = "sys_id_ASC";
    PersonOrder["SysIdDesc"] = "sys_id_DESC";
    PersonOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PersonOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PersonOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PersonOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PersonOrder["TypeAsc"] = "type_ASC";
    PersonOrder["TypeDesc"] = "type_DESC";
})(PersonOrder || (exports.PersonOrder = PersonOrder = {}));
var PressOrder;
(function (PressOrder) {
    PressOrder["EnabledAsc"] = "enabled_ASC";
    PressOrder["EnabledDesc"] = "enabled_DESC";
    PressOrder["FeaturedAsc"] = "featured_ASC";
    PressOrder["FeaturedDesc"] = "featured_DESC";
    PressOrder["InternalNameAsc"] = "internalName_ASC";
    PressOrder["InternalNameDesc"] = "internalName_DESC";
    PressOrder["PublishedDateAsc"] = "publishedDate_ASC";
    PressOrder["PublishedDateDesc"] = "publishedDate_DESC";
    PressOrder["SlugAsc"] = "slug_ASC";
    PressOrder["SlugDesc"] = "slug_DESC";
    PressOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    PressOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    PressOrder["SysIdAsc"] = "sys_id_ASC";
    PressOrder["SysIdDesc"] = "sys_id_DESC";
    PressOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    PressOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    PressOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    PressOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    PressOrder["TitleAsc"] = "title_ASC";
    PressOrder["TitleDesc"] = "title_DESC";
    PressOrder["TypeAsc"] = "type_ASC";
    PressOrder["TypeDesc"] = "type_DESC";
})(PressOrder || (exports.PressOrder = PressOrder = {}));
var RedirectOrder;
(function (RedirectOrder) {
    RedirectOrder["DestinationUrlAsc"] = "destinationUrl_ASC";
    RedirectOrder["DestinationUrlDesc"] = "destinationUrl_DESC";
    RedirectOrder["SourceUrlAsc"] = "sourceUrl_ASC";
    RedirectOrder["SourceUrlDesc"] = "sourceUrl_DESC";
    RedirectOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RedirectOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RedirectOrder["SysIdAsc"] = "sys_id_ASC";
    RedirectOrder["SysIdDesc"] = "sys_id_DESC";
    RedirectOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RedirectOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RedirectOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RedirectOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(RedirectOrder || (exports.RedirectOrder = RedirectOrder = {}));
var ResourceLinkingCollectionsResourceCollectionOrder;
(function (ResourceLinkingCollectionsResourceCollectionOrder) {
    ResourceLinkingCollectionsResourceCollectionOrder["FormButtonTextAsc"] = "formButtonText_ASC";
    ResourceLinkingCollectionsResourceCollectionOrder["FormButtonTextDesc"] = "formButtonText_DESC";
    ResourceLinkingCollectionsResourceCollectionOrder["FormIdAsc"] = "formId_ASC";
    ResourceLinkingCollectionsResourceCollectionOrder["FormIdDesc"] = "formId_DESC";
    ResourceLinkingCollectionsResourceCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ResourceLinkingCollectionsResourceCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ResourceLinkingCollectionsResourceCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    ResourceLinkingCollectionsResourceCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    ResourceLinkingCollectionsResourceCollectionOrder["SlugAsc"] = "slug_ASC";
    ResourceLinkingCollectionsResourceCollectionOrder["SlugDesc"] = "slug_DESC";
    ResourceLinkingCollectionsResourceCollectionOrder["StatusAsc"] = "status_ASC";
    ResourceLinkingCollectionsResourceCollectionOrder["StatusDesc"] = "status_DESC";
    ResourceLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ResourceLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ResourceLinkingCollectionsResourceCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ResourceLinkingCollectionsResourceCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ResourceLinkingCollectionsResourceCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ResourceLinkingCollectionsResourceCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ResourceLinkingCollectionsResourceCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ResourceLinkingCollectionsResourceCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ResourceLinkingCollectionsResourceCollectionOrder["TitleAsc"] = "title_ASC";
    ResourceLinkingCollectionsResourceCollectionOrder["TitleDesc"] = "title_DESC";
    ResourceLinkingCollectionsResourceCollectionOrder["TypeAsc"] = "type_ASC";
    ResourceLinkingCollectionsResourceCollectionOrder["TypeDesc"] = "type_DESC";
})(ResourceLinkingCollectionsResourceCollectionOrder || (exports.ResourceLinkingCollectionsResourceCollectionOrder = ResourceLinkingCollectionsResourceCollectionOrder = {}));
var ResourceOrder;
(function (ResourceOrder) {
    ResourceOrder["FormButtonTextAsc"] = "formButtonText_ASC";
    ResourceOrder["FormButtonTextDesc"] = "formButtonText_DESC";
    ResourceOrder["FormIdAsc"] = "formId_ASC";
    ResourceOrder["FormIdDesc"] = "formId_DESC";
    ResourceOrder["InternalNameAsc"] = "internalName_ASC";
    ResourceOrder["InternalNameDesc"] = "internalName_DESC";
    ResourceOrder["PublishedDateAsc"] = "publishedDate_ASC";
    ResourceOrder["PublishedDateDesc"] = "publishedDate_DESC";
    ResourceOrder["SlugAsc"] = "slug_ASC";
    ResourceOrder["SlugDesc"] = "slug_DESC";
    ResourceOrder["StatusAsc"] = "status_ASC";
    ResourceOrder["StatusDesc"] = "status_DESC";
    ResourceOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ResourceOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ResourceOrder["SysIdAsc"] = "sys_id_ASC";
    ResourceOrder["SysIdDesc"] = "sys_id_DESC";
    ResourceOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ResourceOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ResourceOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ResourceOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ResourceOrder["TitleAsc"] = "title_ASC";
    ResourceOrder["TitleDesc"] = "title_DESC";
    ResourceOrder["TypeAsc"] = "type_ASC";
    ResourceOrder["TypeDesc"] = "type_DESC";
})(ResourceOrder || (exports.ResourceOrder = ResourceOrder = {}));
var ResourceSpeakersCollectionOrder;
(function (ResourceSpeakersCollectionOrder) {
    ResourceSpeakersCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ResourceSpeakersCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ResourceSpeakersCollectionOrder["JobTitleAsc"] = "jobTitle_ASC";
    ResourceSpeakersCollectionOrder["JobTitleDesc"] = "jobTitle_DESC";
    ResourceSpeakersCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ResourceSpeakersCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ResourceSpeakersCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ResourceSpeakersCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ResourceSpeakersCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ResourceSpeakersCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ResourceSpeakersCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ResourceSpeakersCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ResourceSpeakersCollectionOrder || (exports.ResourceSpeakersCollectionOrder = ResourceSpeakersCollectionOrder = {}));
var ResourceStatsCollectionOrder;
(function (ResourceStatsCollectionOrder) {
    ResourceStatsCollectionOrder["KeyAsc"] = "key_ASC";
    ResourceStatsCollectionOrder["KeyDesc"] = "key_DESC";
    ResourceStatsCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ResourceStatsCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ResourceStatsCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ResourceStatsCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ResourceStatsCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ResourceStatsCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ResourceStatsCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ResourceStatsCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ResourceStatsCollectionOrder["ValueAsc"] = "value_ASC";
    ResourceStatsCollectionOrder["ValueDesc"] = "value_DESC";
})(ResourceStatsCollectionOrder || (exports.ResourceStatsCollectionOrder = ResourceStatsCollectionOrder = {}));
var RichTextWrapperOrder;
(function (RichTextWrapperOrder) {
    RichTextWrapperOrder["InternalNameAsc"] = "internalName_ASC";
    RichTextWrapperOrder["InternalNameDesc"] = "internalName_DESC";
    RichTextWrapperOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RichTextWrapperOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RichTextWrapperOrder["SysIdAsc"] = "sys_id_ASC";
    RichTextWrapperOrder["SysIdDesc"] = "sys_id_DESC";
    RichTextWrapperOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RichTextWrapperOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RichTextWrapperOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RichTextWrapperOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    RichTextWrapperOrder["TypeAsc"] = "type_ASC";
    RichTextWrapperOrder["TypeDesc"] = "type_DESC";
})(RichTextWrapperOrder || (exports.RichTextWrapperOrder = RichTextWrapperOrder = {}));
var RobotsOrder;
(function (RobotsOrder) {
    RobotsOrder["InternalNameAsc"] = "internalName_ASC";
    RobotsOrder["InternalNameDesc"] = "internalName_DESC";
    RobotsOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    RobotsOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    RobotsOrder["SysIdAsc"] = "sys_id_ASC";
    RobotsOrder["SysIdDesc"] = "sys_id_DESC";
    RobotsOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    RobotsOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    RobotsOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    RobotsOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(RobotsOrder || (exports.RobotsOrder = RobotsOrder = {}));
var SeoMetadataLinkingCollectionsAppCollectionCollectionOrder;
(function (SeoMetadataLinkingCollectionsAppCollectionCollectionOrder) {
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["NameAsc"] = "name_ASC";
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["NameDesc"] = "name_DESC";
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["PrivateAsc"] = "private_ASC";
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["PrivateDesc"] = "private_DESC";
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["SlugAsc"] = "slug_ASC";
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["SlugDesc"] = "slug_DESC";
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["SortAsc"] = "sort_ASC";
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["SortDesc"] = "sort_DESC";
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["ThumbnailAsc"] = "thumbnail_ASC";
    SeoMetadataLinkingCollectionsAppCollectionCollectionOrder["ThumbnailDesc"] = "thumbnail_DESC";
})(SeoMetadataLinkingCollectionsAppCollectionCollectionOrder || (exports.SeoMetadataLinkingCollectionsAppCollectionCollectionOrder = SeoMetadataLinkingCollectionsAppCollectionCollectionOrder = {}));
var SeoMetadataLinkingCollectionsAppTierCollectionOrder;
(function (SeoMetadataLinkingCollectionsAppTierCollectionOrder) {
    SeoMetadataLinkingCollectionsAppTierCollectionOrder["NameAsc"] = "name_ASC";
    SeoMetadataLinkingCollectionsAppTierCollectionOrder["NameDesc"] = "name_DESC";
    SeoMetadataLinkingCollectionsAppTierCollectionOrder["SlugAsc"] = "slug_ASC";
    SeoMetadataLinkingCollectionsAppTierCollectionOrder["SlugDesc"] = "slug_DESC";
    SeoMetadataLinkingCollectionsAppTierCollectionOrder["SortAsc"] = "sort_ASC";
    SeoMetadataLinkingCollectionsAppTierCollectionOrder["SortDesc"] = "sort_DESC";
    SeoMetadataLinkingCollectionsAppTierCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SeoMetadataLinkingCollectionsAppTierCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SeoMetadataLinkingCollectionsAppTierCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SeoMetadataLinkingCollectionsAppTierCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SeoMetadataLinkingCollectionsAppTierCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SeoMetadataLinkingCollectionsAppTierCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SeoMetadataLinkingCollectionsAppTierCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SeoMetadataLinkingCollectionsAppTierCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(SeoMetadataLinkingCollectionsAppTierCollectionOrder || (exports.SeoMetadataLinkingCollectionsAppTierCollectionOrder = SeoMetadataLinkingCollectionsAppTierCollectionOrder = {}));
var SeoMetadataLinkingCollectionsArticleCollectionOrder;
(function (SeoMetadataLinkingCollectionsArticleCollectionOrder) {
    SeoMetadataLinkingCollectionsArticleCollectionOrder["EditStatusAsc"] = "editStatus_ASC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["EditStatusDesc"] = "editStatus_DESC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["FaqsHeadingAsc"] = "faqsHeading_ASC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["FaqsHeadingDesc"] = "faqsHeading_DESC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["InterstitialHeadlineAsc"] = "interstitialHeadline_ASC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["InterstitialHeadlineDesc"] = "interstitialHeadline_DESC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["PopularAsc"] = "popular_ASC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["PopularDesc"] = "popular_DESC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["SlugAsc"] = "slug_ASC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["SlugDesc"] = "slug_DESC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["TitleAsc"] = "title_ASC";
    SeoMetadataLinkingCollectionsArticleCollectionOrder["TitleDesc"] = "title_DESC";
})(SeoMetadataLinkingCollectionsArticleCollectionOrder || (exports.SeoMetadataLinkingCollectionsArticleCollectionOrder = SeoMetadataLinkingCollectionsArticleCollectionOrder = {}));
var SeoMetadataLinkingCollectionsBlogPostCollectionOrder;
(function (SeoMetadataLinkingCollectionsBlogPostCollectionOrder) {
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["HideOnHomepageAsc"] = "hideOnHomepage_ASC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["HideOnHomepageDesc"] = "hideOnHomepage_DESC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["ShowPostHeroAsc"] = "showPostHero_ASC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["ShowPostHeroDesc"] = "showPostHero_DESC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["SlugAsc"] = "slug_ASC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["SlugDesc"] = "slug_DESC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["StatusAsc"] = "status_ASC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["StatusDesc"] = "status_DESC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["TitleAsc"] = "title_ASC";
    SeoMetadataLinkingCollectionsBlogPostCollectionOrder["TitleDesc"] = "title_DESC";
})(SeoMetadataLinkingCollectionsBlogPostCollectionOrder || (exports.SeoMetadataLinkingCollectionsBlogPostCollectionOrder = SeoMetadataLinkingCollectionsBlogPostCollectionOrder = {}));
var SeoMetadataLinkingCollectionsCaseStudyCollectionOrder;
(function (SeoMetadataLinkingCollectionsCaseStudyCollectionOrder) {
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorNameAsc"] = "featuredAuthorName_ASC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorNameDesc"] = "featuredAuthorName_DESC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorTitleAsc"] = "featuredAuthorTitle_ASC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["FeaturedAuthorTitleDesc"] = "featuredAuthorTitle_DESC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["FeaturedLinkTextAsc"] = "featuredLinkText_ASC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["FeaturedLinkTextDesc"] = "featuredLinkText_DESC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["SlugAsc"] = "slug_ASC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["SlugDesc"] = "slug_DESC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["StatusAsc"] = "status_ASC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["StatusDesc"] = "status_DESC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["TitleAsc"] = "title_ASC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["TitleDesc"] = "title_DESC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["WhitepaperStandinAsc"] = "whitepaperStandin_ASC";
    SeoMetadataLinkingCollectionsCaseStudyCollectionOrder["WhitepaperStandinDesc"] = "whitepaperStandin_DESC";
})(SeoMetadataLinkingCollectionsCaseStudyCollectionOrder || (exports.SeoMetadataLinkingCollectionsCaseStudyCollectionOrder = SeoMetadataLinkingCollectionsCaseStudyCollectionOrder = {}));
var SeoMetadataLinkingCollectionsCategoryCollectionOrder;
(function (SeoMetadataLinkingCollectionsCategoryCollectionOrder) {
    SeoMetadataLinkingCollectionsCategoryCollectionOrder["NameAsc"] = "name_ASC";
    SeoMetadataLinkingCollectionsCategoryCollectionOrder["NameDesc"] = "name_DESC";
    SeoMetadataLinkingCollectionsCategoryCollectionOrder["SlugAsc"] = "slug_ASC";
    SeoMetadataLinkingCollectionsCategoryCollectionOrder["SlugDesc"] = "slug_DESC";
    SeoMetadataLinkingCollectionsCategoryCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SeoMetadataLinkingCollectionsCategoryCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SeoMetadataLinkingCollectionsCategoryCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SeoMetadataLinkingCollectionsCategoryCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SeoMetadataLinkingCollectionsCategoryCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SeoMetadataLinkingCollectionsCategoryCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SeoMetadataLinkingCollectionsCategoryCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SeoMetadataLinkingCollectionsCategoryCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(SeoMetadataLinkingCollectionsCategoryCollectionOrder || (exports.SeoMetadataLinkingCollectionsCategoryCollectionOrder = SeoMetadataLinkingCollectionsCategoryCollectionOrder = {}));
var SeoMetadataLinkingCollectionsGlossaryCollectionOrder;
(function (SeoMetadataLinkingCollectionsGlossaryCollectionOrder) {
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["EnabledAsc"] = "enabled_ASC";
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["EnabledDesc"] = "enabled_DESC";
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["SlugAsc"] = "slug_ASC";
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["SlugDesc"] = "slug_DESC";
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["TitleAsc"] = "title_ASC";
    SeoMetadataLinkingCollectionsGlossaryCollectionOrder["TitleDesc"] = "title_DESC";
})(SeoMetadataLinkingCollectionsGlossaryCollectionOrder || (exports.SeoMetadataLinkingCollectionsGlossaryCollectionOrder = SeoMetadataLinkingCollectionsGlossaryCollectionOrder = {}));
var SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder;
(function (SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder) {
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["AlternativeLogoAsc"] = "alternativeLogo_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["AlternativeLogoDesc"] = "alternativeLogo_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryIdAsc"] = "appRegistryId_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryIdDesc"] = "appRegistryId_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryUpdatedAtAsc"] = "appRegistryUpdatedAt_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["AppRegistryUpdatedAtDesc"] = "appRegistryUpdatedAt_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["ApprovedAtAsc"] = "approvedAt_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["ApprovedAtDesc"] = "approvedAt_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["AutomatedBillingAsc"] = "automatedBilling_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["AutomatedBillingDesc"] = "automatedBilling_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["CreatedOnAsc"] = "createdOn_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["CreatedOnDesc"] = "createdOn_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedAsc"] = "featured_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["FeaturedDesc"] = "featured_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDaysAsc"] = "freeTrialDays_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDaysDesc"] = "freeTrialDays_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialAsc"] = "freeTrial_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["FreeTrialDesc"] = "freeTrial_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["InstallationGuideUrlAsc"] = "installationGuideUrl_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["InstallationGuideUrlDesc"] = "installationGuideUrl_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["LastHashAsc"] = "lastHash_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["LastHashDesc"] = "lastHash_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["LogoIconAsc"] = "logoIcon_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["LogoIconDesc"] = "logoIcon_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["LogoAsc"] = "logo_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["LogoDesc"] = "logo_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["MonthlyPriceAsc"] = "monthlyPrice_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["MonthlyPriceDesc"] = "monthlyPrice_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["MultiLocationAsc"] = "multiLocation_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["MultiLocationDesc"] = "multiLocation_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["MultiStorefrontAsc"] = "multiStorefront_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["MultiStorefrontDesc"] = "multiStorefront_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["NameAsc"] = "name_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["NameDesc"] = "name_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["PricingTypeAsc"] = "pricingType_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["PricingTypeDesc"] = "pricingType_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["PricingAsc"] = "pricing_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["PricingDesc"] = "pricing_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["RankAsc"] = "rank_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["RankDesc"] = "rank_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["RatingAsc"] = "rating_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["RatingDesc"] = "rating_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedOrderAsc"] = "recommendedOrder_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedOrderDesc"] = "recommendedOrder_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedAsc"] = "recommended_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["RecommendedDesc"] = "recommended_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["ReviewCountAsc"] = "reviewCount_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["ReviewCountDesc"] = "reviewCount_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["SingleClickAsc"] = "singleClick_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["SingleClickDesc"] = "singleClick_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["SlugAsc"] = "slug_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["SlugDesc"] = "slug_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["SupportEmailAsc"] = "supportEmail_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["SupportEmailDesc"] = "supportEmail_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["SupportUrlAsc"] = "supportUrl_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["SupportUrlDesc"] = "supportUrl_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["TypeAsc"] = "type_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["TypeDesc"] = "type_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["UnifiedBillingAsc"] = "unifiedBilling_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["UnifiedBillingDesc"] = "unifiedBilling_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["UpfrontPriceAsc"] = "upfrontPrice_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["UpfrontPriceDesc"] = "upfrontPrice_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["UserGuideUrlAsc"] = "userGuideUrl_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["UserGuideUrlDesc"] = "userGuideUrl_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["VersionAsc"] = "version_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["VersionDesc"] = "version_DESC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["WebsiteAsc"] = "website_ASC";
    SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder["WebsiteDesc"] = "website_DESC";
})(SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder || (exports.SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder = SeoMetadataLinkingCollectionsMarketplaceAppCollectionOrder = {}));
var SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder;
(function (SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder) {
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["ContactUrlAsc"] = "contactUrl_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["ContactUrlDesc"] = "contactUrl_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["DemoUrlAsc"] = "demoUrl_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["DemoUrlDesc"] = "demoUrl_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["DocumentationUrlAsc"] = "documentationUrl_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["DocumentationUrlDesc"] = "documentationUrl_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["ExternalIdAsc"] = "externalId_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["ExternalIdDesc"] = "externalId_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["LargePreviewAsc"] = "largePreview_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["LargePreviewDesc"] = "largePreview_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["LargeThumbnailAsc"] = "largeThumbnail_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["LargeThumbnailDesc"] = "largeThumbnail_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["LastHashAsc"] = "lastHash_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["LastHashDesc"] = "lastHash_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["MobilePreviewAsc"] = "mobilePreview_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["MobilePreviewDesc"] = "mobilePreview_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["PartnerEmailAsc"] = "partnerEmail_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["PartnerEmailDesc"] = "partnerEmail_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["PartnerIdAsc"] = "partnerId_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["PartnerIdDesc"] = "partnerId_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["PartnerNameAsc"] = "partnerName_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["PartnerNameDesc"] = "partnerName_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["PriceAsc"] = "price_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["PriceDesc"] = "price_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["RegistryIdAsc"] = "registryId_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["RegistryIdDesc"] = "registryId_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["SlugAsc"] = "slug_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["SlugDesc"] = "slug_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["SmallThumbnailAsc"] = "smallThumbnail_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["SmallThumbnailDesc"] = "smallThumbnail_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["ThemeDefaultConfigurationIdAsc"] = "themeDefaultConfigurationId_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["ThemeDefaultConfigurationIdDesc"] = "themeDefaultConfigurationId_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["ThemeIdAsc"] = "themeId_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["ThemeIdDesc"] = "themeId_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["TitleAsc"] = "title_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["TitleDesc"] = "title_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["VariationNameAsc"] = "variationName_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["VariationNameDesc"] = "variationName_DESC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["VersionIdAsc"] = "versionId_ASC";
    SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder["VersionIdDesc"] = "versionId_DESC";
})(SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder || (exports.SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder = SeoMetadataLinkingCollectionsMarketplaceThemeCollectionOrder = {}));
var SeoMetadataLinkingCollectionsPersonCollectionOrder;
(function (SeoMetadataLinkingCollectionsPersonCollectionOrder) {
    SeoMetadataLinkingCollectionsPersonCollectionOrder["EmailAsc"] = "email_ASC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["EmailDesc"] = "email_DESC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["EnabledAsc"] = "enabled_ASC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["EnabledDesc"] = "enabled_DESC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["FullNameAsc"] = "fullName_ASC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["FullNameDesc"] = "fullName_DESC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["JobTitleAsc"] = "jobTitle_ASC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["JobTitleDesc"] = "jobTitle_DESC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["LinkedUrlAsc"] = "linkedUrl_ASC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["LinkedUrlDesc"] = "linkedUrl_DESC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["SlugAsc"] = "slug_ASC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["SlugDesc"] = "slug_DESC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["TypeAsc"] = "type_ASC";
    SeoMetadataLinkingCollectionsPersonCollectionOrder["TypeDesc"] = "type_DESC";
})(SeoMetadataLinkingCollectionsPersonCollectionOrder || (exports.SeoMetadataLinkingCollectionsPersonCollectionOrder = SeoMetadataLinkingCollectionsPersonCollectionOrder = {}));
var SeoMetadataLinkingCollectionsPressCollectionOrder;
(function (SeoMetadataLinkingCollectionsPressCollectionOrder) {
    SeoMetadataLinkingCollectionsPressCollectionOrder["EnabledAsc"] = "enabled_ASC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["EnabledDesc"] = "enabled_DESC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["FeaturedAsc"] = "featured_ASC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["FeaturedDesc"] = "featured_DESC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["SlugAsc"] = "slug_ASC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["SlugDesc"] = "slug_DESC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["TitleAsc"] = "title_ASC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["TitleDesc"] = "title_DESC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["TypeAsc"] = "type_ASC";
    SeoMetadataLinkingCollectionsPressCollectionOrder["TypeDesc"] = "type_DESC";
})(SeoMetadataLinkingCollectionsPressCollectionOrder || (exports.SeoMetadataLinkingCollectionsPressCollectionOrder = SeoMetadataLinkingCollectionsPressCollectionOrder = {}));
var SeoMetadataLinkingCollectionsResourceCollectionOrder;
(function (SeoMetadataLinkingCollectionsResourceCollectionOrder) {
    SeoMetadataLinkingCollectionsResourceCollectionOrder["FormButtonTextAsc"] = "formButtonText_ASC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["FormButtonTextDesc"] = "formButtonText_DESC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["FormIdAsc"] = "formId_ASC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["FormIdDesc"] = "formId_DESC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["SlugAsc"] = "slug_ASC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["SlugDesc"] = "slug_DESC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["StatusAsc"] = "status_ASC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["StatusDesc"] = "status_DESC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["TitleAsc"] = "title_ASC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["TitleDesc"] = "title_DESC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["TypeAsc"] = "type_ASC";
    SeoMetadataLinkingCollectionsResourceCollectionOrder["TypeDesc"] = "type_DESC";
})(SeoMetadataLinkingCollectionsResourceCollectionOrder || (exports.SeoMetadataLinkingCollectionsResourceCollectionOrder = SeoMetadataLinkingCollectionsResourceCollectionOrder = {}));
var SeoMetadataLinkingCollectionsThemePropertyCollectionOrder;
(function (SeoMetadataLinkingCollectionsThemePropertyCollectionOrder) {
    SeoMetadataLinkingCollectionsThemePropertyCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    SeoMetadataLinkingCollectionsThemePropertyCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    SeoMetadataLinkingCollectionsThemePropertyCollectionOrder["NameAsc"] = "name_ASC";
    SeoMetadataLinkingCollectionsThemePropertyCollectionOrder["NameDesc"] = "name_DESC";
    SeoMetadataLinkingCollectionsThemePropertyCollectionOrder["SlugAsc"] = "slug_ASC";
    SeoMetadataLinkingCollectionsThemePropertyCollectionOrder["SlugDesc"] = "slug_DESC";
    SeoMetadataLinkingCollectionsThemePropertyCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SeoMetadataLinkingCollectionsThemePropertyCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SeoMetadataLinkingCollectionsThemePropertyCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SeoMetadataLinkingCollectionsThemePropertyCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SeoMetadataLinkingCollectionsThemePropertyCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SeoMetadataLinkingCollectionsThemePropertyCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SeoMetadataLinkingCollectionsThemePropertyCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SeoMetadataLinkingCollectionsThemePropertyCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SeoMetadataLinkingCollectionsThemePropertyCollectionOrder["TypeAsc"] = "type_ASC";
    SeoMetadataLinkingCollectionsThemePropertyCollectionOrder["TypeDesc"] = "type_DESC";
})(SeoMetadataLinkingCollectionsThemePropertyCollectionOrder || (exports.SeoMetadataLinkingCollectionsThemePropertyCollectionOrder = SeoMetadataLinkingCollectionsThemePropertyCollectionOrder = {}));
var SeoMetadataOrder;
(function (SeoMetadataOrder) {
    SeoMetadataOrder["CanonicalUrlAsc"] = "canonicalUrl_ASC";
    SeoMetadataOrder["CanonicalUrlDesc"] = "canonicalUrl_DESC";
    SeoMetadataOrder["IncludeTitleTemplateAsc"] = "includeTitleTemplate_ASC";
    SeoMetadataOrder["IncludeTitleTemplateDesc"] = "includeTitleTemplate_DESC";
    SeoMetadataOrder["InternalNameAsc"] = "internalName_ASC";
    SeoMetadataOrder["InternalNameDesc"] = "internalName_DESC";
    SeoMetadataOrder["NofollowAsc"] = "nofollow_ASC";
    SeoMetadataOrder["NofollowDesc"] = "nofollow_DESC";
    SeoMetadataOrder["NoindexAsc"] = "noindex_ASC";
    SeoMetadataOrder["NoindexDesc"] = "noindex_DESC";
    SeoMetadataOrder["ReadingTimeAsc"] = "readingTime_ASC";
    SeoMetadataOrder["ReadingTimeDesc"] = "readingTime_DESC";
    SeoMetadataOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SeoMetadataOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SeoMetadataOrder["SysIdAsc"] = "sys_id_ASC";
    SeoMetadataOrder["SysIdDesc"] = "sys_id_DESC";
    SeoMetadataOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SeoMetadataOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SeoMetadataOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SeoMetadataOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SeoMetadataOrder["TitleAsc"] = "title_ASC";
    SeoMetadataOrder["TitleDesc"] = "title_DESC";
})(SeoMetadataOrder || (exports.SeoMetadataOrder = SeoMetadataOrder = {}));
var ShowcaseCategoryCollectionOrder;
(function (ShowcaseCategoryCollectionOrder) {
    ShowcaseCategoryCollectionOrder["NameAsc"] = "name_ASC";
    ShowcaseCategoryCollectionOrder["NameDesc"] = "name_DESC";
    ShowcaseCategoryCollectionOrder["SlugAsc"] = "slug_ASC";
    ShowcaseCategoryCollectionOrder["SlugDesc"] = "slug_DESC";
    ShowcaseCategoryCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ShowcaseCategoryCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ShowcaseCategoryCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ShowcaseCategoryCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ShowcaseCategoryCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ShowcaseCategoryCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ShowcaseCategoryCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ShowcaseCategoryCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(ShowcaseCategoryCollectionOrder || (exports.ShowcaseCategoryCollectionOrder = ShowcaseCategoryCollectionOrder = {}));
var ShowcaseOrder;
(function (ShowcaseOrder) {
    ShowcaseOrder["FeaturedAsc"] = "featured_ASC";
    ShowcaseOrder["FeaturedDesc"] = "featured_DESC";
    ShowcaseOrder["InternalNameAsc"] = "internalName_ASC";
    ShowcaseOrder["InternalNameDesc"] = "internalName_DESC";
    ShowcaseOrder["SlugAsc"] = "slug_ASC";
    ShowcaseOrder["SlugDesc"] = "slug_DESC";
    ShowcaseOrder["StatusAsc"] = "status_ASC";
    ShowcaseOrder["StatusDesc"] = "status_DESC";
    ShowcaseOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ShowcaseOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ShowcaseOrder["SysIdAsc"] = "sys_id_ASC";
    ShowcaseOrder["SysIdDesc"] = "sys_id_DESC";
    ShowcaseOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ShowcaseOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ShowcaseOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ShowcaseOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ShowcaseOrder["TitleAsc"] = "title_ASC";
    ShowcaseOrder["TitleDesc"] = "title_DESC";
})(ShowcaseOrder || (exports.ShowcaseOrder = ShowcaseOrder = {}));
var SpeakerCardLinkingCollectionsResourceCollectionOrder;
(function (SpeakerCardLinkingCollectionsResourceCollectionOrder) {
    SpeakerCardLinkingCollectionsResourceCollectionOrder["FormButtonTextAsc"] = "formButtonText_ASC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["FormButtonTextDesc"] = "formButtonText_DESC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["FormIdAsc"] = "formId_ASC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["FormIdDesc"] = "formId_DESC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["SlugAsc"] = "slug_ASC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["SlugDesc"] = "slug_DESC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["StatusAsc"] = "status_ASC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["StatusDesc"] = "status_DESC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["TitleAsc"] = "title_ASC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["TitleDesc"] = "title_DESC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["TypeAsc"] = "type_ASC";
    SpeakerCardLinkingCollectionsResourceCollectionOrder["TypeDesc"] = "type_DESC";
})(SpeakerCardLinkingCollectionsResourceCollectionOrder || (exports.SpeakerCardLinkingCollectionsResourceCollectionOrder = SpeakerCardLinkingCollectionsResourceCollectionOrder = {}));
var SpeakerCardOrder;
(function (SpeakerCardOrder) {
    SpeakerCardOrder["InternalNameAsc"] = "internalName_ASC";
    SpeakerCardOrder["InternalNameDesc"] = "internalName_DESC";
    SpeakerCardOrder["JobTitleAsc"] = "jobTitle_ASC";
    SpeakerCardOrder["JobTitleDesc"] = "jobTitle_DESC";
    SpeakerCardOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    SpeakerCardOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    SpeakerCardOrder["SysIdAsc"] = "sys_id_ASC";
    SpeakerCardOrder["SysIdDesc"] = "sys_id_DESC";
    SpeakerCardOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    SpeakerCardOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    SpeakerCardOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    SpeakerCardOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(SpeakerCardOrder || (exports.SpeakerCardOrder = SpeakerCardOrder = {}));
var TagLinkingCollectionsBlogPostCollectionOrder;
(function (TagLinkingCollectionsBlogPostCollectionOrder) {
    TagLinkingCollectionsBlogPostCollectionOrder["HideOnHomepageAsc"] = "hideOnHomepage_ASC";
    TagLinkingCollectionsBlogPostCollectionOrder["HideOnHomepageDesc"] = "hideOnHomepage_DESC";
    TagLinkingCollectionsBlogPostCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    TagLinkingCollectionsBlogPostCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    TagLinkingCollectionsBlogPostCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    TagLinkingCollectionsBlogPostCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    TagLinkingCollectionsBlogPostCollectionOrder["ShowPostHeroAsc"] = "showPostHero_ASC";
    TagLinkingCollectionsBlogPostCollectionOrder["ShowPostHeroDesc"] = "showPostHero_DESC";
    TagLinkingCollectionsBlogPostCollectionOrder["ShowTableOfContentsAsc"] = "showTableOfContents_ASC";
    TagLinkingCollectionsBlogPostCollectionOrder["ShowTableOfContentsDesc"] = "showTableOfContents_DESC";
    TagLinkingCollectionsBlogPostCollectionOrder["SlugAsc"] = "slug_ASC";
    TagLinkingCollectionsBlogPostCollectionOrder["SlugDesc"] = "slug_DESC";
    TagLinkingCollectionsBlogPostCollectionOrder["StatusAsc"] = "status_ASC";
    TagLinkingCollectionsBlogPostCollectionOrder["StatusDesc"] = "status_DESC";
    TagLinkingCollectionsBlogPostCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TagLinkingCollectionsBlogPostCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TagLinkingCollectionsBlogPostCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    TagLinkingCollectionsBlogPostCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    TagLinkingCollectionsBlogPostCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TagLinkingCollectionsBlogPostCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TagLinkingCollectionsBlogPostCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TagLinkingCollectionsBlogPostCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    TagLinkingCollectionsBlogPostCollectionOrder["TitleAsc"] = "title_ASC";
    TagLinkingCollectionsBlogPostCollectionOrder["TitleDesc"] = "title_DESC";
})(TagLinkingCollectionsBlogPostCollectionOrder || (exports.TagLinkingCollectionsBlogPostCollectionOrder = TagLinkingCollectionsBlogPostCollectionOrder = {}));
var TagOrder;
(function (TagOrder) {
    TagOrder["NameAsc"] = "name_ASC";
    TagOrder["NameDesc"] = "name_DESC";
    TagOrder["SlugAsc"] = "slug_ASC";
    TagOrder["SlugDesc"] = "slug_DESC";
    TagOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    TagOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    TagOrder["SysIdAsc"] = "sys_id_ASC";
    TagOrder["SysIdDesc"] = "sys_id_DESC";
    TagOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    TagOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    TagOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    TagOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
})(TagOrder || (exports.TagOrder = TagOrder = {}));
var ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder;
(function (ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder) {
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["ContactUrlAsc"] = "contactUrl_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["ContactUrlDesc"] = "contactUrl_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["DemoUrlAsc"] = "demoUrl_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["DemoUrlDesc"] = "demoUrl_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["DocumentationUrlAsc"] = "documentationUrl_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["DocumentationUrlDesc"] = "documentationUrl_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["ExternalIdAsc"] = "externalId_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["ExternalIdDesc"] = "externalId_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["FeaturedOrderAsc"] = "featuredOrder_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["FeaturedOrderDesc"] = "featuredOrder_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["InternalNameAsc"] = "internalName_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["InternalNameDesc"] = "internalName_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["LargePreviewAsc"] = "largePreview_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["LargePreviewDesc"] = "largePreview_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["LargeThumbnailAsc"] = "largeThumbnail_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["LargeThumbnailDesc"] = "largeThumbnail_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["LastHashAsc"] = "lastHash_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["LastHashDesc"] = "lastHash_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["MobilePreviewAsc"] = "mobilePreview_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["MobilePreviewDesc"] = "mobilePreview_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["PartnerEmailAsc"] = "partnerEmail_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["PartnerEmailDesc"] = "partnerEmail_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["PartnerIdAsc"] = "partnerId_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["PartnerIdDesc"] = "partnerId_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["PartnerNameAsc"] = "partnerName_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["PartnerNameDesc"] = "partnerName_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["PriceAsc"] = "price_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["PriceDesc"] = "price_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["PublishedDateAsc"] = "publishedDate_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["PublishedDateDesc"] = "publishedDate_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["RegistryIdAsc"] = "registryId_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["RegistryIdDesc"] = "registryId_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["SlugAsc"] = "slug_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["SlugDesc"] = "slug_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["SmallThumbnailAsc"] = "smallThumbnail_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["SmallThumbnailDesc"] = "smallThumbnail_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["SysIdAsc"] = "sys_id_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["SysIdDesc"] = "sys_id_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["ThemeDefaultConfigurationIdAsc"] = "themeDefaultConfigurationId_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["ThemeDefaultConfigurationIdDesc"] = "themeDefaultConfigurationId_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["ThemeIdAsc"] = "themeId_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["ThemeIdDesc"] = "themeId_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["TitleAsc"] = "title_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["TitleDesc"] = "title_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["VariationNameAsc"] = "variationName_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["VariationNameDesc"] = "variationName_DESC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["VersionIdAsc"] = "versionId_ASC";
    ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder["VersionIdDesc"] = "versionId_DESC";
})(ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder || (exports.ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder = ThemePropertyLinkingCollectionsMarketplaceThemeCollectionOrder = {}));
var ThemePropertyOrder;
(function (ThemePropertyOrder) {
    ThemePropertyOrder["InternalNameAsc"] = "internalName_ASC";
    ThemePropertyOrder["InternalNameDesc"] = "internalName_DESC";
    ThemePropertyOrder["NameAsc"] = "name_ASC";
    ThemePropertyOrder["NameDesc"] = "name_DESC";
    ThemePropertyOrder["SlugAsc"] = "slug_ASC";
    ThemePropertyOrder["SlugDesc"] = "slug_DESC";
    ThemePropertyOrder["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
    ThemePropertyOrder["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
    ThemePropertyOrder["SysIdAsc"] = "sys_id_ASC";
    ThemePropertyOrder["SysIdDesc"] = "sys_id_DESC";
    ThemePropertyOrder["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
    ThemePropertyOrder["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
    ThemePropertyOrder["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
    ThemePropertyOrder["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
    ThemePropertyOrder["TypeAsc"] = "type_ASC";
    ThemePropertyOrder["TypeDesc"] = "type_DESC";
})(ThemePropertyOrder || (exports.ThemePropertyOrder = ThemePropertyOrder = {}));
/** An enum describing what kind of type a given `__Type` is. */
var __TypeKind;
(function (__TypeKind) {
    /** Indicates this type is a scalar. */
    __TypeKind["Scalar"] = "SCALAR";
    /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
    __TypeKind["Object"] = "OBJECT";
    /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
    __TypeKind["Interface"] = "INTERFACE";
    /** Indicates this type is a union. `possibleTypes` is a valid field. */
    __TypeKind["Union"] = "UNION";
    /** Indicates this type is an enum. `enumValues` is a valid field. */
    __TypeKind["Enum"] = "ENUM";
    /** Indicates this type is an input object. `inputFields` is a valid field. */
    __TypeKind["InputObject"] = "INPUT_OBJECT";
    /** Indicates this type is a list. `ofType` is a valid field. */
    __TypeKind["List"] = "LIST";
    /** Indicates this type is a non-null. `ofType` is a valid field. */
    __TypeKind["NonNull"] = "NON_NULL";
})(__TypeKind || (exports.__TypeKind = __TypeKind = {}));
exports.TypeFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Type' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: '__Type' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fields' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'fields' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'type' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'fields' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'type' },
                                                                                    selectionSet: {
                                                                                        kind: 'SelectionSet',
                                                                                        selections: [
                                                                                            {
                                                                                                kind: 'Field',
                                                                                                name: { kind: 'Name', value: 'name' }
                                                                                            },
                                                                                            {
                                                                                                kind: 'Field',
                                                                                                name: { kind: 'Name', value: 'fields' },
                                                                                                selectionSet: {
                                                                                                    kind: 'SelectionSet',
                                                                                                    selections: [
                                                                                                        {
                                                                                                            kind: 'Field',
                                                                                                            name: { kind: 'Name', value: 'name' }
                                                                                                        },
                                                                                                        {
                                                                                                            kind: 'Field',
                                                                                                            name: { kind: 'Name', value: 'type' },
                                                                                                            selectionSet: {
                                                                                                                kind: 'SelectionSet',
                                                                                                                selections: [
                                                                                                                    {
                                                                                                                        kind: 'Field',
                                                                                                                        name: { kind: 'Name', value: 'name' }
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ArticleBreadcrumbsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleBreadcrumbs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentArticle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parentArticle' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parentArticle' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'parentArticle' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'parentArticle' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ArticleAssetFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.RichTextCalloutFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RichTextCallout' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RichTextWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        }
    ]
};
exports.ArticleAssetExternalFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleAssetExternal' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetExternal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'internalName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                ]
            }
        }
    ]
};
exports.ArticleExternalLinkFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleExternalLink' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalLink' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
                ]
            }
        }
    ]
};
exports.BasicContentCardFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BasicContentCard' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicContentCard' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ctaButtonCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'link' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'ArticleExternalLink' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleExternalLink' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalLink' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
                ]
            }
        }
    ]
};
exports.ArticleBodyLinksFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleBodyLinks' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticleBody' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assets' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'ArticleAsset' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entries' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'RichTextCallout' }
                                                        },
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'ArticleAssetExternal' }
                                                        },
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'BasicContentCard' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleExternalLink' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalLink' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RichTextCallout' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RichTextWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleAssetExternal' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetExternal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'internalName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BasicContentCard' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicContentCard' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ctaButtonCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'link' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'ArticleExternalLink' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ArticleRichTextFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleBodyLinks' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'subheading' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bio' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RichTextCallout' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RichTextWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleAssetExternal' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetExternal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'internalName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleExternalLink' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalLink' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BasicContentCard' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicContentCard' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ctaButtonCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'link' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'ArticleExternalLink' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleBodyLinks' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticleBody' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assets' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'ArticleAsset' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entries' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'RichTextCallout' }
                                                        },
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'ArticleAssetExternal' }
                                                        },
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'BasicContentCard' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ImageAssetFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.ArticleImageFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.ArticleFeedCarouselFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleFeedCarousel' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'cardSummary' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentArticle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'description' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'editStatus' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.ArticleFaqAccordionsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleFAQAccordions' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'faqsCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'question' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'answer' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ArticleInterstitialFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleInterstitial' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'interstitialHeadline' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'interstitialCta' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'link' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ArticleExternalLink' }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleExternalLink' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalLink' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
                ]
            }
        }
    ]
};
exports.ArticleStatusFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleStatus' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_US' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_GB' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_AU' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_it_IT' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_nl_NL' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_fr_FR' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_es_ES' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_de_DE' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_es_MX' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
exports.LocalizedArticleSlugFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LocalizedArticleSlug' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_MX' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_ES' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_it_IT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_fr_FR' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nl_NL' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_DE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
exports.SeoMetadataFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.ArticleMetaFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatar' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleStatus' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocalizedArticleSlug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentArticle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocalizedArticleSlug' } }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleStatus' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_US' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_GB' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_AU' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_it_IT' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_nl_NL' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_fr_FR' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_es_ES' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_de_DE' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_es_MX' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LocalizedArticleSlug' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_MX' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_ES' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_it_IT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_fr_FR' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nl_NL' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_DE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ArticleSecondaryCtAsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleSecondaryCTAs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'secondaryCtasCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'ctaButtonCollection' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'items' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'openInNewTab' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'formId' } },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'link' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                {
                                                                                    kind: 'InlineFragment',
                                                                                    typeCondition: {
                                                                                        kind: 'NamedType',
                                                                                        name: { kind: 'Name', value: 'ExternalLink' }
                                                                                    },
                                                                                    selectionSet: {
                                                                                        kind: 'SelectionSet',
                                                                                        selections: [
                                                                                            {
                                                                                                kind: 'Field',
                                                                                                name: { kind: 'Name', value: '__typename' }
                                                                                            },
                                                                                            {
                                                                                                kind: 'Field',
                                                                                                name: { kind: 'Name', value: 'url' }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ArticleFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Article' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleBreadcrumbs' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleRichText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleImage' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleFeedCarousel' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleFAQAccordions' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleInterstitial' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleMeta' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleSecondaryCTAs' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RichTextCallout' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RichTextWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleAssetExternal' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetExternal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'internalName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleExternalLink' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalLink' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BasicContentCard' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicContentCard' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ctaButtonCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'link' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'ArticleExternalLink' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleBodyLinks' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticleBody' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assets' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'ArticleAsset' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entries' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'RichTextCallout' }
                                                        },
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'ArticleAssetExternal' }
                                                        },
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'BasicContentCard' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleStatus' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_US' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_GB' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_AU' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_it_IT' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_nl_NL' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_fr_FR' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_es_ES' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_de_DE' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_es_MX' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LocalizedArticleSlug' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_MX' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_ES' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_it_IT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_fr_FR' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nl_NL' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_DE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleBreadcrumbs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentArticle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parentArticle' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parentArticle' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'parentArticle' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'parentArticle' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleBodyLinks' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'subheading' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bio' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleFeedCarousel' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'cardSummary' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentArticle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'description' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'editStatus' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleFAQAccordions' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'faqsCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'question' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'answer' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleInterstitial' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'interstitialHeadline' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'interstitialCta' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'link' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ArticleExternalLink' }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatar' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleStatus' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocalizedArticleSlug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentArticle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocalizedArticleSlug' } }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleSecondaryCTAs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'secondaryCtasCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'ctaButtonCollection' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'items' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'openInNewTab' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'formId' } },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'link' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                {
                                                                                    kind: 'InlineFragment',
                                                                                    typeCondition: {
                                                                                        kind: 'NamedType',
                                                                                        name: { kind: 'Name', value: 'ExternalLink' }
                                                                                    },
                                                                                    selectionSet: {
                                                                                        kind: 'SelectionSet',
                                                                                        selections: [
                                                                                            {
                                                                                                kind: 'Field',
                                                                                                name: { kind: 'Name', value: '__typename' }
                                                                                            },
                                                                                            {
                                                                                                kind: 'Field',
                                                                                                name: { kind: 'Name', value: 'url' }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ArticleChildrenCarouselFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleChildrenCarousel' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'cardSummary' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentArticle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'description' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.ArticleTextFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'cardSummary' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'headline' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.CategoryBreadcrumbsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CategoryBreadcrumbs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentCategory' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parentCategory' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parentCategory' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.BlogPostBreadcrumbsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostBreadcrumbs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoriesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CategoryBreadcrumbs' }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CategoryBreadcrumbs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentCategory' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parentCategory' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parentCategory' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.BlogPostCategoriesFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostCategories' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoriesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.BlogPostMetaFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatar' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tagsCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.BlogPostPdfDownloadFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostPDFDownload' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gatedContentSettings' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'calloutTitle' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'calloutDescription' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gatedAsset' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'providePrintVersion' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.BlogPostAssetFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.BlogPostAssetExternalFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostAssetExternal' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetExternal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'internalName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                ]
            }
        }
    ]
};
exports.BlogPostBodyLinksFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostBodyLinks' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPostBody' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assets' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'BlogPostAsset' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entries' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'RichTextCallout' }
                                                        },
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'BlogPostAssetExternal' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RichTextCallout' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RichTextWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostAssetExternal' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetExternal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'internalName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                ]
            }
        }
    ]
};
exports.BlogPostRichTextFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostBodyLinks' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bio' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RichTextCallout' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RichTextWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostAssetExternal' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetExternal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'internalName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostBodyLinks' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPostBody' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assets' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'BlogPostAsset' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entries' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'RichTextCallout' }
                                                        },
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'BlogPostAssetExternal' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.BlogPostImageFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ctaMatPattern' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.BlogPostButtonFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostButton' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ctaMatPattern' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.BlogPostTextFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ctaMatPattern' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'subheading' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'fullName' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.BlogPostFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPost' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostBreadcrumbs' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostCategories' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostMeta' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostPDFDownload' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostRichText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostImage' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostButton' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostText' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CategoryBreadcrumbs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentCategory' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parentCategory' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parentCategory' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RichTextCallout' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RichTextWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostAssetExternal' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetExternal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'internalName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostBodyLinks' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPostBody' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assets' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'BlogPostAsset' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entries' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'RichTextCallout' }
                                                        },
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'BlogPostAssetExternal' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostBreadcrumbs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoriesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CategoryBreadcrumbs' }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostCategories' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoriesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatar' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tagsCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostPDFDownload' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gatedContentSettings' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'calloutTitle' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'calloutDescription' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gatedAsset' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'providePrintVersion' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostBodyLinks' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bio' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ctaMatPattern' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostButton' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ctaMatPattern' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ctaMatPattern' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'subheading' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'fullName' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.CaseStudyButtonFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyButton' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'link' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.CaseStudyTextFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                ]
            }
        }
    ]
};
exports.AssetFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Asset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.CaseStudyRichTextFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'quote' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'statsTitle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'statsSubtitle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'statsDescription' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraSection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section1' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section2' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section3' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section4' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section5' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Asset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RichTextCallout' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RichTextWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        }
    ]
};
exports.CaseStudyStatsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyStats' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseStudyStatsCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.CaseStudyImageFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'quoteImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.CaseStudyVideoFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyVideo' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredVideo' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.CaseStudyMetaFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_US' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_GB' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_AU' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_it_IT' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_nl_NL' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_fr_FR' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_es_ES' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_de_DE' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_es_MX' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.CaseStudyHeroFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyHero' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'subheading' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'link' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.CaseStudyCategoriesFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyCategories' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'competitorsListCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'industriesListCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topicsListCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.CaseStudyRelatedCaseStudiesFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyRelatedCaseStudies' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'relatedCaseStudiesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                                    ]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.CaseStudyFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudy' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyButton' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyRichText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyStats' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyImage' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyVideo' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyMeta' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyHero' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyCategories' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyRelatedCaseStudies' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Asset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RichTextCallout' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RichTextWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyButton' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'link' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'quote' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'statsTitle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'statsSubtitle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'statsDescription' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraSection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section1' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section2' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section3' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section4' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section5' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyStats' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseStudyStatsCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'quoteImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyVideo' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredVideo' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_US' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_GB' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_AU' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_it_IT' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_nl_NL' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_fr_FR' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_es_ES' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_de_DE' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_es_MX' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyHero' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'subheading' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'link' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyCategories' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'competitorsListCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'industriesListCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topicsListCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyRelatedCaseStudies' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'relatedCaseStudiesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                                    ]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.CategoryMetaFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CategoryMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.CategoryRichTextFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CategoryRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.CategoryFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Category' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CategoryBreadcrumbs' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CategoryMeta' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CategoryRichText' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CategoryBreadcrumbs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentCategory' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parentCategory' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parentCategory' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CategoryMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CategoryRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.GlossaryTextFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Glossary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                ]
            }
        }
    ]
};
exports.GlossaryAssetFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.GlossaryRichTextFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Glossary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'GlossaryAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.GlossaryImageFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Glossary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.GlossaryMetaFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Glossary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.GlossaryFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Glossary' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Glossary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GlossaryText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GlossaryRichText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GlossaryImage' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GlossaryMeta' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Glossary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Glossary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'GlossaryAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Glossary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Glossary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.GlossaryCategorySlugsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryCategorySlugs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
exports.GlossaryCategoryFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryCategory' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }
                            ]
                        }
                    },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GlossaryCategorySlugs' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkedFrom' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'allowedLocales' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        { kind: 'StringValue', value: 'en-US', block: false },
                                        { kind: 'StringValue', value: 'en-AU', block: false },
                                        { kind: 'StringValue', value: 'en-GB', block: false }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'glossaryCollection' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'locale' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                                        }
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryCategorySlugs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AppRichTextFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceApp' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'abstract' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AppFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'App' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceApp' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppRichText' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'logoIcon' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'alternativeLogo' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'appRegistryId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'video' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'screenshots' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reviewCount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'unifiedBilling' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'freeTrial' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'freeTrialDays' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'upfrontPrice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'monthlyPrice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pricing' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pricingType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appTier' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'logo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'supportUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'installationGuideUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'userGuideUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'appRegistryUpdatedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'multiStorefront' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'multiLocation' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'similarApps' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appFeaturesCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '5' }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'description' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseStudiesCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '2' }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'description' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'url' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceApp' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'abstract' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.AppInformationFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppInformation' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MarketplaceAppCollection' }
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'App' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceApp' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'abstract' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'App' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceApp' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppRichText' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'logoIcon' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'alternativeLogo' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'appRegistryId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'video' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'screenshots' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reviewCount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'unifiedBilling' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'freeTrial' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'freeTrialDays' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'upfrontPrice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'monthlyPrice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pricing' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pricingType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appTier' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'logo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'supportUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'installationGuideUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'userGuideUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'appRegistryUpdatedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'multiStorefront' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'multiLocation' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'similarApps' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appFeaturesCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '5' }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'description' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseStudiesCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '2' }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'description' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'url' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AppCollectionImageFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppCollectionImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCollection' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } }]
            }
        }
    ]
};
exports.AppCollectionTextFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppCollectionText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCollection' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'summary' } }
                ]
            }
        }
    ]
};
exports.AppCollectionFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppCollection' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCollection' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppCollectionImage' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppCollectionText' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkedFrom' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'marketplaceAppCollection' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppCollectionImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCollection' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } }]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppCollectionText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCollection' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'summary' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.AppMetaFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppMetaFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceApp' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'upfrontPrice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'monthlyPrice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reviewCount' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.AppTierTextFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppTierText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppTier' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } }
                ]
            }
        }
    ]
};
exports.AppTierImageFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppTierImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppTier' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'logo' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.AppTierFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppTier' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppTier' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppTierText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppTierImage' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppTierText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppTier' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppTierImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppTier' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'logo' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ThemeImageFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ThemeImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceTheme' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'smallThumbnail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'largeThumbnail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'mobilePreview' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'largePreview' } }
                ]
            }
        }
    ]
};
exports.ThemeRichTextFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ThemeRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceTheme' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ThemeInformationFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ThemeInformation' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MarketplaceThemeCollection' }
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ThemeImage' } },
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ThemeRichText' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sys' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'registryId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'partnerName' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'seoMetadata' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'partnerEmail' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'demoUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'themeFeatures' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'themeOptimizations' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'documentationUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'related' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ThemeImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceTheme' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'smallThumbnail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'largeThumbnail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'mobilePreview' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'largePreview' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ThemeRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceTheme' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.ThemesPropertyFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ThemesProperty' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ThemePropertyCollection' }
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sys' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'seoMetadata' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'linkedFrom' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'marketplaceThemeCollection' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.PersonTextFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'linkedUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        }
    ]
};
exports.PersonRichTextFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bio' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'additionalOptions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bioSummary' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fullBio' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.PersonMetaFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.PersonRelatedNewsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonRelatedNews' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'additionalOptions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'relatedNewsCollection' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'items' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'sys' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                            }
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'internalName' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.PersonImageFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullSizePhoto' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatar' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.PersonFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Person' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PersonText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PersonRichText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PersonMeta' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PersonRelatedNews' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PersonImage' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'linkedUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bio' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'additionalOptions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bioSummary' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fullBio' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonRelatedNews' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'additionalOptions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'relatedNewsCollection' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'items' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'sys' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                            }
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'internalName' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullSizePhoto' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatar' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.PressAssetFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.PressRichTextFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'PressAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.PressTextFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'summary' } }
                ]
            }
        }
    ]
};
exports.PressDateFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressDate' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } }]
            }
        }
    ]
};
exports.PressSlugFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressSlug' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_SG' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-SG', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_MX' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_ES' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_it_IT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_fr_FR' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nl_NL' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_DE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_AT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-AT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_da_DK' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'da-DK', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_sv_SE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'sv-SE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nb_NO' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nb-NO', block: false }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
exports.PressEnabledFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressEnabled' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_en_US' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_en_AU' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_en_GB' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_en_SG' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-SG', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_es_MX' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_es_ES' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_it_IT' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_fr_FR' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_nl_NL' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_de_DE' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_de_AT' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-AT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_da_DK' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'da-DK', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_sv_SE' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'sv-SE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_nb_NO' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nb-NO', block: false }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
exports.PressPostMetaFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressPostMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PressSlug' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PressEnabled' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressSlug' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_SG' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-SG', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_MX' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_ES' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_it_IT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_fr_FR' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nl_NL' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_DE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_AT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-AT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_da_DK' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'da-DK', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_sv_SE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'sv-SE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nb_NO' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nb-NO', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressEnabled' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_en_US' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_en_AU' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_en_GB' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_en_SG' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-SG', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_es_MX' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_es_ES' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_it_IT' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_fr_FR' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_nl_NL' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_de_DE' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_de_AT' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-AT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_da_DK' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'da-DK', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_sv_SE' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'sv-SE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_nb_NO' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nb-NO', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.PressFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Press' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PressRichText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PressText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PressDate' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PressPostMeta' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressSlug' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_SG' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-SG', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_MX' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_ES' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_it_IT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_fr_FR' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nl_NL' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_DE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_AT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-AT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_da_DK' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'da-DK', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_sv_SE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'sv-SE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nb_NO' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nb-NO', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressEnabled' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_en_US' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_en_AU' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_en_GB' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_en_SG' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-SG', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_es_MX' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_es_ES' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_it_IT' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_fr_FR' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_nl_NL' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_de_DE' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_de_AT' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-AT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_da_DK' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'da-DK', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_sv_SE' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'sv-SE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_nb_NO' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nb-NO', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'PressAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'summary' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressDate' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } }]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressPostMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PressSlug' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PressEnabled' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ResourceSlugFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ResourceSlug' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_MX' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_ES' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_it_IT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_fr_FR' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nl_NL' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_DE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
exports.AssetExternalFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AssetExternal' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetExternal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'internalName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                ]
            }
        }
    ]
};
exports.HeroSubheadingLinkFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'HeroSubheadingLink' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'HeroSubheadingLinks' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assets' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'block' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'block' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AssetExternal' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Asset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AssetExternal' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetExternal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'internalName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                ]
            }
        }
    ]
};
exports.ResourceHeroFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ResourceHero' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Hero' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subheading' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'HeroSubheadingLink' }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'backgroundOptions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'solidColor' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'gradient' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'textColor' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'backgroundImage' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cta' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'formId' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'link' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Asset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AssetExternal' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetExternal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'internalName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'HeroSubheadingLink' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'HeroSubheadingLinks' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assets' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'block' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'block' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AssetExternal' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.ResourceRecommendedFeedFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ResourceRecommendedFeed' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedContentCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'Article' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'featuredImage' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'parentArticle' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'Resource' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'cardImage' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'BlogPost' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'featuredImage' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'CaseStudy' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'image' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'BasicContentCard' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'overline' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'image' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'ctaButtonCollection' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'items' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'displayText' }
                                                                                },
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'link' },
                                                                                    selectionSet: {
                                                                                        kind: 'SelectionSet',
                                                                                        selections: [
                                                                                            {
                                                                                                kind: 'Field',
                                                                                                name: { kind: 'Name', value: 'url' }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.ResourceSpeakersFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ResourceSpeakers' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'speakersCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.ResourceFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Resource' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceSlug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'formId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cardImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceHero' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'statsCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'aboveFormContent' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sideFormContent' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'disclaimer' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceRecommendedFeed' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceSpeakers' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Asset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AssetExternal' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetExternal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'internalName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'HeroSubheadingLink' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'HeroSubheadingLinks' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assets' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'block' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'block' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AssetExternal' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ResourceSlug' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_MX' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_ES' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_it_IT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_fr_FR' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nl_NL' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_DE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ResourceHero' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Hero' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subheading' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'HeroSubheadingLink' }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'backgroundOptions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'solidColor' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'gradient' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'textColor' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'backgroundImage' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cta' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'formId' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'link' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ResourceRecommendedFeed' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedContentCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'Article' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'featuredImage' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'parentArticle' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'Resource' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'cardImage' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'BlogPost' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'featuredImage' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'CaseStudy' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'image' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'BasicContentCard' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'overline' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'image' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'ctaButtonCollection' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'items' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'displayText' }
                                                                                },
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'link' },
                                                                                    selectionSet: {
                                                                                        kind: 'SelectionSet',
                                                                                        selections: [
                                                                                            {
                                                                                                kind: 'Field',
                                                                                                name: { kind: 'Name', value: 'url' }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ResourceSpeakers' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'speakersCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ShowcaseItemFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ShowcaseItem' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Showcase' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseStudy' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'AssetInternal' }
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'media' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'InlineFragment',
                                                            typeCondition: {
                                                                kind: 'NamedType',
                                                                name: { kind: 'Name', value: 'Asset' }
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'height' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalUrl' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'ExternalLink' }
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ShowcaseCategorySlugsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ShowcaseCategorySlugs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_SG' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-SG', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_MX' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_ES' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_it_IT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_fr_FR' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nl_NL' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_DE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_AT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-AT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_da_DK' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'da-DK', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_sv_SE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'sv-SE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nb_NO' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nb-NO', block: false }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
exports.ShowcaseCategoryFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ShowcaseCategory' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }
                            ]
                        }
                    },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ShowcaseCategorySlugs' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentCategory' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ShowcaseCategorySlugs' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkedFrom' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'allowedLocales' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        { kind: 'StringValue', value: 'en-US', block: false },
                                        { kind: 'StringValue', value: 'en-AU', block: false },
                                        { kind: 'StringValue', value: 'en-GB', block: false },
                                        { kind: 'StringValue', value: 'en-SG', block: false },
                                        { kind: 'StringValue', value: 'sv-SE', block: false },
                                        { kind: 'StringValue', value: 'de-DE', block: false },
                                        { kind: 'StringValue', value: 'fr-FR', block: false },
                                        { kind: 'StringValue', value: 'es-ES', block: false },
                                        { kind: 'StringValue', value: 'es-MX', block: false },
                                        { kind: 'StringValue', value: 'it-IT', block: false },
                                        { kind: 'StringValue', value: 'nl-NL', block: false },
                                        { kind: 'StringValue', value: 'nb-NO', block: false },
                                        { kind: 'StringValue', value: 'da-DK', block: false },
                                        { kind: 'StringValue', value: 'de-DE', block: false },
                                        { kind: 'StringValue', value: 'de-AT', block: false }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'showcaseCollection' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'locale' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                                        }
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ShowcaseCategorySlugs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_SG' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-SG', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_MX' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_ES' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_it_IT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_fr_FR' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nl_NL' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_DE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_AT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-AT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_da_DK' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'da-DK', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_sv_SE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'sv-SE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nb_NO' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nb-NO', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AlgoliaBlogPostFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AlgoliaBlogPost' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatar' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoriesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tagsCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AlgoliaMarketplaceAppFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AlgoliaMarketplaceApp' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceApp' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'algoliaKeywords' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'logoIcon' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reviewCount' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'abstract' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'unifiedBilling' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'freeTrial' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'freeTrialDays' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'upfrontPrice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'monthlyPrice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pricing' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pricingType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appTier' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'logo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'appRegistryUpdatedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'multiStorefront' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'multiLocation' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appFeaturesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'description' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'similarApps' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'featuredOrder' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'appRegistryId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appFeaturesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoriesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parentCategory' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'contentfulMetadata' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'tags' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'collectionsCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        }
    ]
};
exports.AlgoliaMarketplaceThemeFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AlgoliaMarketplaceTheme' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceTheme' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'partnerName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'featuredOrder' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'partnerEmail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contactUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'demoUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'registryId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'versionId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'largePreview' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'largeThumbnail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'smallThumbnail' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'themeIndustriesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'mobilePreview' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'themeFeatures' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'themeOptimizations' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'themeCollections' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'documentationUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'related' } }
                ]
            }
        }
    ]
};
exports.AppCollectionSitemapFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppCollectionSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCollection' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AppSitemapFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceApp' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ArticleSitemapFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentArticle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.BlogPostAuthorsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostAuthors' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkedFrom' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'blogPostCollection' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.BlogPostCategoriesSitemapFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostCategoriesSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkedFrom' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'blogPostCollection' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.BlogPostSitemapFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.CaseStudySitemapFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudySitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.CategoriesSitemapFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CategoriesSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentCategory' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.GlossarySitemapFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossarySitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Glossary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.PressSitemapFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ResourcesSitemapFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ResourcesSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ThemeIndustryFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ThemeIndustry' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ThemeProperty' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ThemeSitemapFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ThemeSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceTheme' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ArticleSlugFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleSlug' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'de_AT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-AT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'nb_NO' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nb-NO', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'da_DK' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'da-DK', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'sv_SE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'sv-SE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'fr_FR' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'it_IT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'es_ES' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'es_MX' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'nl_NL' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'de_DE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
exports.TypesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Types' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    defaultValue: { kind: 'StringValue', value: 'Resource', block: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__type' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Type' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Type' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: '__Type' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fields' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'fields' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'type' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'fields' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'type' },
                                                                                    selectionSet: {
                                                                                        kind: 'SelectionSet',
                                                                                        selections: [
                                                                                            {
                                                                                                kind: 'Field',
                                                                                                name: { kind: 'Name', value: 'name' }
                                                                                            },
                                                                                            {
                                                                                                kind: 'Field',
                                                                                                name: { kind: 'Name', value: 'fields' },
                                                                                                selectionSet: {
                                                                                                    kind: 'SelectionSet',
                                                                                                    selections: [
                                                                                                        {
                                                                                                            kind: 'Field',
                                                                                                            name: { kind: 'Name', value: 'name' }
                                                                                                        },
                                                                                                        {
                                                                                                            kind: 'Field',
                                                                                                            name: { kind: 'Name', value: 'type' },
                                                                                                            selectionSet: {
                                                                                                                kind: 'SelectionSet',
                                                                                                                selections: [
                                                                                                                    {
                                                                                                                        kind: 'Field',
                                                                                                                        name: { kind: 'Name', value: 'name' }
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ArticlesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Articles' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticleFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '10' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'articleCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Article' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleBreadcrumbs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentArticle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parentArticle' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parentArticle' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'parentArticle' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'parentArticle' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RichTextCallout' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RichTextWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleAssetExternal' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetExternal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'internalName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleExternalLink' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalLink' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BasicContentCard' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BasicContentCard' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ctaButtonCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'link' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'ArticleExternalLink' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleBodyLinks' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticleBody' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assets' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'ArticleAsset' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entries' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'RichTextCallout' }
                                                        },
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'ArticleAssetExternal' }
                                                        },
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'BasicContentCard' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleBodyLinks' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'subheading' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bio' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleFeedCarousel' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'cardSummary' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentArticle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'description' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'editStatus' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleFAQAccordions' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'faqsCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'question' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'answer' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleInterstitial' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'interstitialHeadline' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'interstitialCta' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'link' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ArticleExternalLink' }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleStatus' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_US' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_GB' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_AU' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_it_IT' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_nl_NL' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_fr_FR' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_es_ES' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_de_DE' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_es_MX' },
                        name: { kind: 'Name', value: 'editStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LocalizedArticleSlug' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_MX' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_ES' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_it_IT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_fr_FR' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nl_NL' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_DE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatar' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleStatus' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocalizedArticleSlug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentArticle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocalizedArticleSlug' } }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleSecondaryCTAs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'secondaryCtasCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'ctaButtonCollection' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'items' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'openInNewTab' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'formId' } },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'link' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                {
                                                                                    kind: 'InlineFragment',
                                                                                    typeCondition: {
                                                                                        kind: 'NamedType',
                                                                                        name: { kind: 'Name', value: 'ExternalLink' }
                                                                                    },
                                                                                    selectionSet: {
                                                                                        kind: 'SelectionSet',
                                                                                        selections: [
                                                                                            {
                                                                                                kind: 'Field',
                                                                                                name: { kind: 'Name', value: '__typename' }
                                                                                            },
                                                                                            {
                                                                                                kind: 'Field',
                                                                                                name: { kind: 'Name', value: 'url' }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Article' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleBreadcrumbs' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleRichText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleImage' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleFeedCarousel' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleFAQAccordions' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleInterstitial' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleMeta' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleSecondaryCTAs' } }
                ]
            }
        }
    ]
};
exports.ArticleChildFeedGridDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ArticleChildFeedGrid' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticleFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1000' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    defaultValue: { kind: 'StringValue', value: 'en-US', block: false }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticleOrder' } }
                    },
                    defaultValue: { kind: 'ListValue', values: [{ kind: 'EnumValue', value: 'slug_ASC' }] }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'articleCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'hero' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'headline' } }]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parentArticle' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'sys' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                            }
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ArticleChildrenCarouselDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ArticleChildrenCarousel' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticleFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '12' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'articleCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ArticleChildrenCarousel' }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleChildrenCarousel' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'cardSummary' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentArticle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'description' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ArticleFeedCarouselDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ArticleFeedCarousel' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticleFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticleOrder' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '12' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'articleCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ArticleFeedCarousel' }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleFeedCarousel' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'cardSummary' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentArticle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'description' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'editStatus' } }
                ]
            }
        }
    ]
};
exports.LocalizedParentArticlesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'LocalizedParentArticles' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1000' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    defaultValue: { kind: 'StringValue', value: 'en-US', block: false }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticleOrder' } }
                    },
                    defaultValue: { kind: 'ListValue', values: [{ kind: 'EnumValue', value: 'slug_ASC' }] }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticleFilter' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'parentArticles' },
                        name: { kind: 'Name', value: 'articleCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.BlogPostsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'BlogPosts' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPostFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '10' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blogPostCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPost' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CategoryBreadcrumbs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentCategory' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parentCategory' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parentCategory' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostBreadcrumbs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoriesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CategoryBreadcrumbs' }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostCategories' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoriesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatar' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tagsCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostPDFDownload' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gatedContentSettings' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'calloutTitle' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'calloutDescription' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gatedAsset' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'providePrintVersion' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RichTextCallout' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RichTextWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostAssetExternal' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetExternal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'internalName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostBodyLinks' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPostBody' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assets' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'BlogPostAsset' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entries' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'RichTextCallout' }
                                                        },
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'BlogPostAssetExternal' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostBodyLinks' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bio' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ctaMatPattern' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostButton' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ctaMatPattern' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ctaMatPattern' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'subheading' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'fullName' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPost' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostBreadcrumbs' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostCategories' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostMeta' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostPDFDownload' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostRichText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostImage' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostButton' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostText' } }
                ]
            }
        }
    ]
};
exports.BlogPostFeedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'BlogPostFeed' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPostFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '10' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blogPostCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: {
                                    kind: 'ListValue',
                                    values: [{ kind: 'EnumValue', value: 'publishedDate_DESC' }]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'author' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'fullName' } }]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'featuredImage' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'seoMetadata' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'image' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'categoriesCollection' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'items' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'hideOnHomepage' } }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.BlogPostFeedPersonsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'BlogPostFeedPersons' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'personCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'fullName_contains' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } }
                                        }
                                    ]
                                }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'linkedFrom' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'blogPostCollection' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'total' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.BlogPostFeedCategoriesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'BlogPostFeedCategories' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoryCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'name_contains' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } }
                                        }
                                    ]
                                }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'linkedFrom' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'blogPostCollection' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'total' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.CaseStudiesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'CaseStudies' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudyFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '12' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseStudyCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudy' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyButton' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'link' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Asset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RichTextCallout' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RichTextWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'quote' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'statsTitle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'statsSubtitle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'statsDescription' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraSection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section1' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section2' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section3' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section4' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section5' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entries' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'RichTextCallout' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyStats' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseStudyStatsCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'quoteImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyVideo' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredVideo' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_US' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_GB' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_en_AU' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_it_IT' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_nl_NL' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_fr_FR' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_es_ES' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_de_DE' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'status_es_MX' },
                        name: { kind: 'Name', value: 'status' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyHero' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'subheading' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'link' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyCategories' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'competitorsListCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'industriesListCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topicsListCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudyRelatedCaseStudies' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'relatedCaseStudiesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                                    ]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudy' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyButton' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyRichText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyStats' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyImage' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyVideo' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyMeta' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyHero' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyCategories' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudyRelatedCaseStudies' } }
                ]
            }
        }
    ]
};
exports.CaseStudyFeedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'CaseStudyFeed' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudyFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '12' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseStudyCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: {
                                    kind: 'ListValue',
                                    values: [{ kind: 'EnumValue', value: 'publishedDate_DESC' }]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'summary' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.CaseStudyPropertyDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'CaseStudyProperty' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1000' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudyPropertyOrder' } }
                    },
                    defaultValue: { kind: 'ListValue', values: [{ kind: 'EnumValue', value: 'name_ASC' }] }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'industries' },
                        name: { kind: 'Name', value: 'caseStudyPropertyCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'type' },
                                            value: { kind: 'StringValue', value: 'Industries', block: false }
                                        }
                                    ]
                                }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'competitors' },
                        name: { kind: 'Name', value: 'caseStudyPropertyCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'type' },
                                            value: { kind: 'StringValue', value: 'Competitors', block: false }
                                        }
                                    ]
                                }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'topics' },
                        name: { kind: 'Name', value: 'caseStudyPropertyCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'type' },
                                            value: { kind: 'StringValue', value: 'Topics', block: false }
                                        }
                                    ]
                                }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.CaseStudySlugsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'CaseStudySlugs' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudyFilter' } },
                    defaultValue: {
                        kind: 'ObjectValue',
                        fields: [
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'status' },
                                value: { kind: 'BooleanValue', value: true }
                            }
                        ]
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '5' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    defaultValue: { kind: 'StringValue', value: 'en-US', block: false }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseStudyCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.CategoriesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Categories' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'CategoryFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '100' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoryCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Category' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CategoryBreadcrumbs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentCategory' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parentCategory' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parentCategory' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CategoryMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CategoryRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Category' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CategoryBreadcrumbs' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CategoryMeta' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CategoryRichText' } }
                ]
            }
        }
    ]
};
exports.EventFeedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'EventFeed' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventOrder' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '20' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'eventCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'url' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'InlineFragment',
                                                            typeCondition: {
                                                                kind: 'NamedType',
                                                                name: { kind: 'Name', value: 'Asset' }
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'height' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'recurringEvent' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'endDate' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.FeaturedContentBlockDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'FeaturedContentBlock' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'EntryFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'EntryOrder' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '20' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entryCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } }
                                                    ]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'BlogPost' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'featuredImage' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'summary' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'json' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'Article' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'featuredImage' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'interstitialHeadline' }
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'parentArticle' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'Resource' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'hero' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'subheading' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'json' } }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'featuredImage' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'CaseStudy' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'hero' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'subheading' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'json' } }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'image' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.FeaturedLogoCarouselDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'FeaturedLogoCarousel' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudyFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '4' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseStudyCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: {
                                    kind: 'ListValue',
                                    values: [{ kind: 'EnumValue', value: 'publishedDate_DESC' }]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'featuredLogo' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'featuredContent' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'featuredAuthorName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'featuredAuthorTitle' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'featuredImage' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                                    ]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'featuredLinkText' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'featuredOrder' } }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.GlossaryDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Glossary' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'GlossaryFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'glossaryCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Glossary' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Glossary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Glossary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'GlossaryAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Glossary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Glossary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Glossary' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Glossary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GlossaryText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GlossaryRichText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GlossaryImage' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GlossaryMeta' } }
                ]
            }
        }
    ]
};
exports.GlossaryFeedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GlossaryFeed' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'GlossaryFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '10' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'glossaryCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: {
                                    kind: 'ListValue',
                                    values: [{ kind: 'EnumValue', value: 'publishedDate_DESC' }]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'categoryCollection' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'items' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'description' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'json' } }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.GlossaryCategoriesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GlossaryCategories' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'CategoryFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '100' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'CategoryOrder' } }
                    },
                    defaultValue: { kind: 'ListValue', values: [{ kind: 'EnumValue', value: 'name_ASC' }] }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoryCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GlossaryCategory' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryCategorySlugs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossaryCategory' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }
                            ]
                        }
                    },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GlossaryCategorySlugs' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkedFrom' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'allowedLocales' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        { kind: 'StringValue', value: 'en-US', block: false },
                                        { kind: 'StringValue', value: 'en-AU', block: false },
                                        { kind: 'StringValue', value: 'en-GB', block: false }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'glossaryCollection' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'locale' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                                        }
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AppInformationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AppInformation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppOrder' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceAppCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppInformation' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceApp' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'abstract' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'App' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceApp' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppRichText' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'logoIcon' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'alternativeLogo' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'appRegistryId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'video' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'screenshots' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reviewCount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'unifiedBilling' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'freeTrial' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'freeTrialDays' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'upfrontPrice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'monthlyPrice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pricing' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pricingType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appTier' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'logo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'supportUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'installationGuideUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'userGuideUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'appRegistryUpdatedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'multiStorefront' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'multiLocation' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'similarApps' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appFeaturesCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '5' }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'description' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseStudiesCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '2' }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'description' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'url' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppInformation' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MarketplaceAppCollection' }
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'App' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AppCarouselDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AppCarousel' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '12' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppOrder' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceAppCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'summary' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'alternativeLogo' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'appTier' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'logo' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'categoriesCollection' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'items' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'sys' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                                                            ]
                                                                        }
                                                                    },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'parentCategory' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'sys' },
                                                                                    selectionSet: {
                                                                                        kind: 'SelectionSet',
                                                                                        selections: [
                                                                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.AppCategoriesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AppCategories' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'CategoryFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1000' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'CategoryOrder' } }
                    }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoryCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AppCollectionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AppCollection' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCollectionFilter' } },
                    defaultValue: {
                        kind: 'ObjectValue',
                        fields: [
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'private_not' },
                                value: { kind: 'BooleanValue', value: true }
                            }
                        ]
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCollectionOrder' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appCollectionCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppCollection' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppCollectionImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCollection' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } }]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppCollectionText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCollection' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'summary' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppCollection' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCollection' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppCollectionImage' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppCollectionText' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkedFrom' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'marketplaceAppCollection' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AppCollectionCarouselDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AppCollectionCarousel' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCollectionFilter' } },
                    defaultValue: {
                        kind: 'ObjectValue',
                        fields: [
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'private_not' },
                                value: { kind: 'BooleanValue', value: true }
                            }
                        ]
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '100' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appCollectionCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppCollection' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppCollectionImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCollection' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'thumbnail' } }]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppCollectionText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCollection' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'summary' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppCollection' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCollection' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppCollectionImage' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppCollectionText' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkedFrom' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'marketplaceAppCollection' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AppCollectionCarouselPriorityDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AppCollectionCarouselPriority' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appCollectionCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'name' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } }
                                        }
                                    ]
                                }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '12' }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AppCollectionListDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AppCollectionList' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '12' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppOrder' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceAppCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'summary' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'reviewCount' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'upfrontPrice' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'monthlyPrice' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'logoIcon' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'categoriesCollection' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'items' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'sys' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                                                            ]
                                                                        }
                                                                    },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'parentCategory' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'sys' },
                                                                                    selectionSet: {
                                                                                        kind: 'SelectionSet',
                                                                                        selections: [
                                                                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'collectionsCollection' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'items' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'sys' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                                                            ]
                                                                        }
                                                                    },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'appTier' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'logo' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'url' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AppMetaDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AppMeta' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppOrder' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceAppCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppMetaFragment' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppMetaFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceApp' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'upfrontPrice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'monthlyPrice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reviewCount' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AppRowDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AppRow' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '4' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppOrder' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceAppCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'summary' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'logoIcon' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AppRowCardsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AppRowCards' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '3' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppOrder' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceAppCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'summary' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'reviewCount' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'logoIcon' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'appTier' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'logo' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'categoriesCollection' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'items' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'sys' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                                                            ]
                                                                        }
                                                                    },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'parentCategory' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'sys' },
                                                                                    selectionSet: {
                                                                                        kind: 'SelectionSet',
                                                                                        selections: [
                                                                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.AppTierDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AppTier' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppTierFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppTierOrder' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appTierCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppTier' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppTierText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppTier' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppTierImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppTier' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'logo' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppTier' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppTier' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppTierText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppTierImage' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AppTierAppGridDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AppTierAppGrid' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '100' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppOrder' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceAppCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'summary' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'reviewCount' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'categoriesCollection' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'items' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'sys' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                                                            ]
                                                                        }
                                                                    },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'parentCategory' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'sys' },
                                                                                    selectionSet: {
                                                                                        kind: 'SelectionSet',
                                                                                        selections: [
                                                                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'appTier' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'logo' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'url' } }
                                                                ]
                                                            }
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AppsRecommendedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AppsRecommended' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '100' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppOrder' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceAppCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'summary' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'upfrontPrice' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'monthlyPrice' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'reviewCount' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'logoIcon' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'appTier' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'logo' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.ThemesInformationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ThemesInformation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceThemeFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceThemeCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ThemeInformation' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ThemeImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceTheme' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'smallThumbnail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'largeThumbnail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'mobilePreview' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'largePreview' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ThemeRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceTheme' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ThemeInformation' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MarketplaceThemeCollection' }
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ThemeImage' } },
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ThemeRichText' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sys' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'registryId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'partnerName' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'seoMetadata' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'partnerEmail' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'contactUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'demoUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'themeFeatures' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'themeOptimizations' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'documentationUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'related' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ThemeRelatedStyleDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ThemeRelatedStyle' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'relatedId' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceThemeCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'registryId' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'relatedId' } }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'largeThumbnail' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'smallThumbnail' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'registryId' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ThemesCollectionsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ThemesCollections' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ThemePropertyFilter' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'themePropertyCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ThemesProperty' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ThemesProperty' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ThemePropertyCollection' }
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sys' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'seoMetadata' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'linkedFrom' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'marketplaceThemeCollection' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ThemesListDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ThemesList' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceThemeFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '12' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceThemeCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'largePreview' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'largeThumbnail' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'smallThumbnail' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'mobilePreview' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'related' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'seoMetadata' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'includeTitleTemplate' }
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'image' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.PersonsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Persons' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'PersonFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '10' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'personCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Person' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'linkedUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bio' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'additionalOptions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bioSummary' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fullBio' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonRelatedNews' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'additionalOptions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'relatedNewsCollection' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'items' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'sys' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                            }
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'internalName' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PersonImage' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullSizePhoto' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatar' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Person' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PersonText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PersonRichText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PersonMeta' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PersonRelatedNews' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PersonImage' } }
                ]
            }
        }
    ]
};
exports.PersonFeedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'PersonFeed' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'PersonFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '10' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'personCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'jobTitleInEnglish' },
                                                name: { kind: 'Name', value: 'jobTitle' },
                                                arguments: [
                                                    {
                                                        kind: 'Argument',
                                                        name: { kind: 'Name', value: 'locale' },
                                                        value: { kind: 'StringValue', value: 'en-US', block: false }
                                                    }
                                                ]
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'avatar' },
                                                arguments: [
                                                    {
                                                        kind: 'Argument',
                                                        name: { kind: 'Name', value: 'locale' },
                                                        value: { kind: 'StringValue', value: 'en-US', block: false }
                                                    }
                                                ],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'additionalOptions' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'avatarOverride' },
                                                            arguments: [
                                                                {
                                                                    kind: 'Argument',
                                                                    name: { kind: 'Name', value: 'locale' },
                                                                    value: { kind: 'StringValue', value: 'en-US', block: false }
                                                                }
                                                            ],
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'bioSummary' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'json' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.PersonFeedPriorityDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'PersonFeedPriority' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'personCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'fullName_contains' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } }
                                        }
                                    ]
                                }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '10' }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.PressDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Press' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'PressFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '10' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pressCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Press' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressRichText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'assets' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'block' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'PressAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressText' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'summary' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressDate' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } }]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressSlug' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_SG' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-SG', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_MX' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_ES' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_it_IT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_fr_FR' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nl_NL' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_DE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_AT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-AT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_da_DK' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'da-DK', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_sv_SE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'sv-SE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nb_NO' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nb-NO', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressEnabled' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_en_US' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_en_AU' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_en_GB' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_en_SG' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-SG', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_es_MX' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_es_ES' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_it_IT' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_fr_FR' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_nl_NL' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_de_DE' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_de_AT' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-AT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_da_DK' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'da-DK', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_sv_SE' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'sv-SE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'enabled_nb_NO' },
                        name: { kind: 'Name', value: 'enabled' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nb-NO', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressPostMeta' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PressSlug' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PressEnabled' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Press' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PressRichText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PressText' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PressDate' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PressPostMeta' } }
                ]
            }
        }
    ]
};
exports.PressFeedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'PressFeed' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'PressFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '10' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pressCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'EnumValue', value: 'publishedDate_DESC' }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'externalLink' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                                }
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'InlineFragment',
                                                            typeCondition: {
                                                                kind: 'NamedType',
                                                                name: { kind: 'Name', value: 'AssetInternal' }
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'media' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                {
                                                                                    kind: 'FragmentSpread',
                                                                                    name: { kind: 'Name', value: 'ImageAsset' }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: 'InlineFragment',
                                                            typeCondition: {
                                                                kind: 'NamedType',
                                                                name: { kind: 'Name', value: 'AssetExternal' }
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'url' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.ResourceDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Resource' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResourceFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResourceOrder' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '20' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            },
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Resource' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ResourceSlug' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_MX' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_ES' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_it_IT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_fr_FR' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nl_NL' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_DE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Asset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AssetExternal' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetExternal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'internalName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'HeroSubheadingLink' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'HeroSubheadingLinks' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assets' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'block' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Asset' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'block' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AssetExternal' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ResourceHero' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Hero' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subheading' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'HeroSubheadingLink' }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'backgroundOptions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'solidColor' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'gradient' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'textColor' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'backgroundImage' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cta' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'formId' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'link' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ResourceRecommendedFeed' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedContentCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'Article' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'featuredImage' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'parentArticle' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'Resource' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'cardImage' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'BlogPost' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'featuredImage' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'CaseStudy' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'image' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'BasicContentCard' }
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'overline' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'image' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageAsset' }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'ctaButtonCollection' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'items' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'displayText' }
                                                                                },
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'link' },
                                                                                    selectionSet: {
                                                                                        kind: 'SelectionSet',
                                                                                        selections: [
                                                                                            {
                                                                                                kind: 'Field',
                                                                                                name: { kind: 'Name', value: 'url' }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ResourceSpeakers' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'speakersCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Resource' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceSlug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'formId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cardImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceHero' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'statsCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'aboveFormContent' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sideFormContent' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentImage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'disclaimer' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceRecommendedFeed' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceSpeakers' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ResourceFeedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ResourceFeed' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResourceFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResourceOrder' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '20' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'cardImage' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        }
    ]
};
exports.ShowcaseFeedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ShowcaseFeed' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ShowcaseFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ShowcaseOrder' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '10' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'showcaseCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'order' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ShowcaseItem' } }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ShowcaseItem' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Showcase' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseStudy' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'AssetInternal' }
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'media' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'InlineFragment',
                                                            typeCondition: {
                                                                kind: 'NamedType',
                                                                name: { kind: 'Name', value: 'Asset' }
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'height' } }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalUrl' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'ExternalLink' }
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ShowcaseCategoriesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ShowcaseCategories' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'CategoryFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '100' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoryCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ShowcaseCategory' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ShowcaseCategorySlugs' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_en_SG' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-SG', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_MX' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_es_ES' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_it_IT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_fr_FR' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nl_NL' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_DE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_de_AT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-AT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_da_DK' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'da-DK', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_sv_SE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'sv-SE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'slug_nb_NO' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nb-NO', block: false }
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ImageAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SeoMetadataFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SeoMetadata' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'includeTitleTemplate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageAsset' } }]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ShowcaseCategory' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }
                            ]
                        }
                    },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ShowcaseCategorySlugs' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentCategory' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ShowcaseCategorySlugs' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SeoMetadataFragment' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkedFrom' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'allowedLocales' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        { kind: 'StringValue', value: 'en-US', block: false },
                                        { kind: 'StringValue', value: 'en-AU', block: false },
                                        { kind: 'StringValue', value: 'en-GB', block: false },
                                        { kind: 'StringValue', value: 'en-SG', block: false },
                                        { kind: 'StringValue', value: 'sv-SE', block: false },
                                        { kind: 'StringValue', value: 'de-DE', block: false },
                                        { kind: 'StringValue', value: 'fr-FR', block: false },
                                        { kind: 'StringValue', value: 'es-ES', block: false },
                                        { kind: 'StringValue', value: 'es-MX', block: false },
                                        { kind: 'StringValue', value: 'it-IT', block: false },
                                        { kind: 'StringValue', value: 'nl-NL', block: false },
                                        { kind: 'StringValue', value: 'nb-NO', block: false },
                                        { kind: 'StringValue', value: 'da-DK', block: false },
                                        { kind: 'StringValue', value: 'de-DE', block: false },
                                        { kind: 'StringValue', value: 'de-AT', block: false }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'showcaseCollection' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'locale' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                                        }
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AlgoliaBlogPostsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AlgoliaBlogPosts' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '100' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                    }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blogPostCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AlgoliaBlogPost' } }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AlgoliaBlogPost' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatar' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoriesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tagsCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AlgoliaBlogPostByIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AlgoliaBlogPostById' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'postID' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                    },
                    defaultValue: { kind: 'StringValue', value: 'en-US', block: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blogPost' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'postID' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AlgoliaBlogPost' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AlgoliaBlogPost' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'canonicalUrl' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatar' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoriesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'body' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tagsCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AlgoliaMarketplaceAppsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AlgoliaMarketplaceApps' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '15' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    defaultValue: { kind: 'StringValue', value: 'en-US', block: false }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppFilter' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceAppCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'AlgoliaMarketplaceApp' }
                                            }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AlgoliaMarketplaceApp' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceApp' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'algoliaKeywords' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'logoIcon' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reviewCount' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'abstract' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'unifiedBilling' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'freeTrial' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'freeTrialDays' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'upfrontPrice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'monthlyPrice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pricing' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pricingType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appTier' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'logo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'appRegistryUpdatedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'multiStorefront' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'multiLocation' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appFeaturesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'description' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'similarApps' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'featuredOrder' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'appRegistryId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appFeaturesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoriesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parentCategory' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'contentfulMetadata' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'tags' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'collectionsCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        }
    ]
};
exports.AlgoliaMarketplaceAppByIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AlgoliaMarketplaceAppById' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'appID' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                    },
                    defaultValue: { kind: 'StringValue', value: 'en-US', block: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceApp' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'appID' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AlgoliaMarketplaceApp' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AlgoliaMarketplaceApp' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceApp' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'algoliaKeywords' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'logoIcon' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reviewCount' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'abstract' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'unifiedBilling' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'freeTrial' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'freeTrialDays' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'upfrontPrice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'monthlyPrice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pricing' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pricingType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appTier' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'logo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'appRegistryUpdatedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'multiStorefront' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'multiLocation' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appFeaturesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'description' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'similarApps' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'featuredOrder' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'appRegistryId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appFeaturesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoriesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parentCategory' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'contentfulMetadata' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'tags' },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'collectionsCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        }
    ]
};
exports.AlgoliaMarketplaceThemesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AlgoliaMarketplaceThemes' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '100' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    defaultValue: { kind: 'StringValue', value: 'en-US', block: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceThemeCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'AlgoliaMarketplaceTheme' }
                                            }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AlgoliaMarketplaceTheme' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceTheme' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'partnerName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'featuredOrder' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'partnerEmail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contactUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'demoUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'registryId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'versionId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'largePreview' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'largeThumbnail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'smallThumbnail' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'themeIndustriesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'mobilePreview' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'themeFeatures' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'themeOptimizations' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'themeCollections' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'documentationUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'related' } }
                ]
            }
        }
    ]
};
exports.AlgoliaMarketplaceThemeByIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AlgoliaMarketplaceThemeById' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'themeID' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                    },
                    defaultValue: { kind: 'StringValue', value: 'en-US', block: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceTheme' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'themeID' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AlgoliaMarketplaceTheme' } }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AlgoliaMarketplaceTheme' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceTheme' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'partnerName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'featuredOrder' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'publishedDate' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'partnerEmail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contactUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'demoUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'registryId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'versionId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'largePreview' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'largeThumbnail' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'smallThumbnail' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'themeIndustriesCollection' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }]
                                    }
                                }
                            ]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'mobilePreview' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'themeFeatures' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'themeOptimizations' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'themeCollections' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'documentationUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'related' } }
                ]
            }
        }
    ]
};
exports.BlogPostPathsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'BlogPostPaths' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPostFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '10' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blogPostCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.BlogContentForPdfDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'BlogContentForPDF' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'postID' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                    },
                    defaultValue: { kind: 'StringValue', value: 'en-US', block: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blogPost' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'postID' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'featuredImage' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'body' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostBodyLinks' } }
                                        ]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gatedContentSettings' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'where' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'providePrintVersion' },
                                                        value: { kind: 'BooleanValue', value: true }
                                                    }
                                                ]
                                            }
                                        }
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostAsset' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Asset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contentType' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RichTextCallout' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RichTextWrapper' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'json' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostAssetExternal' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetExternal' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'assetType' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'internalName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'altText' } }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostBodyLinks' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPostBody' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assets' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'BlogPostAsset' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entries' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'block' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'RichTextCallout' }
                                                        },
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'BlogPostAssetExternal' }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.RobotsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Robots' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'RobotsFilter' } },
                    defaultValue: {
                        kind: 'ObjectValue',
                        fields: [
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'robots_exists' },
                                value: { kind: 'BooleanValue', value: true }
                            }
                        ]
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'robotsCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'robots' } }]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AppCollectionSitemapDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AppCollectionSitemap' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCollectionFilter' } },
                    defaultValue: {
                        kind: 'ObjectValue',
                        fields: [
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'slug_exists' },
                                value: { kind: 'BooleanValue', value: true }
                            }
                        ]
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1000' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appCollectionCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'AppCollectionSitemap' }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppCollectionSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCollection' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.AppsSitemapDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AppsSitemap' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceAppFilter' } },
                    defaultValue: {
                        kind: 'ObjectValue',
                        fields: [
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'slug_exists' },
                                value: { kind: 'BooleanValue', value: true }
                            }
                        ]
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1000' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceAppCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppSitemap' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AppSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceApp' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ArticlesSitemapDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ArticlesSitemap' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticleFilter' } },
                    defaultValue: {
                        kind: 'ObjectValue',
                        fields: [
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'slug_exists' },
                                value: { kind: 'BooleanValue', value: true }
                            },
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editStatus' },
                                value: { kind: 'StringValue', value: '🟢 live', block: false }
                            }
                        ]
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1000' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'articleCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleSitemap' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentArticle' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.BlogPostAuthorsSitemapDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'BlogPostAuthorsSitemap' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'PersonFilter' } },
                    defaultValue: {
                        kind: 'ObjectValue',
                        fields: [
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'slug_exists' },
                                value: { kind: 'BooleanValue', value: true }
                            }
                        ]
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '100' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'personCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostAuthors' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostAuthors' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkedFrom' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'blogPostCollection' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.BlogPostCategoriesSitemapDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'BlogPostCategoriesSitemap' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'CategoryFilter' } },
                    defaultValue: {
                        kind: 'ObjectValue',
                        fields: [
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'slug_exists' },
                                value: { kind: 'BooleanValue', value: true }
                            }
                        ]
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '100' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoryCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'BlogPostCategoriesSitemap' }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostCategoriesSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkedFrom' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'blogPostCollection' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.BlogPostsSitemapDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'BlogPostsSitemap' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPostFilter' } },
                    defaultValue: {
                        kind: 'ObjectValue',
                        fields: [
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'slug_exists' },
                                value: { kind: 'BooleanValue', value: true }
                            }
                        ]
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1000' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blogPostCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlogPostSitemap' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BlogPostSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPost' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.CaseStudySitemapDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'CaseStudySitemap' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudyFilter' } },
                    defaultValue: {
                        kind: 'ObjectValue',
                        fields: [
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'slug_exists' },
                                value: { kind: 'BooleanValue', value: true }
                            }
                        ]
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1000' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseStudyCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CaseStudySitemap' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CaseStudySitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseStudy' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.CategoriesSitemapDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'CategoriesSitemap' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'CategoryFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1000' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoryCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CategoriesSitemap' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CategoriesSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentCategory' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.GlossarySitemapDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GlossarySitemap' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'GlossaryFilter' } },
                    defaultValue: {
                        kind: 'ObjectValue',
                        fields: [
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'slug_exists' },
                                value: { kind: 'BooleanValue', value: true }
                            }
                        ]
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1000' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'glossaryCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GlossarySitemap' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GlossarySitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Glossary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.LeadersSitemapDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'LeadersSitemap' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'PersonFilter' } },
                    defaultValue: {
                        kind: 'ObjectValue',
                        fields: [
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'type' },
                                value: { kind: 'StringValue', value: 'Leader', block: false }
                            },
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'slug_exists' },
                                value: { kind: 'BooleanValue', value: true }
                            }
                        ]
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1000' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'personCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sys' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }
                                                    ]
                                                }
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'seoMetadata' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.PressSitemapDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'PressSitemap' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'PressFilter' } },
                    defaultValue: {
                        kind: 'ObjectValue',
                        fields: [
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'slug_exists' },
                                value: { kind: 'BooleanValue', value: true }
                            },
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'type_in' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        { kind: 'StringValue', value: 'Press Release', block: false },
                                        { kind: 'StringValue', value: 'News / Press Release', block: false }
                                    ]
                                }
                            },
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'enabled' },
                                value: { kind: 'BooleanValue', value: true }
                            }
                        ]
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1000' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pressCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PressSitemap' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PressSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Press' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ResourcesSitemapDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ResourcesSitemap' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResourceFilter' } },
                    defaultValue: {
                        kind: 'ObjectValue',
                        fields: [
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'slug_exists' },
                                value: { kind: 'BooleanValue', value: true }
                            },
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'status' },
                                value: { kind: 'BooleanValue', value: true }
                            }
                        ]
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1000' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourcesSitemap' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ResourcesSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.RootSitemapDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'RootSitemap' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pressCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'slug_exists' },
                                            value: { kind: 'BooleanValue', value: true }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'articleCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'slug_exists' },
                                            value: { kind: 'BooleanValue', value: true }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'leaders' },
                        name: { kind: 'Name', value: 'personCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'type' },
                                            value: { kind: 'StringValue', value: 'Leader', block: false }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'showcaseCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'slug_exists' },
                                            value: { kind: 'BooleanValue', value: true }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceAppCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'slug_exists' },
                                            value: { kind: 'BooleanValue', value: true }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceThemeCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'slug_exists' },
                                            value: { kind: 'BooleanValue', value: true }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'themePropertyCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'type' },
                                            value: { kind: 'StringValue', value: 'industry', block: false }
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'slug_exists' },
                                            value: { kind: 'BooleanValue', value: true }
                                        }
                                    ]
                                }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '1000' }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                        }
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appCollectionCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ThemeIndustriesSitemapDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ThemeIndustriesSitemap' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ThemePropertyFilter' } },
                    defaultValue: {
                        kind: 'ObjectValue',
                        fields: [
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'type' },
                                value: { kind: 'StringValue', value: 'industry', block: false }
                            },
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'slug_exists' },
                                value: { kind: 'BooleanValue', value: true }
                            },
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'slug_not' },
                                value: { kind: 'StringValue', value: 'theme-store', block: false }
                            }
                        ]
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1000' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'themePropertyCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ThemeIndustry' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ThemeIndustry' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ThemeProperty' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ThemesSitemapDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ThemesSitemap' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceThemeFilter' } },
                    defaultValue: {
                        kind: 'ObjectValue',
                        fields: [
                            {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'slug_exists' },
                                value: { kind: 'BooleanValue', value: true }
                            }
                        ]
                    }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1000' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketplaceThemeCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'skip' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ThemeSitemap' } }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ThemeSitemap' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MarketplaceTheme' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sys' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } }]
                        }
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seoMetadata' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'noindex' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'nofollow' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.BlogPostPreviewDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'BlogPostPreview' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlogPostFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '10' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: false }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blogPostCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'us' },
                                                name: { kind: 'Name', value: 'slug' },
                                                arguments: [
                                                    {
                                                        kind: 'Argument',
                                                        name: { kind: 'Name', value: 'locale' },
                                                        value: { kind: 'StringValue', value: 'en-US', block: false }
                                                    }
                                                ]
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'gb' },
                                                name: { kind: 'Name', value: 'slug' },
                                                arguments: [
                                                    {
                                                        kind: 'Argument',
                                                        name: { kind: 'Name', value: 'locale' },
                                                        value: { kind: 'StringValue', value: 'en-GB', block: false }
                                                    }
                                                ]
                                            },
                                            {
                                                kind: 'Field',
                                                alias: { kind: 'Name', value: 'au' },
                                                name: { kind: 'Name', value: 'slug' },
                                                arguments: [
                                                    {
                                                        kind: 'Argument',
                                                        name: { kind: 'Name', value: 'locale' },
                                                        value: { kind: 'StringValue', value: 'en-AU', block: false }
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
exports.ArticlePreviewDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ArticlePreview' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticleFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '1' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    defaultValue: { kind: 'BooleanValue', value: true }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'articleCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'preview' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'preview' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleSlug' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parentArticle' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleSlug' } }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ArticleSlug' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'en_US' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-US', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'en_GB' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-GB', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'en_AU' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'en-AU', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'de_AT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-AT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'nb_NO' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nb-NO', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'da_DK' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'da-DK', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'sv_SE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'sv-SE', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'fr_FR' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'fr-FR', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'it_IT' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'it-IT', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'es_ES' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-ES', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'es_MX' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'es-MX', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'nl_NL' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'nl-NL', block: false }
                            }
                        ]
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'de_DE' },
                        name: { kind: 'Name', value: 'slug' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'StringValue', value: 'de-DE', block: false }
                            }
                        ]
                    }
                ]
            }
        }
    ]
};
exports.RedirectsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Redirects' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'RedirectFilter' } }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '100' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    defaultValue: { kind: 'IntValue', value: '0' }
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
                }
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'redirectCollection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'skip' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } }
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } }
                            }
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'sourceUrl' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'destinationUrl' } }
                                        ]
                                    }
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'total' } }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
